// tslint:disable
/**
 * API SAGA Publique
 * Agregat de l\'adherent particulier et de des adhesions
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface AdherentId
 */
export interface AdherentId {
    /**
     *
     * @type {number}
     * @memberof AdherentId
     */
    adherentParticulierId: number;
}
/**
 *
 * @export
 * @interface AdherentParticulier
 */
export interface AdherentParticulier {
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    nom?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    nomNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    prenom?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    telephone?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    telephone2?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    dateNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    lieuNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    deptNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    numeroPermis?: string;
    /**
     *
     * @type {number}
     * @memberof AdherentParticulier
     */
    nbVehiculesFoyer?: number;
    /**
     *
     * @type {Adresse}
     * @memberof AdherentParticulier
     */
    adresse?: Adresse;
    /**
     * Identifiant de l\'adherent particulier
     * @type {number}
     * @memberof AdherentParticulier
     */
    adherentParticulierId?: number;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulier
     */
    profession?: string;
    /**
     * Titre de l\'adherent. Valeur possible par /referentiel/titre
     * @type {string}
     * @memberof AdherentParticulier
     */
    titre?: string;
}
/**
 * Resultat d\'une recherche d\'adherent particulier
 * @export
 * @interface AdherentParticulierAdhesionDetails
 */
export interface AdherentParticulierAdhesionDetails {
    /**
     *
     * @type {Array<AdhesionRechercheDetails>}
     * @memberof AdherentParticulierAdhesionDetails
     */
    listAdhesion?: Array<AdhesionRechercheDetails>;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    nom?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    nomNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    prenom?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    telephone?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    telephone2?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    dateNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    lieuNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    deptNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    numeroPermis?: string;
    /**
     *
     * @type {number}
     * @memberof AdherentParticulierAdhesionDetails
     */
    nbVehiculesFoyer?: number;
    /**
     *
     * @type {Adresse}
     * @memberof AdherentParticulierAdhesionDetails
     */
    adresse?: Adresse;
    /**
     * Identifiant de l\'adherent particulier
     * @type {number}
     * @memberof AdherentParticulierAdhesionDetails
     */
    adherentParticulierId?: number;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    profession?: string;
    /**
     * Titre de l\'adherent. Valeur possible par /referentiel/titre
     * @type {string}
     * @memberof AdherentParticulierAdhesionDetails
     */
    titre?: string;
}
/**
 *
 * @export
 * @interface AdherentParticulierAdhesionDetailsAllOf
 */
export interface AdherentParticulierAdhesionDetailsAllOf {
    /**
     *
     * @type {Array<AdhesionRechercheDetails>}
     * @memberof AdherentParticulierAdhesionDetailsAllOf
     */
    listAdhesion?: Array<AdhesionRechercheDetails>;
}
/**
 * Resultat d\'une recherche d\'adherent particulier
 * @export
 * @interface AdherentParticulierRecherche
 */
export interface AdherentParticulierRecherche {
    /**
     * Nom du particulier
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    nom?: string;
    /**
     * Prenom du particulier
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    prenom?: string;
    /**
     * Identifiant de l\'adherent particulier
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    adherentParticulierId?: string;
    /**
     * Numero du compte de fidelite du particulier
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    numeroFidelite?: string;
    /**
     * Identifiant du client ayant realise la vente de l\'adhesion
     * @type {number}
     * @memberof AdherentParticulierRecherche
     */
    clientId: number;
    /**
     * Nom du client ayant realise la vente de l\'adhesion
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    clientNom: string;
    /**
     * Etat en cours de l\'adhesion
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    etatAdhesion?: AdherentParticulierRechercheEtatAdhesionEnum;
    /**
     * Liste des adhesions du particulier
     * @type {Array<AdhesionRecherche>}
     * @memberof AdherentParticulierRecherche
     */
    listeAdhesion?: Array<AdhesionRecherche>;
    /**
     * Date de derniere modification d\'une adhesion du particulier
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    dateEnregistrement?: string;
    /**
     * date d\'effet
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    dateEffet?: string;
    /**
     * date d\'echeance
     * @type {string}
     * @memberof AdherentParticulierRecherche
     */
    dateEcheance?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum AdherentParticulierRechercheEtatAdhesionEnum {
    ATTENTEVALIDATION = 'ATTENTE_VALIDATION',
    ATTENTERECEPTION = 'ATTENTE_RECEPTION',
    VALIDER = 'VALIDER',
    VALIDERELECTRO = 'VALIDER_ELECTRO',
    ANNULEE = 'ANNULEE',
    FERMEE = 'FERMEE',
    INCOMPLET = 'INCOMPLET',
    ATTENTESIGNATURE = 'ATTENTE_SIGNATURE',
}

/**
 * AdherentParticulierResponseResource
 * @export
 * @interface AdherentParticulierResponse
 */
export interface AdherentParticulierResponse {
    /**
     *
     * @type {Array<AdhesionAdherentParticulierResponse>}
     * @memberof AdherentParticulierResponse
     */
    listAdhesion?: Array<AdhesionAdherentParticulierResponse>;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    nom?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    nomNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    prenom?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    telephone?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    telephone2?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    dateNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    lieuNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    deptNaissance?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    numeroPermis?: string;
    /**
     *
     * @type {number}
     * @memberof AdherentParticulierResponse
     */
    nbVehiculesFoyer?: number;
    /**
     *
     * @type {Adresse}
     * @memberof AdherentParticulierResponse
     */
    adresse?: Adresse;
    /**
     * Identifiant de l\'adherent particulier
     * @type {number}
     * @memberof AdherentParticulierResponse
     */
    adherentParticulierId?: number;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    profession?: string;
    /**
     * Titre de l\'adherent. Valeur possible par /referentiel/titre
     * @type {string}
     * @memberof AdherentParticulierResponse
     */
    titre?: string;
}
/**
 *
 * @export
 * @interface AdherentParticulierResponseAllOf
 */
export interface AdherentParticulierResponseAllOf {
    /**
     *
     * @type {Array<AdhesionAdherentParticulierResponse>}
     * @memberof AdherentParticulierResponseAllOf
     */
    listAdhesion?: Array<AdhesionAdherentParticulierResponse>;
}
/**
 * Represente une version simplifiee de l\'adherent particulier
 * @export
 * @interface AdherentParticulierSimple
 */
export interface AdherentParticulierSimple {
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierSimple
     */
    nom?: string;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierSimple
     */
    prenom?: string;
    /**
     * Identifiant de l\'adherent particulier
     * @type {number}
     * @memberof AdherentParticulierSimple
     */
    adherentParticulierId?: number;
    /**
     *
     * @type {string}
     * @memberof AdherentParticulierSimple
     */
    codePostal?: string;
}
/**
 * Represente une adhesion en lecture/modification
 * @export
 * @interface Adhesion
 */
export interface Adhesion {
    /**
     * Numero de l\'adhesion
     * @type {string}
     * @memberof Adhesion
     */
    numeroAdhesion?: string;
    /**
     *
     * @type {number}
     * @memberof Adhesion
     */
    clientId?: number;
    /**
     * code commercial du programme
     * @type {string}
     * @memberof Adhesion
     */
    codeProgramme?: string;
    /**
     * L\'autorisation de la cnil
     * @type {boolean}
     * @memberof Adhesion
     */
    autorisationCnil?: boolean;
    /**
     *
     * @type {string}
     * @memberof Adhesion
     */
    dateSaisie?: string;
    /**
     *
     * @type {AdherentParticulier}
     * @memberof Adhesion
     */
    adherentParticulier?: AdherentParticulier;
    /**
     * Date d\'effet de l\'adhesion
     * @type {string}
     * @memberof Adhesion
     */
    dateEffet?: string;
    /**
     *
     * @type {string}
     * @memberof Adhesion
     */
    lieuSaisie?: string;
    /**
     *
     * @type {Mandat}
     * @memberof Adhesion
     */
    mandat?: Mandat;
    /**
     *
     * @type {Assurance}
     * @memberof Adhesion
     */
    assurance?: Assurance;
    /**
     *
     * @type {string}
     * @memberof Adhesion
     */
    numeroOriasAdherent?: string;
    /**
     *
     * @type {ObjetRisque}
     * @memberof Adhesion
     */
    objetRisque: ObjetRisque;
    /**
     *
     * @type {string}
     * @memberof Adhesion
     */
    etatAdhesion: AdhesionEtatAdhesionEnum;
    /**
     * Login de l\'utilisateur ayant realise la vente
     * @type {string}
     * @memberof Adhesion
     */
    vendeur?: string;
    /**
     * Identifiant de la ressource client souscripteur
     * @type {number}
     * @memberof Adhesion
     */
    souscripteurId: number;
    /**
     * Date de réception du bulletin d\'adhésion
     * @type {string}
     * @memberof Adhesion
     */
    dateReceptionBulletinAdhesion?: string;
    /**
     * nom du vendeur
     * @type {string}
     * @memberof Adhesion
     */
    nomVendeur?: string;
    /**
     * prénom du vendeur
     * @type {string}
     * @memberof Adhesion
     */
    prenomVendeur?: string;
    /**
     * nom du site vendeur
     * @type {string}
     * @memberof Adhesion
     */
    nomClient?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum AdhesionEtatAdhesionEnum {
    ATTENTEVALIDATION = 'ATTENTE_VALIDATION',
    ATTENTERECEPTION = 'ATTENTE_RECEPTION',
    VALIDER = 'VALIDER',
    VALIDERELECTRO = 'VALIDER_ELECTRO',
    ANNULEE = 'ANNULEE',
    FERMEE = 'FERMEE',
    INCOMPLET = 'INCOMPLET',
    ATTENTESIGNATURE = 'ATTENTE_SIGNATURE',
}

/**
 *
 * @export
 * @interface AdhesionAdherentParticulierResponse
 */
export interface AdhesionAdherentParticulierResponse {
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    numeroAdhesion: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    codeProgramme?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    immatriculation?: string;
    /**
     *
     * @type {MarqueVehicule}
     * @memberof AdhesionAdherentParticulierResponse
     */
    marque?: MarqueVehicule;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    numeroSerie?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    modele?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    dateSaisie?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    dateEffet?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    dateEcheance?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    numeroFidelite?: string;
    /**
     *
     * @type {number}
     * @memberof AdhesionAdherentParticulierResponse
     */
    referenceModeleCarte?: number;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    idClient?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionAdherentParticulierResponse
     */
    nomClient?: string;
    /**
     *
     * @type {boolean}
     * @memberof AdhesionAdherentParticulierResponse
     */
    editionDateFin?: boolean;
    /**
     *
     * @type {Mandat}
     * @memberof AdhesionAdherentParticulierResponse
     */
    mandat?: Mandat;
    /**
     *
     * @type {boolean}
     * @memberof AdhesionAdherentParticulierResponse
     */
    remorquageDepannage?: boolean;
    /**
     * adhesion qui fait de la fid ou pas
     * @type {boolean}
     * @memberof AdhesionAdherentParticulierResponse
     */
    hasFidelisation: boolean;
}
/**
 * Represente une adhesion en lecture/modification
 * @export
 * @interface AdhesionIn
 */
export interface AdhesionIn {
    /**
     *
     * @type {number}
     * @memberof AdhesionIn
     */
    clientId: number;
    /**
     * code commercial du programme
     * @type {string}
     * @memberof AdhesionIn
     */
    codeProgramme: string;
    /**
     * L\'autorisation de la cnil
     * @type {boolean}
     * @memberof AdhesionIn
     */
    autorisationCnil?: boolean;
    /**
     *
     * @type {string}
     * @memberof AdhesionIn
     */
    dateSaisie?: string;
    /**
     *
     * @type {AdherentParticulier}
     * @memberof AdhesionIn
     */
    adherentParticulier?: AdherentParticulier;
    /**
     * Date d\'effet de l\'adhesion
     * @type {string}
     * @memberof AdhesionIn
     */
    dateEffet: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionIn
     */
    lieuSaisie?: string;
    /**
     *
     * @type {Mandat}
     * @memberof AdhesionIn
     */
    mandat?: Mandat;
    /**
     *
     * @type {Assurance}
     * @memberof AdhesionIn
     */
    assurance?: Assurance;
    /**
     *
     * @type {string}
     * @memberof AdhesionIn
     */
    numeroOriasAdherent?: string;
    /**
     *
     * @type {ObjetRisque}
     * @memberof AdhesionIn
     */
    objetRisque?: ObjetRisque;
    /**
     * Login de l\'utilisateur ayant realise la vente
     * @type {string}
     * @memberof AdhesionIn
     */
    vendeur: string;
    /**
     * Numero d\'adhesion temporaire
     * @type {string}
     * @memberof AdhesionIn
     */
    numeroAdhesion?: string;
    /**
     *
     * @type {number}
     * @memberof AdhesionIn
     */
    souscripteurId?: number;
}
/**
 * Represente une adhesion en lecture/modification
 * @export
 * @interface AdhesionRecherche
 */
export interface AdhesionRecherche {
    /**
     *
     * @type {Programme}
     * @memberof AdhesionRecherche
     */
    programme?: Programme;
    /**
     * Numero de l\'adhesion
     * @type {string}
     * @memberof AdhesionRecherche
     */
    numeroAdhesion: string;
    /**
     * code commercial du programme
     * @type {string}
     * @memberof AdhesionRecherche
     */
    codeProgramme?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRecherche
     */
    immatriculation?: string;
    /**
     *
     * @type {MarqueVehicule}
     * @memberof AdhesionRecherche
     */
    marque?: MarqueVehicule;
    /**
     *
     * @type {Categorie}
     * @memberof AdhesionRecherche
     */
    categorie?: Categorie;
    /**
     *
     * @type {string}
     * @memberof AdhesionRecherche
     */
    numeroSerie?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRecherche
     */
    modele?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRecherche
     */
    etatAdhesion: AdhesionRechercheEtatAdhesionEnum;
    /**
     *
     * @type {boolean}
     * @memberof AdhesionRecherche
     */
    sansVehicule?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum AdhesionRechercheEtatAdhesionEnum {
    ATTENTEVALIDATION = 'ATTENTE_VALIDATION',
    ATTENTERECEPTION = 'ATTENTE_RECEPTION',
    VALIDER = 'VALIDER',
    VALIDERELECTRO = 'VALIDER_ELECTRO',
    ANNULEE = 'ANNULEE',
    FERMEE = 'FERMEE',
    INCOMPLET = 'INCOMPLET',
    ATTENTESIGNATURE = 'ATTENTE_SIGNATURE',
}

/**
 *
 * @export
 * @interface AdhesionRechercheDetails
 */
export interface AdhesionRechercheDetails {
    /**
     *
     * @type {Produit}
     * @memberof AdhesionRechercheDetails
     */
    produit: Produit;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    dateSaisie?: string;
    /**
     * Date d\'effet de l\'adhesion
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    dateEffet?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    dateEcheance?: string;
    /**
     * Date immatriculation
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    dateImmatriculation?: string;
    /**
     * Date pemiere mise en circulation
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    datePremiereMiseEnCir?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    dateImmatriculationPrecedente?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    immatriculationPrecedente?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    type?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    genre?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    nomClient?: string;
    /**
     *
     * @type {number}
     * @memberof AdhesionRechercheDetails
     */
    idClient?: number;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    numeroFidelite?: string;
    /**
     *
     * @type {boolean}
     * @memberof AdhesionRechercheDetails
     */
    cartePhysique?: boolean;
    /**
     *
     * @type {number}
     * @memberof AdhesionRechercheDetails
     */
    referenceModeleCarte?: number;
    /**
     *
     * @type {boolean}
     * @memberof AdhesionRechercheDetails
     */
    presenceMandat?: boolean;
    /**
     *
     * @type {Programme}
     * @memberof AdhesionRechercheDetails
     */
    programme?: Programme;
    /**
     * Numero de l\'adhesion
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    numeroAdhesion: string;
    /**
     * code commercial du programme
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    codeProgramme?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    immatriculation?: string;
    /**
     *
     * @type {MarqueVehicule}
     * @memberof AdhesionRechercheDetails
     */
    marque?: MarqueVehicule;
    /**
     *
     * @type {Categorie}
     * @memberof AdhesionRechercheDetails
     */
    categorie?: Categorie;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    numeroSerie?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    modele?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetails
     */
    etatAdhesion: AdhesionRechercheDetailsEtatAdhesionEnum;
    /**
     *
     * @type {boolean}
     * @memberof AdhesionRechercheDetails
     */
    sansVehicule?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum AdhesionRechercheDetailsEtatAdhesionEnum {
    ATTENTEVALIDATION = 'ATTENTE_VALIDATION',
    ATTENTERECEPTION = 'ATTENTE_RECEPTION',
    VALIDER = 'VALIDER',
    VALIDERELECTRO = 'VALIDER_ELECTRO',
    ANNULEE = 'ANNULEE',
    FERMEE = 'FERMEE',
    INCOMPLET = 'INCOMPLET',
    ATTENTESIGNATURE = 'ATTENTE_SIGNATURE',
}

/**
 *
 * @export
 * @interface AdhesionRechercheDetailsAllOf
 */
export interface AdhesionRechercheDetailsAllOf {
    /**
     *
     * @type {Produit}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    produit: Produit;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    dateSaisie?: string;
    /**
     * Date d\'effet de l\'adhesion
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    dateEffet?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    dateEcheance?: string;
    /**
     * Date immatriculation
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    dateImmatriculation?: string;
    /**
     * Date pemiere mise en circulation
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    datePremiereMiseEnCir?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    dateImmatriculationPrecedente?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    immatriculationPrecedente?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    type?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    genre?: string;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    nomClient?: string;
    /**
     *
     * @type {number}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    idClient?: number;
    /**
     *
     * @type {string}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    numeroFidelite?: string;
    /**
     *
     * @type {boolean}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    cartePhysique?: boolean;
    /**
     *
     * @type {number}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    referenceModeleCarte?: number;
    /**
     *
     * @type {boolean}
     * @memberof AdhesionRechercheDetailsAllOf
     */
    presenceMandat?: boolean;
}
/**
 *
 * @export
 * @interface Adresse
 */
export interface Adresse {
    /**
     *
     * @type {string}
     * @memberof Adresse
     */
    adresse1?: string;
    /**
     *
     * @type {string}
     * @memberof Adresse
     */
    adresse2?: string;
    /**
     *
     * @type {string}
     * @memberof Adresse
     */
    adresse3?: string;
    /**
     *
     * @type {string}
     * @memberof Adresse
     */
    codePostal?: string;
    /**
     *
     * @type {string}
     * @memberof Adresse
     */
    ville?: string;
    /**
     * Reference du pays issue de /referentiel/pays
     * @type {number}
     * @memberof Adresse
     */
    pays?: number;
}
/**
 * info de contact d\'un assisteur
 * @export
 * @interface Assisteur
 */
export interface Assisteur {
    /**
     * telephone de l\'assisteur
     * @type {string}
     * @memberof Assisteur
     */
    telephone?: string;
    /**
     * nom de la compagnie
     * @type {string}
     * @memberof Assisteur
     */
    nom: string;
    /**
     * info permettant de savoir si l\'assisteur permet les depannages en ligne
     * @type {boolean}
     * @memberof Assisteur
     */
    depannageEnLigne: boolean;
}
/**
 * Assurance
 * @export
 * @interface Assurance
 */
export interface Assurance {
    /**
     *
     * @type {string}
     * @memberof Assurance
     */
    nomCompagnie?: string;
    /**
     *
     * @type {string}
     * @memberof Assurance
     */
    police?: string;
    /**
     *
     * @type {string}
     * @memberof Assurance
     */
    compagnieGTA?: string;
}
/**
 * Categorie du vehicule
 * @export
 * @interface Categorie
 */
export interface Categorie {
    /**
     * VN VO VU
     * @type {string}
     * @memberof Categorie
     */
    code?: string;
    /**
     *
     * @type {string}
     * @memberof Categorie
     */
    libelleAbrege?: string;
    /**
     *
     * @type {string}
     * @memberof Categorie
     */
    abregeCategorie?: string;
}
/**
 *
 * @export
 * @interface Client
 */
export interface Client {
    /**
     * Nom du client
     * @type {string}
     * @memberof Client
     */
    nom?: string;
    /**
     * Nom court du client
     * @type {string}
     * @memberof Client
     */
    nomAbrege?: string;
    /**
     *
     * @type {Adresse}
     * @memberof Client
     */
    adresse?: Adresse;
    /**
     *
     * @type {Adresse}
     * @memberof Client
     */
    adressePreparateur?: Adresse;
    /**
     * Identifiant de la ressource client
     * @type {number}
     * @memberof Client
     */
    clientId?: number;
    /**
     * Identifiant du client jouant le role de grand client
     * @type {number}
     * @memberof Client
     */
    grandClientId?: number;
}
/**
 * Liste des clients avec l\'info rôle
 * @export
 * @interface ClientAdministration
 */
export interface ClientAdministration {
    /**
     *
     * @type {string}
     * @memberof ClientAdministration
     */
    nom?: string;
    /**
     *
     * @type {number}
     * @memberof ClientAdministration
     */
    clientId: number;
    /**
     * grandClient ou souscripteur ou adherent en fonction du role du client dans son organisation contractuel
     * @type {string}
     * @memberof ClientAdministration
     */
    role?: string;
    /**
     * SI le client a une convention valide a la date du jour OU une convention d\'adhesion valide à la date du jour OU un rôle Grand client ALORS actif SINON resilie
     * @type {string}
     * @memberof ClientAdministration
     */
    statutContrat?: string;
}
/**
 *
 * @export
 * @interface ClientInfo
 */
export interface ClientInfo {
    /**
     * identifiant client
     * @type {number}
     * @memberof ClientInfo
     */
    identifiant: number;
    /**
     * nom du client
     * @type {string}
     * @memberof ClientInfo
     */
    nomClient?: string;
    /**
     * grandClient ou souscripteur ou adherent en fonction du role du client dans son organisation contractuel
     * @type {string}
     * @memberof ClientInfo
     */
    role?: string;
    /**
     * SI le client a une convention valide a la date du jour OU une convention d\'adhesion valide à la date du jour OU un rôle Grand client ALORS actif SINON resilie
     * @type {string}
     * @memberof ClientInfo
     */
    statutContrat?: string;
}
/**
 * info compte particulier
 * @export
 * @interface CompteParticulier
 */
export interface CompteParticulier {
    /**
     *
     * @type {string}
     * @memberof CompteParticulier
     */
    nom?: string;
    /**
     *
     * @type {string}
     * @memberof CompteParticulier
     */
    prenom?: string;
    /**
     *
     * @type {string}
     * @memberof CompteParticulier
     */
    login?: string;
    /**
     * email du compte particulier
     * @type {string}
     * @memberof CompteParticulier
     */
    email: string;
    /**
     * liste des adherents particuliers du compte
     * @type {Array<ListeAdherentParticulier>}
     * @memberof CompteParticulier
     */
    listeAdherentParticulier?: Array<ListeAdherentParticulier>;
    /**
     *
     * @type {string}
     * @memberof CompteParticulier
     */
    dateCreation?: string;
}
/**
 * info compte particulier
 * @export
 * @interface CompteParticulierResponse
 */
export interface CompteParticulierResponse {
    /**
     *
     * @type {string}
     * @memberof CompteParticulierResponse
     */
    nom?: string;
    /**
     *
     * @type {string}
     * @memberof CompteParticulierResponse
     */
    prenom?: string;
    /**
     *
     * @type {string}
     * @memberof CompteParticulierResponse
     */
    login?: string;
    /**
     *
     * @type {Array<AdherentId>}
     * @memberof CompteParticulierResponse
     */
    listeAdherents: Array<AdherentId>;
}
/**
 * compte particulier
 * @export
 * @interface CreationCompte
 */
export interface CreationCompte {
    /**
     *
     * @type {number}
     * @memberof CreationCompte
     */
    numeroAdhesion: number;
    /**
     *
     * @type {string}
     * @memberof CreationCompte
     */
    email: string;
    /**
     *
     * @type {string}
     * @memberof CreationCompte
     */
    tokenCaptcha: string;
}
/**
 * Info d\'assistance pour le depannage en ligne
 * @export
 * @interface DemandeAssistance
 */
export interface DemandeAssistance {
    /**
     * immatriculation de l\'adhesion qui a besoin d\'assistance
     * @type {string}
     * @memberof DemandeAssistance
     */
    immatriculation: string;
    /**
     * nom du proprietaire
     * @type {string}
     * @memberof DemandeAssistance
     */
    nom: string;
    /**
     * telephone du proprietaire
     * @type {string}
     * @memberof DemandeAssistance
     */
    telephone: string;
    /**
     * prenom du proprietaire
     * @type {string}
     * @memberof DemandeAssistance
     */
    prenom: string;
}
/**
 * Formulaire de demande de contact
 * @export
 * @interface DemandeContact
 */
export interface DemandeContact {
    /**
     * Nom et prénom du demandeur
     * @type {string}
     * @memberof DemandeContact
     */
    nom: string;
    /**
     * Email du demandeur
     * @type {string}
     * @memberof DemandeContact
     */
    email: string;
    /**
     * Telephone du demandeur
     * @type {string}
     * @memberof DemandeContact
     */
    telephone: string;
    /**
     * Motif de la demande de contact
     * @type {string}
     * @memberof DemandeContact
     */
    motifDemande: DemandeContactMotifDemandeEnum;
    /**
     * Contenu du message
     * @type {string}
     * @memberof DemandeContact
     */
    message: string;
    /**
     * Immatriculation ou numero d\'adhesion
     * @type {string}
     * @memberof DemandeContact
     */
    immatriculation: string;
}

/**
 * @export
 * @enum {string}
 */
export enum DemandeContactMotifDemandeEnum {
    PRESTATIONS = 'PRESTATIONS',
    RENOUVELLEMENT = 'RENOUVELLEMENT',
    IMPAYE = 'IMPAYE',
    SINISTRE = 'SINISTRE',
    RESILIATIONOUVENTE = 'RESILIATION_OU_VENTE',
    PROBLEMEDECONNEXION = 'PROBLEME_DE_CONNEXION',
    AUTRE = 'AUTRE',
}

/**
 * donnees a envoyer pour detacher l\'adherent
 * @export
 * @interface DetacherAdherent
 */
export interface DetacherAdherent {
    /**
     * le nouvel email a ajouter au contrat detache
     * @type {string}
     * @memberof DetacherAdherent
     */
    nouvelEmail: string;
    /**
     * le numero de l\'adhesion a detacher du compte
     * @type {number}
     * @memberof DetacherAdherent
     */
    adherentParticulierId: number;
}
/**
 * Detail d\'une erreur HTTP remontee par l\'API
 * @export
 * @interface ErrorOut
 */
export interface ErrorOut {
    /**
     * Code Http de la reponse
     * @type {string}
     * @memberof ErrorOut
     */
    code?: string;
    /**
     * Nom du champ en entree qui cause l\'erreur
     * @type {string}
     * @memberof ErrorOut
     */
    element?: string;
    /**
     * Message permettant de comprende la cause de l\'erreur
     * @type {string}
     * @memberof ErrorOut
     */
    description?: string;
}
/**
 * Fichier binaire encode Base 64
 * @export
 * @interface Fichier
 */
export interface Fichier {
    /**
     * Nom du fichier
     * @type {string}
     * @memberof Fichier
     */
    nom?: string;
    /**
     * date de creation du fichier
     * @type {string}
     * @memberof Fichier
     */
    dateCreation?: string;
    /**
     * Type MIME du fichier
     * @type {string}
     * @memberof Fichier
     */
    typeMime?: string;
    /**
     * Contenu du fichier encode en base64
     * @type {string}
     * @memberof Fichier
     */
    content: string;
}
/**
 * Informations solde et transaction d\'une adhesion fidelisation
 * @export
 * @interface Fidelite
 */
export interface Fidelite {
    /**
     * montant restant sur la carte de fid
     * @type {number}
     * @memberof Fidelite
     */
    solde: number;
    /**
     * date d\'expiration de la transaction la plus recente
     * @type {string}
     * @memberof Fidelite
     */
    dateExpiration?: string;
    /**
     * liste des transactions
     * @type {Array<Transaction>}
     * @memberof Fidelite
     */
    listeTransaction?: Array<Transaction>;
    /**
     * numero de l\'adhesion rattachee
     * @type {string}
     * @memberof Fidelite
     */
    numeroAdhesion: string;
}
/**
 *
 * @export
 * @interface FondCarte
 */
export interface FondCarte {
    /**
     * image png encodee base 64
     * @type {string}
     * @memberof FondCarte
     */
    content?: string;
}
/**
 * Données du formulaire de paiement en ligne SystemPay
 * @export
 * @interface FormulaireDePaiement
 */
export interface FormulaireDePaiement {
    /**
     * url du prestataire pour le paiement
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    url?: string;
    /**
     * Identifiant de la boutique
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsSiteId?: string;
    /**
     * Mode de communication avec la plateforme de paiement
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsCtxMode?: FormulaireDePaiementVadsCtxModeEnum;
    /**
     * Numéro de la transaction
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsTransId?: string;
    /**
     * Date et heure du formulaire de paiement dans le fuseau horaire UTC
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsTransDate?: string;
    /**
     * Montant du paiement (dans sa plus petite unité monétaire)
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsAmount?: string;
    /**
     * Code numérique de la monnaie à utiliser pour le paiement, selon la norme ISO 4217 (code numérique)
     * @type {number}
     * @memberof FormulaireDePaiement
     */
    vadsCurrency?: number;
    /**
     * Mode d\'acquisition des données de la carte
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsActionMode?: FormulaireDePaiementVadsActionModeEnum;
    /**
     * Action à réaliser
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsPageAction?: FormulaireDePaiementVadsPageActionEnum;
    /**
     * Version du protocole d\'échange avec la plateforme de paiement
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsVersion?: FormulaireDePaiementVadsVersionEnum;
    /**
     * Type de paiement
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsPaymentConfig?: FormulaireDePaiementVadsPaymentConfigEnum;
    /**
     * Délai avant remise en banque
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsCaptureDelay?: string;
    /**
     * Mode de validation n1 0 (Automatique)
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsValidationMode?: string;
    /**
     * Information  complémentaire  facultative
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsContrib?: string;
    /**
     * Prénom de l\'acheteur
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsCustFirstName?: string;
    /**
     * Nom de l\'acheteur
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsCustLastName?: string;
    /**
     * Numéro de commande
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsOrderId?: string;
    /**
     * Signature du formulaire
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    signature?: string;
    /**
     * URL de la page à notifier à la fin du paiement
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsUrlCheck?: string;
    /**
     * Permet de spécifier le mode de transmission des données aux URLs de retour vers le site marchand.
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsReturnMode?: FormulaireDePaiementVadsReturnModeEnum;
    /**
     * URL où sera redirigé l\'acheteur  après appui sur \"annuler et retourner à la boutique\" avant d\'avoir procédé au paiement
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsUrlCancel?: string;
    /**
     * URL où sera redirigé l\'acheteur en cas d\'erreur de traitement par la plateforme de paiement
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsUrlError?: string;
    /**
     * URL où sera redirigé l\'acheteur, en cas de refus du paiement, après appui sur \"retourner à la boutique\"
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsUrlRefused?: string;
    /**
     * URL où sera redirigé l\'acheteur, en cas de succès du paiement, après appui sur \"retourner à la boutique\"
     * @type {string}
     * @memberof FormulaireDePaiement
     */
    vadsUrlSuccess?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum FormulaireDePaiementVadsCtxModeEnum {
    TEST = 'TEST',
    PRODUCTION = 'PRODUCTION',
}
/**
 * @export
 * @enum {string}
 */
export enum FormulaireDePaiementVadsActionModeEnum {
    INTERACTIVE = 'INTERACTIVE',
    SILENT = 'SILENT',
    IFRAME = 'IFRAME',
}
/**
 * @export
 * @enum {string}
 */
export enum FormulaireDePaiementVadsPageActionEnum {
    PAYMENT = 'PAYMENT',
    REGISTER = 'REGISTER',
    REGISTERUPDATE = 'REGISTER_UPDATE',
    REGISTERPAY = 'REGISTER_PAY',
    REGISTERSUBSCRIBE = 'REGISTER_SUBSCRIBE',
    REGISTERPAYSUBSCRIBE = 'REGISTER_PAY_SUBSCRIBE',
    SUBSCRIBE = 'SUBSCRIBE',
    REGISTERUPDATEPAY = 'REGISTER_UPDATE_PAY',
}
/**
 * @export
 * @enum {string}
 */
export enum FormulaireDePaiementVadsVersionEnum {
    V2 = 'V2',
}
/**
 * @export
 * @enum {string}
 */
export enum FormulaireDePaiementVadsPaymentConfigEnum {
    SINGLE = 'SINGLE',
}
/**
 * @export
 * @enum {string}
 */
export enum FormulaireDePaiementVadsReturnModeEnum {
    GET = 'GET',
    POST = 'POST',
}

/**
 * Represente une grarantie couverte par un produit d\'assurance
 * @export
 * @interface Garantie
 */
export interface Garantie {
    /**
     * identifiant fonctionnel de la garantie
     * @type {string}
     * @memberof Garantie
     */
    code?: string;
    /**
     * libelle de la garantie
     * @type {string}
     * @memberof Garantie
     */
    libelle?: string;
    /**
     * montant de la ganrantie
     * @type {number}
     * @memberof Garantie
     */
    montant?: number;
    /**
     * Unite dans lequel le montant de la garantie est exprimee: EUR JOUR HEURE NUIT
     * @type {string}
     * @memberof Garantie
     */
    unite?: string;
    /**
     * Type de la garantie: Assistance Remboursement
     * @type {string}
     * @memberof Garantie
     */
    type?: string;
}
/**
 * Genre du vehicule
 * @export
 * @interface GenreVehicule
 */
export interface GenreVehicule {
    /**
     *
     * @type {string}
     * @memberof GenreVehicule
     */
    libelle?: string;
    /**
     *
     * @type {string}
     * @memberof GenreVehicule
     */
    codeGenre?: string;
}
/**
 *
 * @export
 * @interface IbanBicResource
 */
export interface IbanBicResource {
    /**
     *
     * @type {string}
     * @memberof IbanBicResource
     */
    iban?: string;
    /**
     *
     * @type {string}
     * @memberof IbanBicResource
     */
    bic?: string;
}
/**
 *
 * @export
 * @interface Images
 */
export interface Images {
    /**
     *
     * @type {Fichier}
     * @memberof Images
     */
    logo: Fichier;
    /**
     *
     * @type {Fichier}
     * @memberof Images
     */
    icone64: Fichier;
    /**
     *
     * @type {Fichier}
     * @memberof Images
     */
    icone192: Fichier;
    /**
     *
     * @type {Fichier}
     * @memberof Images
     */
    icone512: Fichier;
    /**
     *
     * @type {Fichier}
     * @memberof Images
     */
    favicon: Fichier;
}
/**
 * Informations d\'un produit
 * @export
 * @interface InfosProduit
 */
export interface InfosProduit {
    /**
     *
     * @type {string}
     * @memberof InfosProduit
     */
    libelle?: string;
    /**
     *
     * @type {boolean}
     * @memberof InfosProduit
     */
    gravage?: boolean;
    /**
     *
     * @type {string}
     * @memberof InfosProduit
     */
    pdfConditionsGenerales?: string;
    /**
     *
     * @type {string}
     * @memberof InfosProduit
     */
    pdfAdhesion?: string;
    /**
     *
     * @type {string}
     * @memberof InfosProduit
     */
    dateDebutValidite?: string;
    /**
     *
     * @type {number}
     * @memberof InfosProduit
     */
    idPdfAssocie?: number;
}
/**
 *
 * @export
 * @interface ListeAdherentParticulier
 */
export interface ListeAdherentParticulier {
    /**
     *
     * @type {string}
     * @memberof ListeAdherentParticulier
     */
    nom: string;
    /**
     *
     * @type {string}
     * @memberof ListeAdherentParticulier
     */
    prenom?: string;
    /**
     *
     * @type {number}
     * @memberof ListeAdherentParticulier
     */
    adherentParticulierId: number;
    /**
     *
     * @type {Array<ListeAdhesion>}
     * @memberof ListeAdherentParticulier
     */
    listeAdhesion: Array<ListeAdhesion>;
}
/**
 *
 * @export
 * @interface ListeAdhesion
 */
export interface ListeAdhesion {
    /**
     *
     * @type {string}
     * @memberof ListeAdhesion
     */
    numeroAdhesion: string;
    /**
     *
     * @type {string}
     * @memberof ListeAdhesion
     */
    immatriculation?: string;
    /**
     *
     * @type {string}
     * @memberof ListeAdhesion
     */
    modele?: string;
    /**
     *
     * @type {string}
     * @memberof ListeAdhesion
     */
    marque?: string;
    /**
     *
     * @type {string}
     * @memberof ListeAdhesion
     */
    etatAdhesion: string;
}
/**
 *
 * @export
 * @interface ListeDocumentsProduit
 */
export interface ListeDocumentsProduit {
    /**
     * présence ou non du document adhesion
     * @type {boolean}
     * @memberof ListeDocumentsProduit
     */
    adhesion: boolean;
    /**
     * Id de la version
     * @type {number}
     * @memberof ListeDocumentsProduit
     */
    id: number;
    /**
     * date de début de validité de la version
     * @type {string}
     * @memberof ListeDocumentsProduit
     */
    dateDebut?: string;
    /**
     * présence ou non du document conditions générales
     * @type {boolean}
     * @memberof ListeDocumentsProduit
     */
    conditionsGenerales: boolean;
}
/**
 * Type generique d\'une liste d\'item supportant la pagination de donnee.
 * @export
 * @interface ListePage
 */
export interface ListePage {
    /**
     * Nombre total de lignes correspondant au critére de recherche
     * @type {number}
     * @memberof ListePage
     */
    nombreLigne: number;
    /**
     * Nombre de pages pour afficher tous les résultats
     * @type {number}
     * @memberof ListePage
     */
    nombrePage: number;
    /**
     * L\'index de la page (l\'index de la premiere page est 0)
     * @type {number}
     * @memberof ListePage
     */
    page: number;
    /**
     * Le nombre d\'éléments à retourner dans une page de donnees
     * @type {number}
     * @memberof ListePage
     */
    taille: number;
    /**
     * Format : attribut1:asc,attribut2:desc \\n Nom de l\'attribut egal au nom du champ envoye
     * @type {string}
     * @memberof ListePage
     */
    tri?: string;
}
/**
 * Stucture de donnee contenant une recherche paginee d\'adherent particulier
 * @export
 * @interface ListePageAdherentParticulierRecherche
 */
export interface ListePageAdherentParticulierRecherche {
    /**
     *
     * @type {Array<AdherentParticulierRecherche>}
     * @memberof ListePageAdherentParticulierRecherche
     */
    listeAdherent?: Array<AdherentParticulierRecherche>;
    /**
     * Nombre total de lignes correspondant au critére de recherche
     * @type {number}
     * @memberof ListePageAdherentParticulierRecherche
     */
    nombreLigne: number;
    /**
     * Nombre de pages pour afficher tous les résultats
     * @type {number}
     * @memberof ListePageAdherentParticulierRecherche
     */
    nombrePage: number;
    /**
     * L\'index de la page (l\'index de la premiere page est 0)
     * @type {number}
     * @memberof ListePageAdherentParticulierRecherche
     */
    page: number;
    /**
     * Le nombre d\'éléments à retourner dans une page de donnees
     * @type {number}
     * @memberof ListePageAdherentParticulierRecherche
     */
    taille: number;
    /**
     * Format : attribut1:asc,attribut2:desc \\n Nom de l\'attribut egal au nom du champ envoye
     * @type {string}
     * @memberof ListePageAdherentParticulierRecherche
     */
    tri?: string;
}
/**
 *
 * @export
 * @interface ListePageAdherentParticulierRechercheAllOf
 */
export interface ListePageAdherentParticulierRechercheAllOf {
    /**
     *
     * @type {Array<AdherentParticulierRecherche>}
     * @memberof ListePageAdherentParticulierRechercheAllOf
     */
    listeAdherent?: Array<AdherentParticulierRecherche>;
}
/**
 * Stucture de donnee contenant une recherche paginee de compte
 * @export
 * @interface ListePageCompteParticulierRecherche
 */
export interface ListePageCompteParticulierRecherche {
    /**
     * listeCompte
     * @type {Array<CompteParticulier>}
     * @memberof ListePageCompteParticulierRecherche
     */
    listeCompte?: Array<CompteParticulier>;
    /**
     * Nombre total de lignes correspondant au critére de recherche
     * @type {number}
     * @memberof ListePageCompteParticulierRecherche
     */
    nombreLigne: number;
    /**
     * Nombre de pages pour afficher tous les résultats
     * @type {number}
     * @memberof ListePageCompteParticulierRecherche
     */
    nombrePage: number;
    /**
     * L\'index de la page (l\'index de la premiere page est 0)
     * @type {number}
     * @memberof ListePageCompteParticulierRecherche
     */
    page: number;
    /**
     * Le nombre d\'éléments à retourner dans une page de donnees
     * @type {number}
     * @memberof ListePageCompteParticulierRecherche
     */
    taille: number;
    /**
     * Format : attribut1:asc,attribut2:desc \\n Nom de l\'attribut egal au nom du champ envoye
     * @type {string}
     * @memberof ListePageCompteParticulierRecherche
     */
    tri?: string;
}
/**
 *
 * @export
 * @interface ListePageCompteParticulierRechercheAllOf
 */
export interface ListePageCompteParticulierRechercheAllOf {
    /**
     * listeCompte
     * @type {Array<CompteParticulier>}
     * @memberof ListePageCompteParticulierRechercheAllOf
     */
    listeCompte?: Array<CompteParticulier>;
}
/**
 * Stucture de donnee contenant une recherche paginee de stocks
 * @export
 * @interface ListePageStockRecherche
 */
export interface ListePageStockRecherche {
    /**
     * liste des stocks d\'un grand client
     * @type {Array<StockRecherche>}
     * @memberof ListePageStockRecherche
     */
    listeStock?: Array<StockRecherche>;
    /**
     * Nombre total de lignes correspondant au critére de recherche
     * @type {number}
     * @memberof ListePageStockRecherche
     */
    nombreLigne: number;
    /**
     * Nombre de pages pour afficher tous les résultats
     * @type {number}
     * @memberof ListePageStockRecherche
     */
    nombrePage: number;
    /**
     * L\'index de la page (l\'index de la premiere page est 0)
     * @type {number}
     * @memberof ListePageStockRecherche
     */
    page: number;
    /**
     * Le nombre d\'éléments à retourner dans une page de donnees
     * @type {number}
     * @memberof ListePageStockRecherche
     */
    taille: number;
    /**
     * Format : attribut1:asc,attribut2:desc \\n Nom de l\'attribut egal au nom du champ envoye
     * @type {string}
     * @memberof ListePageStockRecherche
     */
    tri?: string;
}
/**
 *
 * @export
 * @interface ListePageStockRechercheAllOf
 */
export interface ListePageStockRechercheAllOf {
    /**
     * liste des stocks d\'un grand client
     * @type {Array<StockRecherche>}
     * @memberof ListePageStockRechercheAllOf
     */
    listeStock?: Array<StockRecherche>;
}
/**
 * un produit et ses documents présents
 * @export
 * @interface ListeProduits
 */
export interface ListeProduits {
    /**
     * code du produit
     * @type {string}
     * @memberof ListeProduits
     */
    code: string;
    /**
     * libelle court du produit
     * @type {string}
     * @memberof ListeProduits
     */
    libelleCourt?: string;
    /**
     * libelle du produit
     * @type {string}
     * @memberof ListeProduits
     */
    libelle?: string;
    /**
     *
     * @type {ListeDocumentsProduit}
     * @memberof ListeProduits
     */
    documents: ListeDocumentsProduit;
}
/**
 * liste des stocks pour reedition pochoir
 * @export
 * @interface ListeStockPochoir
 */
export interface ListeStockPochoir {
    /**
     * code du programme du stock
     * @type {string}
     * @memberof ListeStockPochoir
     */
    codeProgramme: string;
    /**
     * identifiant du client rattache au stock
     * @type {number}
     * @memberof ListeStockPochoir
     */
    clientId: number;
    /**
     * numero de serie court du stock
     * @type {string}
     * @memberof ListeStockPochoir
     */
    numeroSerie: string;
}
/**
 * Represente un mandat de prelevement SEPA
 * @export
 * @interface Mandat
 */
export interface Mandat {
    /**
     * Reference Unique du Mandat SEPA
     * @type {string}
     * @memberof Mandat
     */
    rum?: string;
    /**
     * IBAN du compte bancaire a prelever
     * @type {string}
     * @memberof Mandat
     */
    iban?: string;
    /**
     * Code BIC de la banque a debiter
     * @type {string}
     * @memberof Mandat
     */
    bic?: string;
    /**
     * nom du titulaire
     * @type {string}
     * @memberof Mandat
     */
    nomTitulaire?: string;
}
/**
 * Marque du vehicule
 * @export
 * @interface MarqueVehicule
 */
export interface MarqueVehicule {
    /**
     *
     * @type {number}
     * @memberof MarqueVehicule
     */
    codeMarque?: number;
    /**
     *
     * @type {string}
     * @memberof MarqueVehicule
     */
    libelle?: string;
}
/**
 * Représente un modèle de carte
 * @export
 * @interface ModeleCarte
 */
export interface ModeleCarte {
    /**
     * reference du modele de carte
     * @type {number}
     * @memberof ModeleCarte
     */
    reference: number;
    /**
     * libelle du modele de carte
     * @type {string}
     * @memberof ModeleCarte
     */
    libelle?: string;
}
/**
 *
 * @export
 * @interface MoyenTransport
 */
export interface MoyenTransport {
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    immatriculation?: string;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    numeroCarteGrise?: string;
    /**
     * 17 caracteres du numero de serie du vehicule
     * @type {string}
     * @memberof MoyenTransport
     */
    numeroSerie?: string;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    genre?: string;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    type?: string;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    dateCarteGrise?: string;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    datePremiereMiseEnCirc?: string;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    dateImmatPrecedente?: string;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    immatPrecedente?: string;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    modele?: string;
    /**
     *
     * @type {number}
     * @memberof MoyenTransport
     */
    codeMarque?: number;
    /**
     *
     * @type {string}
     * @memberof MoyenTransport
     */
    codeCategorie?: string;
    /**
     * true si le le moyen de transport a une immatriculation temporaire.
     * @type {boolean}
     * @memberof MoyenTransport
     */
    immatriculationTemporaire?: boolean;
    /**
     *
     * @type {Pochoir}
     * @memberof MoyenTransport
     */
    pochoir?: Pochoir;
}
/**
 *
 * @export
 * @interface NumeroAdhesion
 */
export interface NumeroAdhesion {
    /**
     *
     * @type {number}
     * @memberof NumeroAdhesion
     */
    numeroAdhesion: number;
}
/**
 * Represente l\'objet de risque ou l\'objet de l\'adhesion
 * @export
 * @interface ObjetRisque
 */
export interface ObjetRisque {
    /**
     * Objet de risque personne
     * @type {number}
     * @memberof ObjetRisque
     */
    personne?: number;
    /**
     *
     * @type {MoyenTransport}
     * @memberof ObjetRisque
     */
    moyenTransport?: MoyenTransport;
}
/**
 *
 * @export
 * @interface Pays
 */
export interface Pays {
    /**
     * Code ISO sur 2 caracteres
     * @type {string}
     * @memberof Pays
     */
    id: string;
    /**
     * code Iso sur 3 caracteres
     * @type {string}
     * @memberof Pays
     */
    codePays3: string;
    /**
     *
     * @type {string}
     * @memberof Pays
     */
    nomFrancais: string;
    /**
     *
     * @type {string}
     * @memberof Pays
     */
    nomAnglais?: string;
}
/**
 *
 * @export
 * @interface Personnalisation
 */
export interface Personnalisation {
    /**
     *
     * @type {number}
     * @memberof Personnalisation
     */
    id: number;
    /**
     *
     * @type {Theme}
     * @memberof Personnalisation
     */
    theme: Theme;
    /**
     *
     * @type {Images}
     * @memberof Personnalisation
     */
    images: Images;
}
/**
 *
 * @export
 * @interface PersonnalisationClient
 */
export interface PersonnalisationClient {
    /**
     *
     * @type {Personnalisation}
     * @memberof PersonnalisationClient
     */
    personnalisation?: Personnalisation;
    /**
     *
     * @type {boolean}
     * @memberof PersonnalisationClient
     */
    personnalisationGrandClient: boolean;
}
/**
 * PersonnalisationIdResource
 * @export
 * @interface PersonnalisationIdResource
 */
export interface PersonnalisationIdResource {
    /**
     *
     * @type {number}
     * @memberof PersonnalisationIdResource
     */
    personnalisationId?: number;
}
/**
 *
 * @export
 * @interface PersonnalisationIn
 */
export interface PersonnalisationIn {
    /**
     *
     * @type {number}
     * @memberof PersonnalisationIn
     */
    identifiantTheme: number;
    /**
     * Numéro du client auquel la personnalisation est rattachée
     * @type {number}
     * @memberof PersonnalisationIn
     */
    clientId: number;
    /**
     *
     * @type {number}
     * @memberof PersonnalisationIn
     */
    grandClientId: number;
    /**
     *
     * @type {Images}
     * @memberof PersonnalisationIn
     */
    images: Images;
}
/**
 * Information concernant le pochoir a appliquer sur le moyen de transport
 * @export
 * @interface Pochoir
 */
export interface Pochoir {
    /**
     * Client --> GET client/utilisateur/{login}/reseau champ adresse AdherentParticulier --> GET /adherentParticulier/{adherentParticulierId} champ adresse Autre --> POST /stock champ pochoir.adresse Preparateur -->GET client/utilisateur/{login}/reseau champ adressePreparateur
     * @type {string}
     * @memberof Pochoir
     */
    type: string;
    /**
     *
     * @type {Adresse}
     * @memberof Pochoir
     */
    adresse?: Adresse;
    /**
     * 8 derniers caracteres du numero de serie du moyen de transport imprime sur le pochoir.
     * @type {string}
     * @memberof Pochoir
     */
    numeroSerieCourt?: string;
    /**
     * intitule de l\'adresse du pochoir
     * @type {string}
     * @memberof Pochoir
     */
    intitule?: string;
    /**
     * valeurs : “EN_ATTENTE” / “EN_COURS” / “EXPEDIE” / null
     * @type {string}
     * @memberof Pochoir
     */
    statut?: PochoirStatutEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum PochoirStatutEnum {
    ENATTENTE = 'EN_ATTENTE',
    ENCOURS = 'EN_COURS',
    EXPEDIE = 'EXPEDIE',
}

/**
 * Description d\'un produit SAGA
 * @export
 * @interface Produit
 */
export interface Produit {
    /**
     * code commercial du produit
     * @type {string}
     * @memberof Produit
     */
    code?: string;
    /**
     * Libelle court du produit
     * @type {string}
     * @memberof Produit
     */
    libelleCourt?: string;
    /**
     * Denomination commerciale du produit
     * @type {string}
     * @memberof Produit
     */
    libelle?: string;
    /**
     * Nom de l\'assureur apériteur du produit d\'assurance
     * @type {string}
     * @memberof Produit
     */
    assureur?: string;
    /**
     * Objet de risque concerne par le produit: MoyenTransport Personne Autre
     * @type {string}
     * @memberof Produit
     */
    objetRisque: string;
    /**
     * Liste des garanties du produit d\'assurance
     * @type {Array<Garantie>}
     * @memberof Produit
     */
    listeGaranties?: Array<Garantie>;
    /**
     * savoir si l adherent a un contrat assistance depannage
     * @type {boolean}
     * @memberof Produit
     */
    remorquageDepannage: boolean;
}
/**
 *
 * @export
 * @interface ProduitDocuments
 */
export interface ProduitDocuments {
    /**
     * identifiant de la version courante des documents
     * @type {number}
     * @memberof ProduitDocuments
     */
    id: number;
    /**
     * date de debut de validite de la version de document
     * @type {string}
     * @memberof ProduitDocuments
     */
    dateDebut: string;
    /**
     * Date de fin de la version de documents (renseignée seulement si ce n\'est pas la version courante)
     * @type {string}
     * @memberof ProduitDocuments
     */
    dateFin?: string;
    /**
     *
     * @type {Fichier}
     * @memberof ProduitDocuments
     */
    adhesion?: Fichier;
    /**
     *
     * @type {Fichier}
     * @memberof ProduitDocuments
     */
    conditionsGenerales?: Fichier;
}
/**
 * Representation d\'un programme d\'adhesion SAGA
 * @export
 * @interface Programme
 */
export interface Programme {
    /**
     * code commercial du programme
     * @type {string}
     * @memberof Programme
     */
    code?: string;
    /**
     * Libelle court du programme
     * @type {string}
     * @memberof Programme
     */
    libelleCourt?: string;
    /**
     * Denomination commerciale du programme
     * @type {string}
     * @memberof Programme
     */
    libelle?: string;
    /**
     * liste des produits composants le programme
     * @type {Array<Produit>}
     * @memberof Programme
     */
    listeProduits?: Array<Produit>;
    /**
     * liste des services composant le programme
     * @type {Array<Service>}
     * @memberof Programme
     */
    listeServices?: Array<Service>;
    /**
     * info renouvellement par prelevement. Valeurs : \"O\"/\"N\"
     * @type {string}
     * @memberof Programme
     */
    mandatSepa?: string;
    /**
     * info pour savoir si le contrat necessite un renouvellement
     * @type {string}
     * @memberof Programme
     */
    renouvellement?: string;
    /**
     * boolean qui permet de savoir si la saisie du mandat est obligatoire dans la creation d\'adhesion
     * @type {string}
     * @memberof Programme
     */
    mandatObligatoire?: string;
}
/**
 *
 * @export
 * @interface RaisonResiliation
 */
export interface RaisonResiliation {
    /**
     *
     * @type {string}
     * @memberof RaisonResiliation
     */
    raison?: string;
}
/**
 *
 * @export
 * @interface Renouvellement
 */
export interface Renouvellement {
    /**
     * numero d\'adhesion a renovuellement
     * @type {string}
     * @memberof Renouvellement
     */
    numeroAdhesion: string;
    /**
     * date debut du renouvellement
     * @type {string}
     * @memberof Renouvellement
     */
    dateDebut: string;
    /**
     * date de fin du renouvellement
     * @type {string}
     * @memberof Renouvellement
     */
    dateFin: string;
    /**
     * montant du renouvellement
     * @type {number}
     * @memberof Renouvellement
     */
    tarif?: number;
    /**
     * produit a renouveller
     * @type {string}
     * @memberof Renouvellement
     */
    codeProduit?: string;
    /**
     * savoir s\'il y\'a deja une transaction sur le dernier objet renouvellement
     * @type {boolean}
     * @memberof Renouvellement
     */
    transactionEnCours: boolean;
}
/**
 *
 * @export
 * @interface RumResource
 */
export interface RumResource {
    /**
     *
     * @type {string}
     * @memberof RumResource
     */
    rum?: string;
    /**
     *
     * @type {string}
     * @memberof RumResource
     */
    iban?: string;
    /**
     *
     * @type {string}
     * @memberof RumResource
     */
    bic?: string;
}
/**
 * Represente un service vendu par SAGA
 * @export
 * @interface Service
 */
export interface Service {
    /**
     * Type de service vendu par SAGA: Gravage, Fidelisation
     * @type {string}
     * @memberof Service
     */
    type?: string;
    /**
     * Niveau du service
     * @type {string}
     * @memberof Service
     */
    niveau?: string;
    /**
     * Libelle court du service
     * @type {string}
     * @memberof Service
     */
    libelleCourt?: string;
    /**
     * Denomination commerciale du service
     * @type {string}
     * @memberof Service
     */
    libelle?: string;
    /**
     * Objet de risque concerne par le produit: MoyenTransport Personne Autre
     * @type {string}
     * @memberof Service
     */
    objetRisque: string;
}
/**
 * Information pour la signature par Otp
 * @export
 * @interface SignatureSms
 */
export interface SignatureSms {
    /**
     * Code OTP reçu par sms et à renseigner pour signer.
     * @type {string}
     * @memberof SignatureSms
     */
    codeOtp: string;
}
/**
 * Represente la declaration d\'un stock
 * @export
 * @interface Stock
 */
export interface Stock {
    /**
     * Identifiant de la ressource client vendeur de l\'adhesion
     * @type {number}
     * @memberof Stock
     */
    clientId: number;
    /**
     * Identifiant de la ressource Programme obtenue par /programme/client/{clientId}
     * @type {string}
     * @memberof Stock
     */
    codeProgramme: string;
    /**
     * Identifiant de la ressource Categorie obtenue pas /categorie/recherche
     * @type {number}
     * @memberof Stock
     */
    codeCategorie: number;
    /**
     * 17 caracteres ou les 8 derniers caractères du numero de serie du vehicule
     * @type {string}
     * @memberof Stock
     */
    numeroSerie: string;
    /**
     *
     * @type {Pochoir}
     * @memberof Stock
     */
    pochoir?: Pochoir;
    /**
     * 8 derniers caracteres du numero de serie
     * @type {string}
     * @memberof Stock
     */
    numeroSerieCourt?: string;
}
/**
 * Reedition d\'un pochoir pour une liste de stocks
 * @export
 * @interface StockPochoir
 */
export interface StockPochoir {
    /**
     *
     * @type {Adresse}
     * @memberof StockPochoir
     */
    adresse: Adresse;
    /**
     * intitule du pochoir
     * @type {string}
     * @memberof StockPochoir
     */
    intitule?: string;
    /**
     * liste des stocks
     * @type {Array<ListeStockPochoir>}
     * @memberof StockPochoir
     */
    stocks: Array<ListeStockPochoir>;
    /**
     * Type d\'adresse
     * @type {string}
     * @memberof StockPochoir
     */
    type: string;
}
/**
 *
 * @export
 * @interface StockRecherche
 */
export interface StockRecherche {
    /**
     * Identifiant du client sur lequel a été realise la declaration de stock
     * @type {string}
     * @memberof StockRecherche
     */
    clientId: string;
    /**
     * Nom du client sur lequel a été realise la declaration de stock
     * @type {string}
     * @memberof StockRecherche
     */
    clientNom: string;
    /**
     * Date de derniere modification de la declaration de stock
     * @type {string}
     * @memberof StockRecherche
     */
    dateEnregistrement?: string;
    /**
     * 17 caracteres du numero de serie du vehicule
     * @type {string}
     * @memberof StockRecherche
     */
    numeroSerie?: string;
    /**
     *
     * @type {Pochoir}
     * @memberof StockRecherche
     */
    pochoir?: Pochoir;
    /**
     *
     * @type {Categorie}
     * @memberof StockRecherche
     */
    categorie?: Categorie;
}
/**
 *
 * @export
 * @interface Theme
 */
export interface Theme {
    /**
     *
     * @type {number}
     * @memberof Theme
     */
    id: number;
    /**
     *
     * @type {string}
     * @memberof Theme
     */
    libelle?: string;
    /**
     *
     * @type {string}
     * @memberof Theme
     */
    hexaCouleurTheme1?: string;
    /**
     *
     * @type {string}
     * @memberof Theme
     */
    hexaCouleurTheme2?: string;
}
/**
 *
 * @export
 * @interface TokenSaga
 */
export interface TokenSaga {
    /**
     *
     * @type {string}
     * @memberof TokenSaga
     */
    tokenSaga?: string;
}
/**
 *
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * date de la transaction
     * @type {string}
     * @memberof Transaction
     */
    date: string;
    /**
     * type de l\'achat
     * @type {string}
     * @memberof Transaction
     */
    detail: string;
    /**
     * montant de l\'achat en euros
     * @type {number}
     * @memberof Transaction
     */
    montant: number;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    credit?: number;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    debit?: number;
}
/**
 *
 * @export
 * @interface UrlDemandeAssistance
 */
export interface UrlDemandeAssistance {
    /**
     * url de redirection de depannage en ligne
     * @type {string}
     * @memberof UrlDemandeAssistance
     */
    url: string;
}
/**
 * Represente les informations d\'un utilisateur
 * @export
 * @interface Utilisateur
 */
export interface Utilisateur {
    /**
     * Nom de l\'utilisateur
     * @type {string}
     * @memberof Utilisateur
     */
    nom?: string;
    /**
     * Login de connexion de l\'utilisateur
     * @type {string}
     * @memberof Utilisateur
     */
    login?: string;
    /**
     * Prenom de l\'utilisateur
     * @type {string}
     * @memberof Utilisateur
     */
    prenom?: string;
    /**
     *
     * @type {Client}
     * @memberof Utilisateur
     */
    client?: Client;
    /**
     *
     * @type {ClientInfo}
     * @memberof Utilisateur
     */
    grandClient?: ClientInfo;
    /**
     * Liste des clients pour lequel l\'utilisateur a le droit de modifier des donnees
     * @type {Array<ClientInfo>}
     * @memberof Utilisateur
     */
    reseau?: Array<ClientInfo>;
    /**
     * Email de l\'utilisateur
     * @type {string}
     * @memberof Utilisateur
     */
    email?: string;
    /**
     * Telephone de l\'utilisateur
     * @type {string}
     * @memberof Utilisateur
     */
    telephone?: string;
    /**
     * direction / secretaire / vendeur
     * @type {string}
     * @memberof Utilisateur
     */
    profil?: string;
    /**
     * Mot de passe temporaire si l\'utilisateur n\'a pas d\'email de renseigner. 8 caracteres, 1 majuscule, 1 caractere special, 1 chiffre
     * @type {string}
     * @memberof Utilisateur
     */
    mdpTemporaire?: string;
    /**
     * A FAIRE si email vide sinon EFFECTUE
     * @type {string}
     * @memberof Utilisateur
     */
    statutEnrolement?: string;
    /**
     * Abonnement de l\'utilisateur au reporting mensuel
     * @type {boolean}
     * @memberof Utilisateur
     */
    abonnement?: boolean;
}
/**
 * Represente les informations d\'un utilisateur
 * @export
 * @interface UtilisateurIn
 */
export interface UtilisateurIn {
    /**
     * Nom de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurIn
     */
    nom?: string;
    /**
     * Login de connexion de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurIn
     */
    login?: string;
    /**
     * Prenom de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurIn
     */
    prenom?: string;
    /**
     *
     * @type {Client}
     * @memberof UtilisateurIn
     */
    client?: Client;
    /**
     *
     * @type {ClientInfo}
     * @memberof UtilisateurIn
     */
    grandClient?: ClientInfo;
    /**
     * Email de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurIn
     */
    email?: string;
    /**
     * Telephone de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurIn
     */
    telephone?: string;
    /**
     * direction / secretaire / vendeur
     * @type {string}
     * @memberof UtilisateurIn
     */
    profil?: string;
    /**
     * Mot de passe temporaire si l\'utilisateur n\'a pas d\'email de renseigner. 8 caracteres, 1 majuscule, 1 caractere special, 1 chiffre
     * @type {string}
     * @memberof UtilisateurIn
     */
    mdpTemporaire?: string;
    /**
     * A FAIRE si email vide sinon EFFECTUE
     * @type {string}
     * @memberof UtilisateurIn
     */
    statutEnrolement?: string;
    /**
     * Liste des clients ajoutés dans le reseau de l\'utilisateur modifié
     * @type {Array<ClientInfo>}
     * @memberof UtilisateurIn
     */
    reseauAjout?: Array<ClientInfo>;
    /**
     * Liste des clients supprimés du reseau de l\'utilisateur modifié
     * @type {Array<ClientInfo>}
     * @memberof UtilisateurIn
     */
    reseauRetrait?: Array<ClientInfo>;
    /**
     * Abonnement de l\'utilisateur au reporting mensuel
     * @type {boolean}
     * @memberof UtilisateurIn
     */
    abonnement?: boolean;
}
/**
 * Represente les infos d\'un utilisateur dans une liste
 * @export
 * @interface UtilisateurRecherche
 */
export interface UtilisateurRecherche {
    /**
     * Nom de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurRecherche
     */
    nom?: string;
    /**
     * Login de connexion de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurRecherche
     */
    login?: string;
    /**
     * Prenom de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurRecherche
     */
    prenom?: string;
    /**
     * Profil de l\'utilisateur (administrateur, secretaire commercial, vendeur, direction...)
     * @type {string}
     * @memberof UtilisateurRecherche
     */
    profil?: string;
    /**
     * Date de fin = date de depart du collaborateur de la concession = date a laquelle l\'utilisateur ne doit plus avoir acces à SEL
     * @type {string}
     * @memberof UtilisateurRecherche
     */
    dateDeFin?: string;
    /**
     * Telephone de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurRecherche
     */
    telephone?: string;
    /**
     * Email de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurRecherche
     */
    email?: string;
}
/**
 * Represente les informations d\'un utilisateur
 * @export
 * @interface UtilisateurSimple
 */
export interface UtilisateurSimple {
    /**
     * Nom de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurSimple
     */
    nom?: string;
    /**
     * Login de connexion de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurSimple
     */
    login?: string;
    /**
     * Prenom de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurSimple
     */
    prenom?: string;
    /**
     * Email de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurSimple
     */
    email?: string;
    /**
     * Telephone de l\'utilisateur
     * @type {string}
     * @memberof UtilisateurSimple
     */
    telephone?: string;
    /**
     * direction / secretaire / vendeur
     * @type {string}
     * @memberof UtilisateurSimple
     */
    profil?: string;
    /**
     * Mot de passe temporaire si l\'utilisateur n\'a pas d\'email de renseigner. 8 caracteres, 1 majuscule, 1 caractere special, 1 chiffre
     * @type {string}
     * @memberof UtilisateurSimple
     */
    mdpTemporaire?: string;
}
/**
 * Representation d\'un ville
 * @export
 * @interface Ville
 */
export interface Ville {
    /**
     * Code insee de la commune
     * @type {string}
     * @memberof Ville
     */
    codeInsee?: string;
    /**
     * Code postal de la ville
     * @type {string}
     * @memberof Ville
     */
    codePostal?: string;
    /**
     * Nom commun de la ville
     * @type {string}
     * @memberof Ville
     */
    libelleAcheminement?: string;
    /**
     * libelle de la ville
     * @type {string}
     * @memberof Ville
     */
    libelleCommune?: string;
}

/**
 * AdherentParticulierApi - axios parameter creator
 * @export
 */
export const AdherentParticulierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * endpoint qui permet de récupérer les informations d\'un adhérentParticulier (ainsi que sa liste d\'adhésion)
         * @summary GET /compte/adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentById(adherentParticulierId: number, options: any = {}): RequestArgs {
            // verify required parameter 'adherentParticulierId' is not null or undefined
            if (adherentParticulierId === null || adherentParticulierId === undefined) {
                throw new RequiredError(
                    'adherentParticulierId',
                    'Required parameter adherentParticulierId was null or undefined when calling getAdherentById.',
                );
            }
            const localVarPath = `/compte/adherentParticulier/{adherentParticulierId}`.replace(
                `{${'adherentParticulierId'}}`,
                encodeURIComponent(String(adherentParticulierId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * liste des adherents particuliers
         * @summary GET /adherentParticulier
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {number} [clientId] Identifiant de la ressource client (site vendeur) permettant de definir le grand client dans lequel sera effectuee la recherche.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulier(nom?: string, clientId?: number, options: any = {}): RequestArgs {
            const localVarPath = `/adherentParticulier`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc \\n Nom de l\&#39;attribut egal au nom du champ envoye
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {Array<string>} [etatAdhesion] L\&#39;etat de l\&#39;adhesion
         * @param {Array<string>} [siteVendeur] les sites vendeurs
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {string} [categorie] categorie vehicule
         * @param {string} [numeroFidelite] Numero du compte de fidelite du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierAdhesionByCritere(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            page?: number,
            taille?: number,
            tri?: Array<string>,
            adherentParticulierId?: number,
            etatAdhesion?: Array<string>,
            siteVendeur?: Array<string>,
            souscripteurId?: number,
            numeroSerie?: string,
            categorie?: string,
            numeroFidelite?: string,
            options: any = {},
        ): RequestArgs {
            const localVarPath = `/adherentParticulier/adhesion`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (grandClientId !== undefined) {
                localVarQueryParameter['grandClientId'] = grandClientId;
            }

            if (dateMin !== undefined) {
                localVarQueryParameter['dateMin'] =
                    (dateMin as any) instanceof Date ? (dateMin as any).toISOString().substr(0, 10) : dateMin;
            }

            if (dateMax !== undefined) {
                localVarQueryParameter['dateMax'] =
                    (dateMax as any) instanceof Date ? (dateMax as any).toISOString().substr(0, 10) : dateMax;
            }

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            if (immatriculation !== undefined) {
                localVarQueryParameter['immatriculation'] = immatriculation;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (taille !== undefined) {
                localVarQueryParameter['taille'] = taille;
            }

            if (tri) {
                localVarQueryParameter['tri'] = tri;
            }

            if (adherentParticulierId !== undefined) {
                localVarQueryParameter['adherentParticulierId'] = adherentParticulierId;
            }

            if (etatAdhesion) {
                localVarQueryParameter['etatAdhesion'] = etatAdhesion;
            }

            if (siteVendeur) {
                localVarQueryParameter['siteVendeur'] = siteVendeur;
            }

            if (souscripteurId !== undefined) {
                localVarQueryParameter['souscripteurId'] = souscripteurId;
            }

            if (numeroSerie !== undefined) {
                localVarQueryParameter['numeroSerie'] = numeroSerie;
            }

            if (categorie !== undefined) {
                localVarQueryParameter['categorie'] = categorie;
            }

            if (numeroFidelite !== undefined) {
                localVarQueryParameter['numeroFidelite'] = numeroFidelite;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/{adherentParticulierId}/adhesion
         * @param {string} adherentParticulierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierAdhesionOfAdherent(adherentParticulierId: string, options: any = {}): RequestArgs {
            // verify required parameter 'adherentParticulierId' is not null or undefined
            if (adherentParticulierId === null || adherentParticulierId === undefined) {
                throw new RequiredError(
                    'adherentParticulierId',
                    'Required parameter adherentParticulierId was null or undefined when calling getAdherentParticulierAdhesionOfAdherent.',
                );
            }
            const localVarPath = `/adherentParticulier/{adherentParticulierId}/adhesion`.replace(
                `{${'adherentParticulierId'}}`,
                encodeURIComponent(String(adherentParticulierId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lecture des donnees d\'un particulier a partir de son identifiant
         * @summary GET /adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId Identifiant de l\&#39;adherent particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierById(adherentParticulierId: number, options: any = {}): RequestArgs {
            // verify required parameter 'adherentParticulierId' is not null or undefined
            if (adherentParticulierId === null || adherentParticulierId === undefined) {
                throw new RequiredError(
                    'adherentParticulierId',
                    'Required parameter adherentParticulierId was null or undefined when calling getAdherentParticulierById.',
                );
            }
            const localVarPath = `/adherentParticulier/{adherentParticulierId}`.replace(
                `{${'adherentParticulierId'}}`,
                encodeURIComponent(String(adherentParticulierId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin. Pas disponible.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax Pas disponible.
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {Array<string>} [etatAdhesion] etatAdhesion
         * @param {'excel' | 'pdf'} [format] Format du rapport
         * @param {boolean} [infoVehicule] info pour afficher ou non les colonnes vehicule dans extraction de la liste des contrats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAdherentParticulierAdhesion(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            adherentParticulierId?: number,
            souscripteurId?: number,
            numeroSerie?: string,
            etatAdhesion?: Array<string>,
            format?: 'excel' | 'pdf',
            infoVehicule?: boolean,
            options: any = {},
        ): RequestArgs {
            const localVarPath = `/adherentParticulier/adhesion/rapport`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (grandClientId !== undefined) {
                localVarQueryParameter['grandClientId'] = grandClientId;
            }

            if (dateMin !== undefined) {
                localVarQueryParameter['dateMin'] =
                    (dateMin as any) instanceof Date ? (dateMin as any).toISOString().substr(0, 10) : dateMin;
            }

            if (dateMax !== undefined) {
                localVarQueryParameter['dateMax'] =
                    (dateMax as any) instanceof Date ? (dateMax as any).toISOString().substr(0, 10) : dateMax;
            }

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            if (immatriculation !== undefined) {
                localVarQueryParameter['immatriculation'] = immatriculation;
            }

            if (adherentParticulierId !== undefined) {
                localVarQueryParameter['adherentParticulierId'] = adherentParticulierId;
            }

            if (souscripteurId !== undefined) {
                localVarQueryParameter['souscripteurId'] = souscripteurId;
            }

            if (numeroSerie !== undefined) {
                localVarQueryParameter['numeroSerie'] = numeroSerie;
            }

            if (etatAdhesion) {
                localVarQueryParameter['etatAdhesion'] = etatAdhesion;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (infoVehicule !== undefined) {
                localVarQueryParameter['infoVehicule'] = infoVehicule;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary put  /adherentParticulier
         * @param {AdherentParticulier} adherentParticulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifierAdherentParticulier(adherentParticulier: AdherentParticulier, options: any = {}): RequestArgs {
            // verify required parameter 'adherentParticulier' is not null or undefined
            if (adherentParticulier === null || adherentParticulier === undefined) {
                throw new RequiredError(
                    'adherentParticulier',
                    'Required parameter adherentParticulier was null or undefined when calling modifierAdherentParticulier.',
                );
            }
            const localVarPath = `/adherentParticulier`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof adherentParticulier !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(adherentParticulier !== undefined ? adherentParticulier : {})
                : adherentParticulier || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modificiations des donnees d\'un particulier
         * @summary PUT /adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId Identifiant de l\&#39;adherent particulier
         * @param {AdherentParticulier} adherentParticulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdherentParticulierById(
            adherentParticulierId: number,
            adherentParticulier: AdherentParticulier,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'adherentParticulierId' is not null or undefined
            if (adherentParticulierId === null || adherentParticulierId === undefined) {
                throw new RequiredError(
                    'adherentParticulierId',
                    'Required parameter adherentParticulierId was null or undefined when calling putAdherentParticulierById.',
                );
            }
            // verify required parameter 'adherentParticulier' is not null or undefined
            if (adherentParticulier === null || adherentParticulier === undefined) {
                throw new RequiredError(
                    'adherentParticulier',
                    'Required parameter adherentParticulier was null or undefined when calling putAdherentParticulierById.',
                );
            }
            const localVarPath = `/adherentParticulier/{adherentParticulierId}`.replace(
                `{${'adherentParticulierId'}}`,
                encodeURIComponent(String(adherentParticulierId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof adherentParticulier !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(adherentParticulier !== undefined ? adherentParticulier : {})
                : adherentParticulier || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * AdherentParticulierApi - functional programming interface
 * @export
 */
export const AdherentParticulierApiFp = function (configuration?: Configuration) {
    return {
        /**
         * endpoint qui permet de récupérer les informations d\'un adhérentParticulier (ainsi que sa liste d\'adhésion)
         * @summary GET /compte/adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentById(
            adherentParticulierId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdherentParticulierResponse> {
            const localVarAxiosArgs = AdherentParticulierApiAxiosParamCreator(configuration).getAdherentById(
                adherentParticulierId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * liste des adherents particuliers
         * @summary GET /adherentParticulier
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {number} [clientId] Identifiant de la ressource client (site vendeur) permettant de definir le grand client dans lequel sera effectuee la recherche.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulier(
            nom?: string,
            clientId?: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdherentParticulierSimple>> {
            const localVarAxiosArgs = AdherentParticulierApiAxiosParamCreator(configuration).getAdherentParticulier(
                nom,
                clientId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc \\n Nom de l\&#39;attribut egal au nom du champ envoye
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {Array<string>} [etatAdhesion] L\&#39;etat de l\&#39;adhesion
         * @param {Array<string>} [siteVendeur] les sites vendeurs
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {string} [categorie] categorie vehicule
         * @param {string} [numeroFidelite] Numero du compte de fidelite du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierAdhesionByCritere(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            page?: number,
            taille?: number,
            tri?: Array<string>,
            adherentParticulierId?: number,
            etatAdhesion?: Array<string>,
            siteVendeur?: Array<string>,
            souscripteurId?: number,
            numeroSerie?: string,
            categorie?: string,
            numeroFidelite?: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListePageAdherentParticulierRecherche> {
            const localVarAxiosArgs = AdherentParticulierApiAxiosParamCreator(
                configuration,
            ).getAdherentParticulierAdhesionByCritere(
                grandClientId,
                dateMin,
                dateMax,
                nom,
                immatriculation,
                page,
                taille,
                tri,
                adherentParticulierId,
                etatAdhesion,
                siteVendeur,
                souscripteurId,
                numeroSerie,
                categorie,
                numeroFidelite,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/{adherentParticulierId}/adhesion
         * @param {string} adherentParticulierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierAdhesionOfAdherent(
            adherentParticulierId: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdherentParticulierAdhesionDetails> {
            const localVarAxiosArgs = AdherentParticulierApiAxiosParamCreator(
                configuration,
            ).getAdherentParticulierAdhesionOfAdherent(adherentParticulierId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Lecture des donnees d\'un particulier a partir de son identifiant
         * @summary GET /adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId Identifiant de l\&#39;adherent particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierById(
            adherentParticulierId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdherentParticulier> {
            const localVarAxiosArgs = AdherentParticulierApiAxiosParamCreator(configuration).getAdherentParticulierById(
                adherentParticulierId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin. Pas disponible.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax Pas disponible.
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {Array<string>} [etatAdhesion] etatAdhesion
         * @param {'excel' | 'pdf'} [format] Format du rapport
         * @param {boolean} [infoVehicule] info pour afficher ou non les colonnes vehicule dans extraction de la liste des contrats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAdherentParticulierAdhesion(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            adherentParticulierId?: number,
            souscripteurId?: number,
            numeroSerie?: string,
            etatAdhesion?: Array<string>,
            format?: 'excel' | 'pdf',
            infoVehicule?: boolean,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = AdherentParticulierApiAxiosParamCreator(
                configuration,
            ).getRapportAdherentParticulierAdhesion(
                grandClientId,
                dateMin,
                dateMax,
                nom,
                immatriculation,
                adherentParticulierId,
                souscripteurId,
                numeroSerie,
                etatAdhesion,
                format,
                infoVehicule,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary put  /adherentParticulier
         * @param {AdherentParticulier} adherentParticulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifierAdherentParticulier(
            adherentParticulier: AdherentParticulier,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdherentParticulierApiAxiosParamCreator(configuration).modifierAdherentParticulier(
                adherentParticulier,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Modificiations des donnees d\'un particulier
         * @summary PUT /adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId Identifiant de l\&#39;adherent particulier
         * @param {AdherentParticulier} adherentParticulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdherentParticulierById(
            adherentParticulierId: number,
            adherentParticulier: AdherentParticulier,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdherentParticulier> {
            const localVarAxiosArgs = AdherentParticulierApiAxiosParamCreator(configuration).putAdherentParticulierById(
                adherentParticulierId,
                adherentParticulier,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * AdherentParticulierApi - factory interface
 * @export
 */
export const AdherentParticulierApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
) {
    return {
        /**
         * endpoint qui permet de récupérer les informations d\'un adhérentParticulier (ainsi que sa liste d\'adhésion)
         * @summary GET /compte/adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentById(adherentParticulierId: number, options?: any) {
            return AdherentParticulierApiFp(configuration).getAdherentById(adherentParticulierId, options)(axios, basePath);
        },
        /**
         * liste des adherents particuliers
         * @summary GET /adherentParticulier
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {number} [clientId] Identifiant de la ressource client (site vendeur) permettant de definir le grand client dans lequel sera effectuee la recherche.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulier(nom?: string, clientId?: number, options?: any) {
            return AdherentParticulierApiFp(configuration).getAdherentParticulier(nom, clientId, options)(axios, basePath);
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc \\n Nom de l\&#39;attribut egal au nom du champ envoye
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {Array<string>} [etatAdhesion] L\&#39;etat de l\&#39;adhesion
         * @param {Array<string>} [siteVendeur] les sites vendeurs
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {string} [categorie] categorie vehicule
         * @param {string} [numeroFidelite] Numero du compte de fidelite du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierAdhesionByCritere(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            page?: number,
            taille?: number,
            tri?: Array<string>,
            adherentParticulierId?: number,
            etatAdhesion?: Array<string>,
            siteVendeur?: Array<string>,
            souscripteurId?: number,
            numeroSerie?: string,
            categorie?: string,
            numeroFidelite?: string,
            options?: any,
        ) {
            return AdherentParticulierApiFp(configuration).getAdherentParticulierAdhesionByCritere(
                grandClientId,
                dateMin,
                dateMax,
                nom,
                immatriculation,
                page,
                taille,
                tri,
                adherentParticulierId,
                etatAdhesion,
                siteVendeur,
                souscripteurId,
                numeroSerie,
                categorie,
                numeroFidelite,
                options,
            )(axios, basePath);
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/{adherentParticulierId}/adhesion
         * @param {string} adherentParticulierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierAdhesionOfAdherent(adherentParticulierId: string, options?: any) {
            return AdherentParticulierApiFp(configuration).getAdherentParticulierAdhesionOfAdherent(
                adherentParticulierId,
                options,
            )(axios, basePath);
        },
        /**
         * Lecture des donnees d\'un particulier a partir de son identifiant
         * @summary GET /adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId Identifiant de l\&#39;adherent particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdherentParticulierById(adherentParticulierId: number, options?: any) {
            return AdherentParticulierApiFp(configuration).getAdherentParticulierById(adherentParticulierId, options)(
                axios,
                basePath,
            );
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin. Pas disponible.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax Pas disponible.
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {Array<string>} [etatAdhesion] etatAdhesion
         * @param {'excel' | 'pdf'} [format] Format du rapport
         * @param {boolean} [infoVehicule] info pour afficher ou non les colonnes vehicule dans extraction de la liste des contrats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAdherentParticulierAdhesion(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            adherentParticulierId?: number,
            souscripteurId?: number,
            numeroSerie?: string,
            etatAdhesion?: Array<string>,
            format?: 'excel' | 'pdf',
            infoVehicule?: boolean,
            options?: any,
        ) {
            return AdherentParticulierApiFp(configuration).getRapportAdherentParticulierAdhesion(
                grandClientId,
                dateMin,
                dateMax,
                nom,
                immatriculation,
                adherentParticulierId,
                souscripteurId,
                numeroSerie,
                etatAdhesion,
                format,
                infoVehicule,
                options,
            )(axios, basePath);
        },
        /**
         *
         * @summary put  /adherentParticulier
         * @param {AdherentParticulier} adherentParticulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifierAdherentParticulier(adherentParticulier: AdherentParticulier, options?: any) {
            return AdherentParticulierApiFp(configuration).modifierAdherentParticulier(adherentParticulier, options)(
                axios,
                basePath,
            );
        },
        /**
         * Modificiations des donnees d\'un particulier
         * @summary PUT /adherentParticulier/{adherentParticulierId}
         * @param {number} adherentParticulierId Identifiant de l\&#39;adherent particulier
         * @param {AdherentParticulier} adherentParticulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdherentParticulierById(adherentParticulierId: number, adherentParticulier: AdherentParticulier, options?: any) {
            return AdherentParticulierApiFp(configuration).putAdherentParticulierById(
                adherentParticulierId,
                adherentParticulier,
                options,
            )(axios, basePath);
        },
    };
};

/**
 * AdherentParticulierApi - object-oriented interface
 * @export
 * @class AdherentParticulierApi
 * @extends {BaseAPI}
 */
export class AdherentParticulierApi extends BaseAPI {
    /**
     * endpoint qui permet de récupérer les informations d\'un adhérentParticulier (ainsi que sa liste d\'adhésion)
     * @summary GET /compte/adherentParticulier/{adherentParticulierId}
     * @param {number} adherentParticulierId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdherentParticulierApi
     */
    public getAdherentById(adherentParticulierId: number, options?: any) {
        return AdherentParticulierApiFp(this.configuration).getAdherentById(adherentParticulierId, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * liste des adherents particuliers
     * @summary GET /adherentParticulier
     * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
     * @param {number} [clientId] Identifiant de la ressource client (site vendeur) permettant de definir le grand client dans lequel sera effectuee la recherche.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdherentParticulierApi
     */
    public getAdherentParticulier(nom?: string, clientId?: number, options?: any) {
        return AdherentParticulierApiFp(this.configuration).getAdherentParticulier(
            nom,
            clientId,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
     * @summary GET /adherentParticulier/adhesion
     * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
     * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin.
     * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax
     * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
     * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
     * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
     * @param {number} [taille] Le nombre d\&#39;éléments à retourner
     * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc \\n Nom de l\&#39;attribut egal au nom du champ envoye
     * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
     * @param {Array<string>} [etatAdhesion] L\&#39;etat de l\&#39;adhesion
     * @param {Array<string>} [siteVendeur] les sites vendeurs
     * @param {number} [souscripteurId]
     * @param {string} [numeroSerie]
     * @param {string} [categorie] categorie vehicule
     * @param {string} [numeroFidelite] Numero du compte de fidelite du particulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdherentParticulierApi
     */
    public getAdherentParticulierAdhesionByCritere(
        grandClientId?: number,
        dateMin?: string,
        dateMax?: string,
        nom?: string,
        immatriculation?: string,
        page?: number,
        taille?: number,
        tri?: Array<string>,
        adherentParticulierId?: number,
        etatAdhesion?: Array<string>,
        siteVendeur?: Array<string>,
        souscripteurId?: number,
        numeroSerie?: string,
        categorie?: string,
        numeroFidelite?: string,
        options?: any,
    ) {
        return AdherentParticulierApiFp(this.configuration).getAdherentParticulierAdhesionByCritere(
            grandClientId,
            dateMin,
            dateMax,
            nom,
            immatriculation,
            page,
            taille,
            tri,
            adherentParticulierId,
            etatAdhesion,
            siteVendeur,
            souscripteurId,
            numeroSerie,
            categorie,
            numeroFidelite,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
     * @summary GET /adherentParticulier/{adherentParticulierId}/adhesion
     * @param {string} adherentParticulierId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdherentParticulierApi
     */
    public getAdherentParticulierAdhesionOfAdherent(adherentParticulierId: string, options?: any) {
        return AdherentParticulierApiFp(this.configuration).getAdherentParticulierAdhesionOfAdherent(
            adherentParticulierId,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Lecture des donnees d\'un particulier a partir de son identifiant
     * @summary GET /adherentParticulier/{adherentParticulierId}
     * @param {number} adherentParticulierId Identifiant de l\&#39;adherent particulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdherentParticulierApi
     */
    public getAdherentParticulierById(adherentParticulierId: number, options?: any) {
        return AdherentParticulierApiFp(this.configuration).getAdherentParticulierById(adherentParticulierId, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
     * @summary GET /adherentParticulier/adhesion
     * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
     * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin. Pas disponible.
     * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax Pas disponible.
     * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
     * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
     * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
     * @param {number} [souscripteurId]
     * @param {string} [numeroSerie]
     * @param {Array<string>} [etatAdhesion] etatAdhesion
     * @param {'excel' | 'pdf'} [format] Format du rapport
     * @param {boolean} [infoVehicule] info pour afficher ou non les colonnes vehicule dans extraction de la liste des contrats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdherentParticulierApi
     */
    public getRapportAdherentParticulierAdhesion(
        grandClientId?: number,
        dateMin?: string,
        dateMax?: string,
        nom?: string,
        immatriculation?: string,
        adherentParticulierId?: number,
        souscripteurId?: number,
        numeroSerie?: string,
        etatAdhesion?: Array<string>,
        format?: 'excel' | 'pdf',
        infoVehicule?: boolean,
        options?: any,
    ) {
        return AdherentParticulierApiFp(this.configuration).getRapportAdherentParticulierAdhesion(
            grandClientId,
            dateMin,
            dateMax,
            nom,
            immatriculation,
            adherentParticulierId,
            souscripteurId,
            numeroSerie,
            etatAdhesion,
            format,
            infoVehicule,
            options,
        )(this.axios, this.basePath);
    }

    /**
     *
     * @summary put  /adherentParticulier
     * @param {AdherentParticulier} adherentParticulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdherentParticulierApi
     */
    public modifierAdherentParticulier(adherentParticulier: AdherentParticulier, options?: any) {
        return AdherentParticulierApiFp(this.configuration).modifierAdherentParticulier(adherentParticulier, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Modificiations des donnees d\'un particulier
     * @summary PUT /adherentParticulier/{adherentParticulierId}
     * @param {number} adherentParticulierId Identifiant de l\&#39;adherent particulier
     * @param {AdherentParticulier} adherentParticulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdherentParticulierApi
     */
    public putAdherentParticulierById(
        adherentParticulierId: number,
        adherentParticulier: AdherentParticulier,
        options?: any,
    ) {
        return AdherentParticulierApiFp(this.configuration).putAdherentParticulierById(
            adherentParticulierId,
            adherentParticulier,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * AdhesionApi - axios parameter creator
 * @export
 */
export const AdhesionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Abondonner signature
         * @summary DELETE /adhesion/{numeroAdhesion}/abandonnerSignature
         * @param {string} numeroAdhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abandonnerSignature(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling abandonnerSignature.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/abandonnerSignature`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer une adhesion au statut \"Incomplet\" ou \"Attente signature\"
         * @summary DELETE /adhesion/{numeroAdhesion}
         * @param {string} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdhesionByNumero(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling deleteAdhesionByNumero.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary demande de résiliation par un particulier de son adhésion
         * @param {string} numeroAdhesion
         * @param {RaisonResiliation} raisonResiliation Informations sur la résiliation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDemanderResiliationAdhesion(numeroAdhesion: string, raisonResiliation: RaisonResiliation, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError('numeroAdhesion', 'Required parameter numeroAdhesion was null or undefined when calling postDemanderResiliationAdhesion.');
            }
            // verify required parameter 'raisonResiliation' is not null or undefined
            if (raisonResiliation === null || raisonResiliation === undefined) {
                throw new RequiredError('raisonResiliation', 'Required parameter raisonResiliation was null or undefined when calling postDemanderResiliationAdhesion.');
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/demanderResiliation`
                .replace(`{${"numeroAdhesion"}}`, encodeURIComponent(String(numeroAdhesion)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization = (typeof raisonResiliation !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(raisonResiliation !== undefined ? raisonResiliation : {}) : (raisonResiliation || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir le bulletin d\'adhesion par numero d\'adhesion particulier
         * @summary GET /adhesion/{numeroAdhesion}/bulletinAdhesion
         * @param {number} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {number} [numeroPage] N° de la premiere page a extraire (première page &#x3D; 1) Par defaut&#x3D;1
         * @param {number} [nbPage] Nombre de pages a extraire - toutes les pages si pas renseigne
         * @param {boolean} [force] Forcer la regeneration du bulletin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdhesionBulletinAdhesionByNumeroAdhesion(
            numeroAdhesion: number,
            numeroPage?: number,
            nbPage?: number,
            force?: boolean,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling getAdhesionBulletinAdhesionByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/bulletinAdhesion`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numeroPage !== undefined) {
                localVarQueryParameter['numeroPage'] = numeroPage;
            }

            if (nbPage !== undefined) {
                localVarQueryParameter['nbPage'] = nbPage;
            }

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recuperer l\'adhesion par numero
         * @summary GET /adhesion/{numeroAdhesion}
         * @param {number} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdhesionByNumero(numeroAdhesion: number, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling getAdhesionByNumero.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retourne le solde et les transactions fidelisation par adhesion
         * @summary GET /adhesion/{numeroAdhesion}/fidelite
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFideliteByNumeroAdhesion(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling getFideliteByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/fidelite`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * retourne les infos sur le renouvellement
         * @summary GET /adhesion/{numeroAdhesion}/renouvellement
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRenouvellementByNumeroAdhesion(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling getRenouvellementByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/renouvellement`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creer une adhesion
         * @summary POST /adhesion
         * @param {AdhesionIn} adhesionIn Donnees de l\&#39;adhesion a creer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesion(adhesionIn: AdhesionIn, options: any = {}): RequestArgs {
            // verify required parameter 'adhesionIn' is not null or undefined
            if (adhesionIn === null || adhesionIn === undefined) {
                throw new RequiredError(
                    'adhesionIn',
                    'Required parameter adhesionIn was null or undefined when calling postAdhesion.',
                );
            }
            const localVarPath = `/adhesion`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof adhesionIn !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(adhesionIn !== undefined ? adhesionIn : {})
                : adhesionIn || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generer le bulletin d\'adhesion par numero d\'adhesion particulier
         * @summary POST /adhesion/{numeroAdhesion}/bulletinAdhesion
         * @param {number} numeroAdhesion numero de l\&#39;adhesion particulier
         * @param {boolean} [force] Forcer la regeneration du bulletin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionBulletinAdhesionByNumeroAdhesion(
            numeroAdhesion: number,
            force?: boolean,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postAdhesionBulletinAdhesionByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/bulletinAdhesion`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Parametrage d\'une adhesion chez les partenaires de SAGA (appel inclus dans le POST /adhesion)
         * @summary POST /adhesion/{numeroAdhesion}/partenaire
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionPartenaireByNumeroAdhesion(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postAdhesionPartenaireByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/partenaire`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de passer etatAdhesion du statut ATTENTE_SIGNATURE a ATTENTE_RECEPTION. Signifie la signature papier du bulletin d\'adhesion par l\'adherent particulier.
         * @summary POST /adhesion/{numeroAdhesion}/valider
         * @param {string} numeroAdhesion numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionValiderByNumeroAdhesion(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postAdhesionValiderByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/valider`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lancer une demande d\'assistance
         * @summary POST /adhesion/{numeroAdhesion}/demanderAssistance
         * @param {number} numeroAdhesion numero de l\&#39;adhesion qui a besoin de depannage
         * @param {DemandeAssistance} demandeAssistance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDemandeAssistanceByNumeroAdhesion(
            numeroAdhesion: number,
            demandeAssistance: DemandeAssistance,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postDemandeAssistanceByNumeroAdhesion.',
                );
            }
            // verify required parameter 'demandeAssistance' is not null or undefined
            if (demandeAssistance === null || demandeAssistance === undefined) {
                throw new RequiredError(
                    'demandeAssistance',
                    'Required parameter demandeAssistance was null or undefined when calling postDemandeAssistanceByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/demanderAssistance`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof demandeAssistance !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(demandeAssistance !== undefined ? demandeAssistance : {})
                : demandeAssistance || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet d\'envoyer le contrat à un adherent avant signature
         * @summary POST /adhesion/{numeroAdhesion}/envoyerContrat
         * @param {string} numeroAdhesion numéro de l\&#39;adhesion concernee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEnvoyerContratByNumeroAdhesion(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postEnvoyerContratByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/envoyerContrat`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Envoi d\'un nouveau sms au signataire avec un nouvel OTP
         * @summary POST /adhesion/{numeroAdhesion}/envoyerSms
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEnvoyerSmsAdhesionById(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postEnvoyerSmsAdhesionById.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/envoyerSms`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de récupérer les informations du formulaire à fabriquer pour le paienement en ligne
         * @summary POST /paiementEnLigne
         * @param {NumeroAdhesion} numeroAdhesion Adhesion en entrée
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaiementEnLigne(numeroAdhesion: NumeroAdhesion, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postPaiementEnLigne.',
                );
            }
            const localVarPath = `/paiementEnLigne`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof numeroAdhesion !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(numeroAdhesion !== undefined ? numeroAdhesion : {})
                : numeroAdhesion || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permet d\'envoyer un sms à l\'adhérent particulier pour le paiement du renouvellement de son adhésion
         * @param {NumeroAdhesion} numeroAdhesion Numéro d\&#39;adhésion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaiementParSms(numeroAdhesion: NumeroAdhesion, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postPaiementParSms.',
                );
            }
            const localVarPath = `/paiementEnLigne/sms`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof numeroAdhesion !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(numeroAdhesion !== undefined ? numeroAdhesion : {})
                : numeroAdhesion || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Envoi du code recu par Sms par le signataire pour valider la signature electronique
         * @summary POST /adhesion/{numeroAdhesion}/saisirOtp
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {SignatureSms} signatureSms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSaisirOtpAdhesionByNumero(numeroAdhesion: string, signatureSms: SignatureSms, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postSaisirOtpAdhesionByNumero.',
                );
            }
            // verify required parameter 'signatureSms' is not null or undefined
            if (signatureSms === null || signatureSms === undefined) {
                throw new RequiredError(
                    'signatureSms',
                    'Required parameter signatureSms was null or undefined when calling postSaisirOtpAdhesionByNumero.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/saisirOtp`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof signatureSms !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(signatureSms !== undefined ? signatureSms : {})
                : signatureSms || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creation d\'une procedure de signature electronique
         * @summary POST /adhesion/{numeroAdhesion}/signer
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {TokenSaga} tokenSaga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSignerAdhesionById(numeroAdhesion: string, tokenSaga: TokenSaga, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postSignerAdhesionById.',
                );
            }
            // verify required parameter 'tokenSaga' is not null or undefined
            if (tokenSaga === null || tokenSaga === undefined) {
                throw new RequiredError(
                    'tokenSaga',
                    'Required parameter tokenSaga was null or undefined when calling postSignerAdhesionById.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/signer`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof tokenSaga !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(tokenSaga !== undefined ? tokenSaga : {})
                : tokenSaga || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * valider le bulletin d\'adhesion du partenaire
         * @summary /adhesion/{numeroAdhesion}/valider/bulletin
         * @param {string} numeroAdhesion Numéro d\&#39;adhésion
         * @param {Fichier} fichier Bulletin d\&#39;adhésion envoyé du partenaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValiderBulletin(numeroAdhesion: string, fichier: Fichier, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postValiderBulletin.',
                );
            }
            // verify required parameter 'fichier' is not null or undefined
            if (fichier === null || fichier === undefined) {
                throw new RequiredError(
                    'fichier',
                    'Required parameter fichier was null or undefined when calling postValiderBulletin.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/valider/bulletin`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof fichier !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(fichier !== undefined ? fichier : {})
                : fichier || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifier l\'adhesion partiellement renseignee
         * @summary PUT /adhesion/{numeroAdhesion}
         * @param {string} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {Adhesion} adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdhesionByNumero(numeroAdhesion: string, adhesion: Adhesion, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling putAdhesionByNumero.',
                );
            }
            // verify required parameter 'adhesion' is not null or undefined
            if (adhesion === null || adhesion === undefined) {
                throw new RequiredError(
                    'adhesion',
                    'Required parameter adhesion was null or undefined when calling putAdhesionByNumero.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof adhesion !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(adhesion !== undefined ? adhesion : {})
                : adhesion || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ajout des infos du mandat a une adhesion
         * @summary PUT /adhesion/{numeroAdhesion}/mandat
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {Mandat} mandat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMandatByNumeroAdhesion(numeroAdhesion: string, mandat: Mandat, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling putMandatByNumeroAdhesion.',
                );
            }
            // verify required parameter 'mandat' is not null or undefined
            if (mandat === null || mandat === undefined) {
                throw new RequiredError(
                    'mandat',
                    'Required parameter mandat was null or undefined when calling putMandatByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/mandat`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof mandat !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(mandat !== undefined ? mandat : {})
                : mandat || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Parametrage d\'une adhesion chez les partenaires de SAGA (appel inclus dans le PUT /adhesion)
         * @summary PUT /adhesion/{numeroAdhesion}/partenaire
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPartenaireByNumeroAdhesion(numeroAdhesion: string, options: any = {}): RequestArgs {
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling putPartenaireByNumeroAdhesion.',
                );
            }
            const localVarPath = `/adhesion/{numeroAdhesion}/partenaire`.replace(
                `{${'numeroAdhesion'}}`,
                encodeURIComponent(String(numeroAdhesion)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * AdhesionApi - functional programming interface
 * @export
 */
export const AdhesionApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Abondonner signature
         * @summary DELETE /adhesion/{numeroAdhesion}/abandonnerSignature
         * @param {string} numeroAdhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abandonnerSignature(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).abandonnerSignature(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Supprimer une adhesion au statut \"Incomplet\" ou \"Attente signature\"
         * @summary DELETE /adhesion/{numeroAdhesion}
         * @param {string} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdhesionByNumero(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adhesion> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).deleteAdhesionByNumero(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary demande de résiliation par un particulier de son adhésion
         * @param {string} numeroAdhesion
         * @param {RaisonResiliation} raisonResiliation Informations sur la résiliation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDemanderResiliationAdhesion(numeroAdhesion: string, raisonResiliation: RaisonResiliation, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postDemanderResiliationAdhesion(numeroAdhesion, raisonResiliation, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtenir le bulletin d\'adhesion par numero d\'adhesion particulier
         * @summary GET /adhesion/{numeroAdhesion}/bulletinAdhesion
         * @param {number} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {number} [numeroPage] N° de la premiere page a extraire (première page &#x3D; 1) Par defaut&#x3D;1
         * @param {number} [nbPage] Nombre de pages a extraire - toutes les pages si pas renseigne
         * @param {boolean} [force] Forcer la regeneration du bulletin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdhesionBulletinAdhesionByNumeroAdhesion(
            numeroAdhesion: number,
            numeroPage?: number,
            nbPage?: number,
            force?: boolean,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).getAdhesionBulletinAdhesionByNumeroAdhesion(
                numeroAdhesion,
                numeroPage,
                nbPage,
                force,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recuperer l\'adhesion par numero
         * @summary GET /adhesion/{numeroAdhesion}
         * @param {number} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdhesionByNumero(
            numeroAdhesion: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adhesion> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).getAdhesionByNumero(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retourne le solde et les transactions fidelisation par adhesion
         * @summary GET /adhesion/{numeroAdhesion}/fidelite
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFideliteByNumeroAdhesion(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fidelite> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).getFideliteByNumeroAdhesion(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * retourne les infos sur le renouvellement
         * @summary GET /adhesion/{numeroAdhesion}/renouvellement
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRenouvellementByNumeroAdhesion(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Renouvellement> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).getRenouvellementByNumeroAdhesion(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Creer une adhesion
         * @summary POST /adhesion
         * @param {AdhesionIn} adhesionIn Donnees de l\&#39;adhesion a creer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesion(
            adhesionIn: AdhesionIn,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adhesion> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postAdhesion(adhesionIn, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Generer le bulletin d\'adhesion par numero d\'adhesion particulier
         * @summary POST /adhesion/{numeroAdhesion}/bulletinAdhesion
         * @param {number} numeroAdhesion numero de l\&#39;adhesion particulier
         * @param {boolean} [force] Forcer la regeneration du bulletin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionBulletinAdhesionByNumeroAdhesion(
            numeroAdhesion: number,
            force?: boolean,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(
                configuration,
            ).postAdhesionBulletinAdhesionByNumeroAdhesion(numeroAdhesion, force, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Parametrage d\'une adhesion chez les partenaires de SAGA (appel inclus dans le POST /adhesion)
         * @summary POST /adhesion/{numeroAdhesion}/partenaire
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionPartenaireByNumeroAdhesion(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postAdhesionPartenaireByNumeroAdhesion(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de passer etatAdhesion du statut ATTENTE_SIGNATURE a ATTENTE_RECEPTION. Signifie la signature papier du bulletin d\'adhesion par l\'adherent particulier.
         * @summary POST /adhesion/{numeroAdhesion}/valider
         * @param {string} numeroAdhesion numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionValiderByNumeroAdhesion(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adhesion> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postAdhesionValiderByNumeroAdhesion(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Lancer une demande d\'assistance
         * @summary POST /adhesion/{numeroAdhesion}/demanderAssistance
         * @param {number} numeroAdhesion numero de l\&#39;adhesion qui a besoin de depannage
         * @param {DemandeAssistance} demandeAssistance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDemandeAssistanceByNumeroAdhesion(
            numeroAdhesion: number,
            demandeAssistance: DemandeAssistance,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UrlDemandeAssistance> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postDemandeAssistanceByNumeroAdhesion(
                numeroAdhesion,
                demandeAssistance,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet d\'envoyer le contrat à un adherent avant signature
         * @summary POST /adhesion/{numeroAdhesion}/envoyerContrat
         * @param {string} numeroAdhesion numéro de l\&#39;adhesion concernee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEnvoyerContratByNumeroAdhesion(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postEnvoyerContratByNumeroAdhesion(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Envoi d\'un nouveau sms au signataire avec un nouvel OTP
         * @summary POST /adhesion/{numeroAdhesion}/envoyerSms
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEnvoyerSmsAdhesionById(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postEnvoyerSmsAdhesionById(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de récupérer les informations du formulaire à fabriquer pour le paienement en ligne
         * @summary POST /paiementEnLigne
         * @param {NumeroAdhesion} numeroAdhesion Adhesion en entrée
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaiementEnLigne(
            numeroAdhesion: NumeroAdhesion,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaireDePaiement> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postPaiementEnLigne(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Permet d\'envoyer un sms à l\'adhérent particulier pour le paiement du renouvellement de son adhésion
         * @param {NumeroAdhesion} numeroAdhesion Numéro d\&#39;adhésion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaiementParSms(
            numeroAdhesion: NumeroAdhesion,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postPaiementParSms(numeroAdhesion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Envoi du code recu par Sms par le signataire pour valider la signature electronique
         * @summary POST /adhesion/{numeroAdhesion}/saisirOtp
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {SignatureSms} signatureSms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSaisirOtpAdhesionByNumero(
            numeroAdhesion: string,
            signatureSms: SignatureSms,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adhesion> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postSaisirOtpAdhesionByNumero(
                numeroAdhesion,
                signatureSms,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Creation d\'une procedure de signature electronique
         * @summary POST /adhesion/{numeroAdhesion}/signer
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {TokenSaga} tokenSaga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSignerAdhesionById(
            numeroAdhesion: string,
            tokenSaga: TokenSaga,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postSignerAdhesionById(
                numeroAdhesion,
                tokenSaga,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * valider le bulletin d\'adhesion du partenaire
         * @summary /adhesion/{numeroAdhesion}/valider/bulletin
         * @param {string} numeroAdhesion Numéro d\&#39;adhésion
         * @param {Fichier} fichier Bulletin d\&#39;adhésion envoyé du partenaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValiderBulletin(
            numeroAdhesion: string,
            fichier: Fichier,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adhesion> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).postValiderBulletin(
                numeroAdhesion,
                fichier,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Modifier l\'adhesion partiellement renseignee
         * @summary PUT /adhesion/{numeroAdhesion}
         * @param {string} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {Adhesion} adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdhesionByNumero(
            numeroAdhesion: string,
            adhesion: Adhesion,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adhesion> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).putAdhesionByNumero(
                numeroAdhesion,
                adhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Ajout des infos du mandat a une adhesion
         * @summary PUT /adhesion/{numeroAdhesion}/mandat
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {Mandat} mandat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMandatByNumeroAdhesion(
            numeroAdhesion: string,
            mandat: Mandat,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).putMandatByNumeroAdhesion(
                numeroAdhesion,
                mandat,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Parametrage d\'une adhesion chez les partenaires de SAGA (appel inclus dans le PUT /adhesion)
         * @summary PUT /adhesion/{numeroAdhesion}/partenaire
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPartenaireByNumeroAdhesion(
            numeroAdhesion: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AdhesionApiAxiosParamCreator(configuration).putPartenaireByNumeroAdhesion(
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * AdhesionApi - factory interface
 * @export
 */
export const AdhesionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Abondonner signature
         * @summary DELETE /adhesion/{numeroAdhesion}/abandonnerSignature
         * @param {string} numeroAdhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abandonnerSignature(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).abandonnerSignature(numeroAdhesion, options)(axios, basePath);
        },
        /**
         * Supprimer une adhesion au statut \"Incomplet\" ou \"Attente signature\"
         * @summary DELETE /adhesion/{numeroAdhesion}
         * @param {string} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdhesionByNumero(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).deleteAdhesionByNumero(numeroAdhesion, options)(axios, basePath);
        },
        /**
         *
         * @summary demande de résiliation par un particulier de son adhésion
         * @param {string} numeroAdhesion
         * @param {RaisonResiliation} raisonResiliation Informations sur la résiliation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDemanderResiliationAdhesion(numeroAdhesion: string, raisonResiliation: RaisonResiliation, options?: any) {
            return AdhesionApiFp(configuration).postDemanderResiliationAdhesion(numeroAdhesion, raisonResiliation, options)(axios, basePath);
        },
        /**
         * Obtenir le bulletin d\'adhesion par numero d\'adhesion particulier
         * @summary GET /adhesion/{numeroAdhesion}/bulletinAdhesion
         * @param {number} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {number} [numeroPage] N° de la premiere page a extraire (première page &#x3D; 1) Par defaut&#x3D;1
         * @param {number} [nbPage] Nombre de pages a extraire - toutes les pages si pas renseigne
         * @param {boolean} [force] Forcer la regeneration du bulletin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdhesionBulletinAdhesionByNumeroAdhesion(
            numeroAdhesion: number,
            numeroPage?: number,
            nbPage?: number,
            force?: boolean,
            options?: any,
        ) {
            return AdhesionApiFp(configuration).getAdhesionBulletinAdhesionByNumeroAdhesion(
                numeroAdhesion,
                numeroPage,
                nbPage,
                force,
                options,
            )(axios, basePath);
        },
        /**
         * Recuperer l\'adhesion par numero
         * @summary GET /adhesion/{numeroAdhesion}
         * @param {number} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdhesionByNumero(numeroAdhesion: number, options?: any) {
            return AdhesionApiFp(configuration).getAdhesionByNumero(numeroAdhesion, options)(axios, basePath);
        },
        /**
         * Retourne le solde et les transactions fidelisation par adhesion
         * @summary GET /adhesion/{numeroAdhesion}/fidelite
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFideliteByNumeroAdhesion(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).getFideliteByNumeroAdhesion(numeroAdhesion, options)(axios, basePath);
        },
        /**
         * retourne les infos sur le renouvellement
         * @summary GET /adhesion/{numeroAdhesion}/renouvellement
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRenouvellementByNumeroAdhesion(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).getRenouvellementByNumeroAdhesion(numeroAdhesion, options)(axios, basePath);
        },
        /**
         * Creer une adhesion
         * @summary POST /adhesion
         * @param {AdhesionIn} adhesionIn Donnees de l\&#39;adhesion a creer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesion(adhesionIn: AdhesionIn, options?: any) {
            return AdhesionApiFp(configuration).postAdhesion(adhesionIn, options)(axios, basePath);
        },
        /**
         * Generer le bulletin d\'adhesion par numero d\'adhesion particulier
         * @summary POST /adhesion/{numeroAdhesion}/bulletinAdhesion
         * @param {number} numeroAdhesion numero de l\&#39;adhesion particulier
         * @param {boolean} [force] Forcer la regeneration du bulletin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionBulletinAdhesionByNumeroAdhesion(numeroAdhesion: number, force?: boolean, options?: any) {
            return AdhesionApiFp(configuration).postAdhesionBulletinAdhesionByNumeroAdhesion(
                numeroAdhesion,
                force,
                options,
            )(axios, basePath);
        },
        /**
         * Parametrage d\'une adhesion chez les partenaires de SAGA (appel inclus dans le POST /adhesion)
         * @summary POST /adhesion/{numeroAdhesion}/partenaire
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionPartenaireByNumeroAdhesion(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).postAdhesionPartenaireByNumeroAdhesion(numeroAdhesion, options)(
                axios,
                basePath,
            );
        },
        /**
         * Permet de passer etatAdhesion du statut ATTENTE_SIGNATURE a ATTENTE_RECEPTION. Signifie la signature papier du bulletin d\'adhesion par l\'adherent particulier.
         * @summary POST /adhesion/{numeroAdhesion}/valider
         * @param {string} numeroAdhesion numero de l\&#39;adhesion particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdhesionValiderByNumeroAdhesion(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).postAdhesionValiderByNumeroAdhesion(numeroAdhesion, options)(axios, basePath);
        },
        /**
         * Lancer une demande d\'assistance
         * @summary POST /adhesion/{numeroAdhesion}/demanderAssistance
         * @param {number} numeroAdhesion numero de l\&#39;adhesion qui a besoin de depannage
         * @param {DemandeAssistance} demandeAssistance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDemandeAssistanceByNumeroAdhesion(numeroAdhesion: number, demandeAssistance: DemandeAssistance, options?: any) {
            return AdhesionApiFp(configuration).postDemandeAssistanceByNumeroAdhesion(
                numeroAdhesion,
                demandeAssistance,
                options,
            )(axios, basePath);
        },
        /**
         * Permet d\'envoyer le contrat à un adherent avant signature
         * @summary POST /adhesion/{numeroAdhesion}/envoyerContrat
         * @param {string} numeroAdhesion numéro de l\&#39;adhesion concernee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEnvoyerContratByNumeroAdhesion(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).postEnvoyerContratByNumeroAdhesion(numeroAdhesion, options)(axios, basePath);
        },
        /**
         * Envoi d\'un nouveau sms au signataire avec un nouvel OTP
         * @summary POST /adhesion/{numeroAdhesion}/envoyerSms
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEnvoyerSmsAdhesionById(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).postEnvoyerSmsAdhesionById(numeroAdhesion, options)(axios, basePath);
        },
        /**
         * Permet de récupérer les informations du formulaire à fabriquer pour le paienement en ligne
         * @summary POST /paiementEnLigne
         * @param {NumeroAdhesion} numeroAdhesion Adhesion en entrée
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaiementEnLigne(numeroAdhesion: NumeroAdhesion, options?: any) {
            return AdhesionApiFp(configuration).postPaiementEnLigne(numeroAdhesion, options)(axios, basePath);
        },
        /**
         *
         * @summary Permet d\'envoyer un sms à l\'adhérent particulier pour le paiement du renouvellement de son adhésion
         * @param {NumeroAdhesion} numeroAdhesion Numéro d\&#39;adhésion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaiementParSms(numeroAdhesion: NumeroAdhesion, options?: any) {
            return AdhesionApiFp(configuration).postPaiementParSms(numeroAdhesion, options)(axios, basePath);
        },
        /**
         * Envoi du code recu par Sms par le signataire pour valider la signature electronique
         * @summary POST /adhesion/{numeroAdhesion}/saisirOtp
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {SignatureSms} signatureSms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSaisirOtpAdhesionByNumero(numeroAdhesion: string, signatureSms: SignatureSms, options?: any) {
            return AdhesionApiFp(configuration).postSaisirOtpAdhesionByNumero(
                numeroAdhesion,
                signatureSms,
                options,
            )(axios, basePath);
        },
        /**
         * Creation d\'une procedure de signature electronique
         * @summary POST /adhesion/{numeroAdhesion}/signer
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {TokenSaga} tokenSaga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSignerAdhesionById(numeroAdhesion: string, tokenSaga: TokenSaga, options?: any) {
            return AdhesionApiFp(configuration).postSignerAdhesionById(numeroAdhesion, tokenSaga, options)(axios, basePath);
        },
        /**
         * valider le bulletin d\'adhesion du partenaire
         * @summary /adhesion/{numeroAdhesion}/valider/bulletin
         * @param {string} numeroAdhesion Numéro d\&#39;adhésion
         * @param {Fichier} fichier Bulletin d\&#39;adhésion envoyé du partenaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValiderBulletin(numeroAdhesion: string, fichier: Fichier, options?: any) {
            return AdhesionApiFp(configuration).postValiderBulletin(numeroAdhesion, fichier, options)(axios, basePath);
        },
        /**
         * Modifier l\'adhesion partiellement renseignee
         * @summary PUT /adhesion/{numeroAdhesion}
         * @param {string} numeroAdhesion Numero de l\&#39;adhesion particulier
         * @param {Adhesion} adhesion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdhesionByNumero(numeroAdhesion: string, adhesion: Adhesion, options?: any) {
            return AdhesionApiFp(configuration).putAdhesionByNumero(numeroAdhesion, adhesion, options)(axios, basePath);
        },
        /**
         * Ajout des infos du mandat a une adhesion
         * @summary PUT /adhesion/{numeroAdhesion}/mandat
         * @param {string} numeroAdhesion numero d\&#39;adhesion
         * @param {Mandat} mandat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMandatByNumeroAdhesion(numeroAdhesion: string, mandat: Mandat, options?: any) {
            return AdhesionApiFp(configuration).putMandatByNumeroAdhesion(numeroAdhesion, mandat, options)(axios, basePath);
        },
        /**
         * Parametrage d\'une adhesion chez les partenaires de SAGA (appel inclus dans le PUT /adhesion)
         * @summary PUT /adhesion/{numeroAdhesion}/partenaire
         * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPartenaireByNumeroAdhesion(numeroAdhesion: string, options?: any) {
            return AdhesionApiFp(configuration).putPartenaireByNumeroAdhesion(numeroAdhesion, options)(axios, basePath);
        },
    };
};

/**
 * AdhesionApi - object-oriented interface
 * @export
 * @class AdhesionApi
 * @extends {BaseAPI}
 */
export class AdhesionApi extends BaseAPI {
    /**
     * Abondonner signature
     * @summary DELETE /adhesion/{numeroAdhesion}/abandonnerSignature
     * @param {string} numeroAdhesion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public abandonnerSignature(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).abandonnerSignature(numeroAdhesion, options)(this.axios, this.basePath);
    }

    /**
     * Supprimer une adhesion au statut \"Incomplet\" ou \"Attente signature\"
     * @summary DELETE /adhesion/{numeroAdhesion}
     * @param {string} numeroAdhesion Numero de l\&#39;adhesion particulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public deleteAdhesionByNumero(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).deleteAdhesionByNumero(numeroAdhesion, options)(this.axios, this.basePath);
    }

    /**
     *
     * @summary demande de résiliation par un particulier de son adhésion
     * @param {string} numeroAdhesion
     * @param {RaisonResiliation} raisonResiliation Informations sur la résiliation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postDemanderResiliationAdhesion(numeroAdhesion: string, raisonResiliation: RaisonResiliation, options?: any) {
        return AdhesionApiFp(this.configuration).postDemanderResiliationAdhesion(numeroAdhesion, raisonResiliation, options)(this.axios, this.basePath);
    }

    /**
     * Obtenir le bulletin d\'adhesion par numero d\'adhesion particulier
     * @summary GET /adhesion/{numeroAdhesion}/bulletinAdhesion
     * @param {number} numeroAdhesion Numero de l\&#39;adhesion particulier
     * @param {number} [numeroPage] N° de la premiere page a extraire (première page &#x3D; 1) Par defaut&#x3D;1
     * @param {number} [nbPage] Nombre de pages a extraire - toutes les pages si pas renseigne
     * @param {boolean} [force] Forcer la regeneration du bulletin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public getAdhesionBulletinAdhesionByNumeroAdhesion(
        numeroAdhesion: number,
        numeroPage?: number,
        nbPage?: number,
        force?: boolean,
        options?: any,
    ) {
        return AdhesionApiFp(this.configuration).getAdhesionBulletinAdhesionByNumeroAdhesion(
            numeroAdhesion,
            numeroPage,
            nbPage,
            force,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Recuperer l\'adhesion par numero
     * @summary GET /adhesion/{numeroAdhesion}
     * @param {number} numeroAdhesion Numero de l\&#39;adhesion particulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public getAdhesionByNumero(numeroAdhesion: number, options?: any) {
        return AdhesionApiFp(this.configuration).getAdhesionByNumero(numeroAdhesion, options)(this.axios, this.basePath);
    }

    /**
     * Retourne le solde et les transactions fidelisation par adhesion
     * @summary GET /adhesion/{numeroAdhesion}/fidelite
     * @param {string} numeroAdhesion numero d\&#39;adhesion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public getFideliteByNumeroAdhesion(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).getFideliteByNumeroAdhesion(numeroAdhesion, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * retourne les infos sur le renouvellement
     * @summary GET /adhesion/{numeroAdhesion}/renouvellement
     * @param {string} numeroAdhesion numero d\&#39;adhesion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public getRenouvellementByNumeroAdhesion(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).getRenouvellementByNumeroAdhesion(numeroAdhesion, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Creer une adhesion
     * @summary POST /adhesion
     * @param {AdhesionIn} adhesionIn Donnees de l\&#39;adhesion a creer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postAdhesion(adhesionIn: AdhesionIn, options?: any) {
        return AdhesionApiFp(this.configuration).postAdhesion(adhesionIn, options)(this.axios, this.basePath);
    }

    /**
     * Generer le bulletin d\'adhesion par numero d\'adhesion particulier
     * @summary POST /adhesion/{numeroAdhesion}/bulletinAdhesion
     * @param {number} numeroAdhesion numero de l\&#39;adhesion particulier
     * @param {boolean} [force] Forcer la regeneration du bulletin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postAdhesionBulletinAdhesionByNumeroAdhesion(numeroAdhesion: number, force?: boolean, options?: any) {
        return AdhesionApiFp(this.configuration).postAdhesionBulletinAdhesionByNumeroAdhesion(
            numeroAdhesion,
            force,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Parametrage d\'une adhesion chez les partenaires de SAGA (appel inclus dans le POST /adhesion)
     * @summary POST /adhesion/{numeroAdhesion}/partenaire
     * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postAdhesionPartenaireByNumeroAdhesion(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).postAdhesionPartenaireByNumeroAdhesion(numeroAdhesion, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Permet de passer etatAdhesion du statut ATTENTE_SIGNATURE a ATTENTE_RECEPTION. Signifie la signature papier du bulletin d\'adhesion par l\'adherent particulier.
     * @summary POST /adhesion/{numeroAdhesion}/valider
     * @param {string} numeroAdhesion numero de l\&#39;adhesion particulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postAdhesionValiderByNumeroAdhesion(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).postAdhesionValiderByNumeroAdhesion(numeroAdhesion, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Lancer une demande d\'assistance
     * @summary POST /adhesion/{numeroAdhesion}/demanderAssistance
     * @param {number} numeroAdhesion numero de l\&#39;adhesion qui a besoin de depannage
     * @param {DemandeAssistance} demandeAssistance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postDemandeAssistanceByNumeroAdhesion(
        numeroAdhesion: number,
        demandeAssistance: DemandeAssistance,
        options?: any,
    ) {
        return AdhesionApiFp(this.configuration).postDemandeAssistanceByNumeroAdhesion(
            numeroAdhesion,
            demandeAssistance,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Permet d\'envoyer le contrat à un adherent avant signature
     * @summary POST /adhesion/{numeroAdhesion}/envoyerContrat
     * @param {string} numeroAdhesion numéro de l\&#39;adhesion concernee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postEnvoyerContratByNumeroAdhesion(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).postEnvoyerContratByNumeroAdhesion(numeroAdhesion, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Envoi d\'un nouveau sms au signataire avec un nouvel OTP
     * @summary POST /adhesion/{numeroAdhesion}/envoyerSms
     * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postEnvoyerSmsAdhesionById(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).postEnvoyerSmsAdhesionById(numeroAdhesion, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Permet de récupérer les informations du formulaire à fabriquer pour le paienement en ligne
     * @summary POST /paiementEnLigne
     * @param {NumeroAdhesion} numeroAdhesion Adhesion en entrée
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postPaiementEnLigne(numeroAdhesion: NumeroAdhesion, options?: any) {
        return AdhesionApiFp(this.configuration).postPaiementEnLigne(numeroAdhesion, options)(this.axios, this.basePath);
    }

    /**
     *
     * @summary Permet d\'envoyer un sms à l\'adhérent particulier pour le paiement du renouvellement de son adhésion
     * @param {NumeroAdhesion} numeroAdhesion Numéro d\&#39;adhésion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postPaiementParSms(numeroAdhesion: NumeroAdhesion, options?: any) {
        return AdhesionApiFp(this.configuration).postPaiementParSms(numeroAdhesion, options)(this.axios, this.basePath);
    }

    /**
     * Envoi du code recu par Sms par le signataire pour valider la signature electronique
     * @summary POST /adhesion/{numeroAdhesion}/saisirOtp
     * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
     * @param {SignatureSms} signatureSms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postSaisirOtpAdhesionByNumero(numeroAdhesion: string, signatureSms: SignatureSms, options?: any) {
        return AdhesionApiFp(this.configuration).postSaisirOtpAdhesionByNumero(
            numeroAdhesion,
            signatureSms,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Creation d\'une procedure de signature electronique
     * @summary POST /adhesion/{numeroAdhesion}/signer
     * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
     * @param {TokenSaga} tokenSaga
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postSignerAdhesionById(numeroAdhesion: string, tokenSaga: TokenSaga, options?: any) {
        return AdhesionApiFp(this.configuration).postSignerAdhesionById(
            numeroAdhesion,
            tokenSaga,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * valider le bulletin d\'adhesion du partenaire
     * @summary /adhesion/{numeroAdhesion}/valider/bulletin
     * @param {string} numeroAdhesion Numéro d\&#39;adhésion
     * @param {Fichier} fichier Bulletin d\&#39;adhésion envoyé du partenaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public postValiderBulletin(numeroAdhesion: string, fichier: Fichier, options?: any) {
        return AdhesionApiFp(this.configuration).postValiderBulletin(
            numeroAdhesion,
            fichier,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Modifier l\'adhesion partiellement renseignee
     * @summary PUT /adhesion/{numeroAdhesion}
     * @param {string} numeroAdhesion Numero de l\&#39;adhesion particulier
     * @param {Adhesion} adhesion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public putAdhesionByNumero(numeroAdhesion: string, adhesion: Adhesion, options?: any) {
        return AdhesionApiFp(this.configuration).putAdhesionByNumero(
            numeroAdhesion,
            adhesion,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Ajout des infos du mandat a une adhesion
     * @summary PUT /adhesion/{numeroAdhesion}/mandat
     * @param {string} numeroAdhesion numero d\&#39;adhesion
     * @param {Mandat} mandat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public putMandatByNumeroAdhesion(numeroAdhesion: string, mandat: Mandat, options?: any) {
        return AdhesionApiFp(this.configuration).putMandatByNumeroAdhesion(
            numeroAdhesion,
            mandat,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Parametrage d\'une adhesion chez les partenaires de SAGA (appel inclus dans le PUT /adhesion)
     * @summary PUT /adhesion/{numeroAdhesion}/partenaire
     * @param {string} numeroAdhesion Numero d\&#39;adhesion du particulier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdhesionApi
     */
    public putPartenaireByNumeroAdhesion(numeroAdhesion: string, options?: any) {
        return AdhesionApiFp(this.configuration).putPartenaireByNumeroAdhesion(numeroAdhesion, options)(
            this.axios,
            this.basePath,
        );
    }
}

/**
 * CategorieApi - axios parameter creator
 * @export
 */
export const CategorieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Recherche des categorie de vehicule applicable a un client pour un programme et a un date donnee.
         * @summary GET /categorie/recherche
         * @param {number} clientId Id de la resssource client
         * @param {string} dateEffet Date d\&#39;effet de l\&#39;adhesion
         * @param {string} codeProgramme code commercial du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorieRecherche(clientId: number, dateEffet: string, codeProgramme: string, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getCategorieRecherche.',
                );
            }
            // verify required parameter 'dateEffet' is not null or undefined
            if (dateEffet === null || dateEffet === undefined) {
                throw new RequiredError(
                    'dateEffet',
                    'Required parameter dateEffet was null or undefined when calling getCategorieRecherche.',
                );
            }
            // verify required parameter 'codeProgramme' is not null or undefined
            if (codeProgramme === null || codeProgramme === undefined) {
                throw new RequiredError(
                    'codeProgramme',
                    'Required parameter codeProgramme was null or undefined when calling getCategorieRecherche.',
                );
            }
            const localVarPath = `/categorie/recherche`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (dateEffet !== undefined) {
                localVarQueryParameter['dateEffet'] =
                    (dateEffet as any) instanceof Date ? (dateEffet as any).toISOString().substr(0, 10) : dateEffet;
            }

            if (codeProgramme !== undefined) {
                localVarQueryParameter['codeProgramme'] = codeProgramme;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * CategorieApi - functional programming interface
 * @export
 */
export const CategorieApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Recherche des categorie de vehicule applicable a un client pour un programme et a un date donnee.
         * @summary GET /categorie/recherche
         * @param {number} clientId Id de la resssource client
         * @param {string} dateEffet Date d\&#39;effet de l\&#39;adhesion
         * @param {string} codeProgramme code commercial du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorieRecherche(
            clientId: number,
            dateEffet: string,
            codeProgramme: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Categorie>> {
            const localVarAxiosArgs = CategorieApiAxiosParamCreator(configuration).getCategorieRecherche(
                clientId,
                dateEffet,
                codeProgramme,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * CategorieApi - factory interface
 * @export
 */
export const CategorieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Recherche des categorie de vehicule applicable a un client pour un programme et a un date donnee.
         * @summary GET /categorie/recherche
         * @param {number} clientId Id de la resssource client
         * @param {string} dateEffet Date d\&#39;effet de l\&#39;adhesion
         * @param {string} codeProgramme code commercial du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorieRecherche(clientId: number, dateEffet: string, codeProgramme: string, options?: any) {
            return CategorieApiFp(configuration).getCategorieRecherche(
                clientId,
                dateEffet,
                codeProgramme,
                options,
            )(axios, basePath);
        },
    };
};

/**
 * CategorieApi - object-oriented interface
 * @export
 * @class CategorieApi
 * @extends {BaseAPI}
 */
export class CategorieApi extends BaseAPI {
    /**
     * Recherche des categorie de vehicule applicable a un client pour un programme et a un date donnee.
     * @summary GET /categorie/recherche
     * @param {number} clientId Id de la resssource client
     * @param {string} dateEffet Date d\&#39;effet de l\&#39;adhesion
     * @param {string} codeProgramme code commercial du programme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategorieApi
     */
    public getCategorieRecherche(clientId: number, dateEffet: string, codeProgramme: string, options?: any) {
        return CategorieApiFp(this.configuration).getCategorieRecherche(
            clientId,
            dateEffet,
            codeProgramme,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint qui envoie à Saga un mail de demande de contact
         * @summary POST /demanderContact
         * @param {DemandeContact} demandeContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demanderContact(demandeContact: DemandeContact, options: any = {}): RequestArgs {
            // verify required parameter 'demandeContact' is not null or undefined
            if (demandeContact === null || demandeContact === undefined) {
                throw new RequiredError(
                    'demandeContact',
                    'Required parameter demandeContact was null or undefined when calling demanderContact.',
                );
            }
            const localVarPath = `/demanderContact`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof demandeContact !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(demandeContact !== undefined ? demandeContact : {})
                : demandeContact || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de rechercher des clients pour un grand client ou un souscripteur ayant eu un contrat avec SAGA filtre=EXERCICE pour avoir les clients ayant un contrat en cours
         * @summary GET /client
         * @param {number} [souscripteurId] Identifiant du souscritpeur sur lequel filtrer les clients adherent
         * @param {number} [grandClientId] Identifiant du client ayant le role de grand client
         * @param {string} [filtre]  EXERCICE: Une convention doit etre valable sur l\&#39;annee civile en cours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient(souscripteurId?: number, grandClientId?: number, filtre?: string, options: any = {}): RequestArgs {
            const localVarPath = `/client`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (souscripteurId !== undefined) {
                localVarQueryParameter['souscripteurId'] = souscripteurId;
            }

            if (grandClientId !== undefined) {
                localVarQueryParameter['grandClientId'] = grandClientId;
            }

            if (filtre !== undefined) {
                localVarQueryParameter['filtre'] = filtre;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retourne la liste des clients rattachés au grand client en paramètre dont les clients résiliés :
         * @summary GET /client/administration
         * @param {number} grandClientId
         * @param {number} [souscripteurId] Id d\&#39;un souscripteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAdministrationByGrandClientId(
            grandClientId: number,
            souscripteurId?: number,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'grandClientId' is not null or undefined
            if (grandClientId === null || grandClientId === undefined) {
                throw new RequiredError(
                    'grandClientId',
                    'Required parameter grandClientId was null or undefined when calling getClientAdministrationByGrandClientId.',
                );
            }
            const localVarPath = `/client/administration/{grandClientId}`.replace(
                `{${'grandClientId'}}`,
                encodeURIComponent(String(grandClientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (souscripteurId !== undefined) {
                localVarQueryParameter['souscripteurId'] = souscripteurId;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECIEE - Lecture d\'une ressource client
         * @summary GET /client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientByClientId(clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getClientByClientId.',
                );
            }
            const localVarPath = `/client/{clientId}`.replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la iiste des clients ayant un contrat valide appartenant au reseau d\'un utilisateur. L\'utilisateur en question a le droit de modifier les donnees des clients dans cette liste.
         * @summary GET /client/utilisateur/{login}/reseau
         * @param {string} login Identifiant de l\&#39;utilisateur
         * @param {number} [souscripteurId] Identifiant du souscritpeur sur lequel filtrer les clients du reseau de l\&#39;utilisateur.
         * @param {number} [grandClientId] ROLE SAGA Identifiant du client ayant le role de grand client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientReseauByUtilisateur(
            login: string,
            souscripteurId?: number,
            grandClientId?: number,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError(
                    'login',
                    'Required parameter login was null or undefined when calling getClientReseauByUtilisateur.',
                );
            }
            const localVarPath = `/client/utilisateur/{login}/reseau`.replace(
                `{${'login'}}`,
                encodeURIComponent(String(login)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (souscripteurId !== undefined) {
                localVarQueryParameter['souscripteurId'] = souscripteurId;
            }

            if (grandClientId !== undefined) {
                localVarQueryParameter['grandClientId'] = grandClientId;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la iiste des clients appartenant au reseau d\'un client
         * @summary GET /client/{clientId}/reseau
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientReseauByidAndDate(clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getClientReseauByidAndDate.',
                );
            }
            const localVarPath = `/client/{clientId}/reseau`.replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Renvoie la liste des clients etant de type Souscripteur avec un contrat actif
         * @summary GET /client/souscripteur
         * @param {number} [clientId] identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientSouscripteur(clientId?: number, options: any = {}): RequestArgs {
            const localVarPath = `/client/souscripteur`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Renvoie la liste des clients etant de type Grand client avec un contrat actif
         * @summary GET /client/grandClient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandClient(options: any = {}): RequestArgs {
            const localVarPath = `/client/grandClient`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Renvoie la liste des clients etant de type Grand client y compris ceux resilie
         * @summary GET /client/grandClient/resilie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandClientResilie(options: any = {}): RequestArgs {
            const localVarPath = `/client/grandClient/resilie`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recuperer modele carte par id du client
         * @summary GET /client/{clientId}/modeleCarte
         * @param {number} clientId id du client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeleCarteByClientId(clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getModeleCarteByClientId.',
                );
            }
            const localVarPath = `/client/{clientId}/modeleCarte`.replace(
                `{${'clientId'}}`,
                encodeURIComponent(String(clientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint qui envoie à Saga un mail de demande de contact
         * @summary POST /demanderContact
         * @param {DemandeContact} demandeContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demanderContact(
            demandeContact: DemandeContact,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).demanderContact(demandeContact, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de rechercher des clients pour un grand client ou un souscripteur ayant eu un contrat avec SAGA filtre=EXERCICE pour avoir les clients ayant un contrat en cours
         * @summary GET /client
         * @param {number} [souscripteurId] Identifiant du souscritpeur sur lequel filtrer les clients adherent
         * @param {number} [grandClientId] Identifiant du client ayant le role de grand client
         * @param {string} [filtre]  EXERCICE: Une convention doit etre valable sur l\&#39;annee civile en cours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient(
            souscripteurId?: number,
            grandClientId?: number,
            filtre?: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getClient(
                souscripteurId,
                grandClientId,
                filtre,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retourne la liste des clients rattachés au grand client en paramètre dont les clients résiliés :
         * @summary GET /client/administration
         * @param {number} grandClientId
         * @param {number} [souscripteurId] Id d\&#39;un souscripteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAdministrationByGrandClientId(
            grandClientId: number,
            souscripteurId?: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientAdministration>> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getClientAdministrationByGrandClientId(
                grandClientId,
                souscripteurId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * DEPRECIEE - Lecture d\'une ressource client
         * @summary GET /client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientByClientId(
            clientId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getClientByClientId(clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtenir la iiste des clients ayant un contrat valide appartenant au reseau d\'un utilisateur. L\'utilisateur en question a le droit de modifier les donnees des clients dans cette liste.
         * @summary GET /client/utilisateur/{login}/reseau
         * @param {string} login Identifiant de l\&#39;utilisateur
         * @param {number} [souscripteurId] Identifiant du souscritpeur sur lequel filtrer les clients du reseau de l\&#39;utilisateur.
         * @param {number} [grandClientId] ROLE SAGA Identifiant du client ayant le role de grand client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientReseauByUtilisateur(
            login: string,
            souscripteurId?: number,
            grandClientId?: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getClientReseauByUtilisateur(
                login,
                souscripteurId,
                grandClientId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtenir la iiste des clients appartenant au reseau d\'un client
         * @summary GET /client/{clientId}/reseau
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientReseauByidAndDate(
            clientId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getClientReseauByidAndDate(clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Renvoie la liste des clients etant de type Souscripteur avec un contrat actif
         * @summary GET /client/souscripteur
         * @param {number} [clientId] identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientSouscripteur(
            clientId?: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getClientSouscripteur(clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Renvoie la liste des clients etant de type Grand client avec un contrat actif
         * @summary GET /client/grandClient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandClient(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getGrandClient(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Renvoie la liste des clients etant de type Grand client y compris ceux resilie
         * @summary GET /client/grandClient/resilie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandClientResilie(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getGrandClientResilie(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recuperer modele carte par id du client
         * @summary GET /client/{clientId}/modeleCarte
         * @param {number} clientId id du client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeleCarteByClientId(
            clientId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModeleCarte>> {
            const localVarAxiosArgs = ClientApiAxiosParamCreator(configuration).getModeleCarteByClientId(clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Endpoint qui envoie à Saga un mail de demande de contact
         * @summary POST /demanderContact
         * @param {DemandeContact} demandeContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demanderContact(demandeContact: DemandeContact, options?: any) {
            return ClientApiFp(configuration).demanderContact(demandeContact, options)(axios, basePath);
        },
        /**
         * Permet de rechercher des clients pour un grand client ou un souscripteur ayant eu un contrat avec SAGA filtre=EXERCICE pour avoir les clients ayant un contrat en cours
         * @summary GET /client
         * @param {number} [souscripteurId] Identifiant du souscritpeur sur lequel filtrer les clients adherent
         * @param {number} [grandClientId] Identifiant du client ayant le role de grand client
         * @param {string} [filtre]  EXERCICE: Une convention doit etre valable sur l\&#39;annee civile en cours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient(souscripteurId?: number, grandClientId?: number, filtre?: string, options?: any) {
            return ClientApiFp(configuration).getClient(souscripteurId, grandClientId, filtre, options)(axios, basePath);
        },
        /**
         * Retourne la liste des clients rattachés au grand client en paramètre dont les clients résiliés :
         * @summary GET /client/administration
         * @param {number} grandClientId
         * @param {number} [souscripteurId] Id d\&#39;un souscripteur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAdministrationByGrandClientId(grandClientId: number, souscripteurId?: number, options?: any) {
            return ClientApiFp(configuration).getClientAdministrationByGrandClientId(
                grandClientId,
                souscripteurId,
                options,
            )(axios, basePath);
        },
        /**
         * DEPRECIEE - Lecture d\'une ressource client
         * @summary GET /client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientByClientId(clientId: number, options?: any) {
            return ClientApiFp(configuration).getClientByClientId(clientId, options)(axios, basePath);
        },
        /**
         * Obtenir la iiste des clients ayant un contrat valide appartenant au reseau d\'un utilisateur. L\'utilisateur en question a le droit de modifier les donnees des clients dans cette liste.
         * @summary GET /client/utilisateur/{login}/reseau
         * @param {string} login Identifiant de l\&#39;utilisateur
         * @param {number} [souscripteurId] Identifiant du souscritpeur sur lequel filtrer les clients du reseau de l\&#39;utilisateur.
         * @param {number} [grandClientId] ROLE SAGA Identifiant du client ayant le role de grand client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientReseauByUtilisateur(login: string, souscripteurId?: number, grandClientId?: number, options?: any) {
            return ClientApiFp(configuration).getClientReseauByUtilisateur(
                login,
                souscripteurId,
                grandClientId,
                options,
            )(axios, basePath);
        },
        /**
         * Obtenir la iiste des clients appartenant au reseau d\'un client
         * @summary GET /client/{clientId}/reseau
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientReseauByidAndDate(clientId: number, options?: any) {
            return ClientApiFp(configuration).getClientReseauByidAndDate(clientId, options)(axios, basePath);
        },
        /**
         * Renvoie la liste des clients etant de type Souscripteur avec un contrat actif
         * @summary GET /client/souscripteur
         * @param {number} [clientId] identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientSouscripteur(clientId?: number, options?: any) {
            return ClientApiFp(configuration).getClientSouscripteur(clientId, options)(axios, basePath);
        },
        /**
         * Renvoie la liste des clients etant de type Grand client avec un contrat actif
         * @summary GET /client/grandClient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandClient(options?: any) {
            return ClientApiFp(configuration).getGrandClient(options)(axios, basePath);
        },
        /**
         * Renvoie la liste des clients etant de type Grand client y compris ceux resilie
         * @summary GET /client/grandClient/resilie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandClientResilie(options?: any) {
            return ClientApiFp(configuration).getGrandClientResilie(options)(axios, basePath);
        },
        /**
         * Recuperer modele carte par id du client
         * @summary GET /client/{clientId}/modeleCarte
         * @param {number} clientId id du client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeleCarteByClientId(clientId: number, options?: any) {
            return ClientApiFp(configuration).getModeleCarteByClientId(clientId, options)(axios, basePath);
        },
    };
};

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * Endpoint qui envoie à Saga un mail de demande de contact
     * @summary POST /demanderContact
     * @param {DemandeContact} demandeContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public demanderContact(demandeContact: DemandeContact, options?: any) {
        return ClientApiFp(this.configuration).demanderContact(demandeContact, options)(this.axios, this.basePath);
    }

    /**
     * Permet de rechercher des clients pour un grand client ou un souscripteur ayant eu un contrat avec SAGA filtre=EXERCICE pour avoir les clients ayant un contrat en cours
     * @summary GET /client
     * @param {number} [souscripteurId] Identifiant du souscritpeur sur lequel filtrer les clients adherent
     * @param {number} [grandClientId] Identifiant du client ayant le role de grand client
     * @param {string} [filtre]  EXERCICE: Une convention doit etre valable sur l\&#39;annee civile en cours.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClient(souscripteurId?: number, grandClientId?: number, filtre?: string, options?: any) {
        return ClientApiFp(this.configuration).getClient(
            souscripteurId,
            grandClientId,
            filtre,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Retourne la liste des clients rattachés au grand client en paramètre dont les clients résiliés :
     * @summary GET /client/administration
     * @param {number} grandClientId
     * @param {number} [souscripteurId] Id d\&#39;un souscripteur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClientAdministrationByGrandClientId(grandClientId: number, souscripteurId?: number, options?: any) {
        return ClientApiFp(this.configuration).getClientAdministrationByGrandClientId(
            grandClientId,
            souscripteurId,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * DEPRECIEE - Lecture d\'une ressource client
     * @summary GET /client/{clientId}
     * @param {number} clientId Identifiant de la ressource client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClientByClientId(clientId: number, options?: any) {
        return ClientApiFp(this.configuration).getClientByClientId(clientId, options)(this.axios, this.basePath);
    }

    /**
     * Obtenir la iiste des clients ayant un contrat valide appartenant au reseau d\'un utilisateur. L\'utilisateur en question a le droit de modifier les donnees des clients dans cette liste.
     * @summary GET /client/utilisateur/{login}/reseau
     * @param {string} login Identifiant de l\&#39;utilisateur
     * @param {number} [souscripteurId] Identifiant du souscritpeur sur lequel filtrer les clients du reseau de l\&#39;utilisateur.
     * @param {number} [grandClientId] ROLE SAGA Identifiant du client ayant le role de grand client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClientReseauByUtilisateur(login: string, souscripteurId?: number, grandClientId?: number, options?: any) {
        return ClientApiFp(this.configuration).getClientReseauByUtilisateur(
            login,
            souscripteurId,
            grandClientId,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Obtenir la iiste des clients appartenant au reseau d\'un client
     * @summary GET /client/{clientId}/reseau
     * @param {number} clientId Identifiant de la ressource client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClientReseauByidAndDate(clientId: number, options?: any) {
        return ClientApiFp(this.configuration).getClientReseauByidAndDate(clientId, options)(this.axios, this.basePath);
    }

    /**
     * Renvoie la liste des clients etant de type Souscripteur avec un contrat actif
     * @summary GET /client/souscripteur
     * @param {number} [clientId] identifiant de la ressource client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClientSouscripteur(clientId?: number, options?: any) {
        return ClientApiFp(this.configuration).getClientSouscripteur(clientId, options)(this.axios, this.basePath);
    }

    /**
     * Renvoie la liste des clients etant de type Grand client avec un contrat actif
     * @summary GET /client/grandClient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getGrandClient(options?: any) {
        return ClientApiFp(this.configuration).getGrandClient(options)(this.axios, this.basePath);
    }

    /**
     * Renvoie la liste des clients etant de type Grand client y compris ceux resilie
     * @summary GET /client/grandClient/resilie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getGrandClientResilie(options?: any) {
        return ClientApiFp(this.configuration).getGrandClientResilie(options)(this.axios, this.basePath);
    }

    /**
     * Recuperer modele carte par id du client
     * @summary GET /client/{clientId}/modeleCarte
     * @param {number} clientId id du client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getModeleCarteByClientId(clientId: number, options?: any) {
        return ClientApiFp(this.configuration).getModeleCarteByClientId(clientId, options)(this.axios, this.basePath);
    }

}

/**
 * CompteApi - axios parameter creator
 * @export
 */
export const CompteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Permet de rechercher des comptes en fonction du critere de recherche.
         * @summary GET /compte
         * @param {string} [nom] nom de l\&#39;adherent particulier
         * @param {string} [email] email de l\&#39;adherent particulier
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] champs de tri
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompteByCritere(
            nom?: string,
            email?: string,
            page?: number,
            taille?: number,
            tri?: Array<string>,
            options: any = {},
        ): RequestArgs {
            const localVarPath = `/compte`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (taille !== undefined) {
                localVarQueryParameter['taille'] = taille;
            }

            if (tri) {
                localVarQueryParameter['tri'] = tri;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recuperation info compte particulier
         * @summary GET /compte
         * @param {string} login correspond au numero d\&#39;adhesion avec lequel le particulier a cree son compte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompteByLogin(login: string, options: any = {}): RequestArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError(
                    'login',
                    'Required parameter login was null or undefined when calling getCompteByLogin.',
                );
            }
            const localVarPath = `/compte/{login}`.replace(`{${'login'}}`, encodeURIComponent(String(login)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ajout d\'un contrat à un CompteParticulier
         * @summary POST /compte/{login}/ajouterAdherent
         * @param {string} login login du compte
         * @param {NumeroAdhesion} numeroAdhesion Le numeroAdhesion d\&#39;une adhésion de l\&#39;adhérent que l\&#39;on souhaite ajouter au compte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAjouterAdherentByNumeroAdhesion(login: string, numeroAdhesion: NumeroAdhesion, options: any = {}): RequestArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError(
                    'login',
                    'Required parameter login was null or undefined when calling postAjouterAdherentByNumeroAdhesion.',
                );
            }
            // verify required parameter 'numeroAdhesion' is not null or undefined
            if (numeroAdhesion === null || numeroAdhesion === undefined) {
                throw new RequiredError(
                    'numeroAdhesion',
                    'Required parameter numeroAdhesion was null or undefined when calling postAjouterAdherentByNumeroAdhesion.',
                );
            }
            const localVarPath = `/compte/{login}/ajouterAdherent`.replace(`{${'login'}}`, encodeURIComponent(String(login)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof numeroAdhesion !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(numeroAdhesion !== undefined ? numeroAdhesion : {})
                : numeroAdhesion || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creation d\'un compte
         * @summary POST /compte
         * @param {CreationCompte} creationCompte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompte(creationCompte: CreationCompte, options: any = {}): RequestArgs {
            // verify required parameter 'creationCompte' is not null or undefined
            if (creationCompte === null || creationCompte === undefined) {
                throw new RequiredError(
                    'creationCompte',
                    'Required parameter creationCompte was null or undefined when calling postCompte.',
                );
            }
            const localVarPath = `/compte`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof creationCompte !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(creationCompte !== undefined ? creationCompte : {})
                : creationCompte || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Détacher un contrat à un CompteParticulier
         * @summary PUT /compte/{login}/detacherAdherent
         * @param {string} login login du compte
         * @param {DetacherAdherent} [detacherAdherent] ok
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDetacherAdherentByNumeroAdhesion(
            login: string,
            detacherAdherent?: DetacherAdherent,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError(
                    'login',
                    'Required parameter login was null or undefined when calling putDetacherAdherentByNumeroAdhesion.',
                );
            }
            const localVarPath = `/compte/{login}/detacherAdherent`.replace(
                `{${'login'}}`,
                encodeURIComponent(String(login)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof detacherAdherent !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(detacherAdherent !== undefined ? detacherAdherent : {})
                : detacherAdherent || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * CompteApi - functional programming interface
 * @export
 */
export const CompteApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Permet de rechercher des comptes en fonction du critere de recherche.
         * @summary GET /compte
         * @param {string} [nom] nom de l\&#39;adherent particulier
         * @param {string} [email] email de l\&#39;adherent particulier
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] champs de tri
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompteByCritere(
            nom?: string,
            email?: string,
            page?: number,
            taille?: number,
            tri?: Array<string>,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListePageCompteParticulierRecherche> {
            const localVarAxiosArgs = CompteApiAxiosParamCreator(configuration).getCompteByCritere(
                nom,
                email,
                page,
                taille,
                tri,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Recuperation info compte particulier
         * @summary GET /compte
         * @param {string} login correspond au numero d\&#39;adhesion avec lequel le particulier a cree son compte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompteByLogin(
            login: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompteParticulierResponse> {
            const localVarAxiosArgs = CompteApiAxiosParamCreator(configuration).getCompteByLogin(login, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Ajout d\'un contrat à un CompteParticulier
         * @summary POST /compte/{login}/ajouterAdherent
         * @param {string} login login du compte
         * @param {NumeroAdhesion} numeroAdhesion Le numeroAdhesion d\&#39;une adhésion de l\&#39;adhérent que l\&#39;on souhaite ajouter au compte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAjouterAdherentByNumeroAdhesion(
            login: string,
            numeroAdhesion: NumeroAdhesion,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompteApiAxiosParamCreator(configuration).postAjouterAdherentByNumeroAdhesion(
                login,
                numeroAdhesion,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Creation d\'un compte
         * @summary POST /compte
         * @param {CreationCompte} creationCompte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompte(
            creationCompte: CreationCompte,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompteParticulier> {
            const localVarAxiosArgs = CompteApiAxiosParamCreator(configuration).postCompte(creationCompte, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Détacher un contrat à un CompteParticulier
         * @summary PUT /compte/{login}/detacherAdherent
         * @param {string} login login du compte
         * @param {DetacherAdherent} [detacherAdherent] ok
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDetacherAdherentByNumeroAdhesion(
            login: string,
            detacherAdherent?: DetacherAdherent,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompteApiAxiosParamCreator(configuration).putDetacherAdherentByNumeroAdhesion(
                login,
                detacherAdherent,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * CompteApi - factory interface
 * @export
 */
export const CompteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Permet de rechercher des comptes en fonction du critere de recherche.
         * @summary GET /compte
         * @param {string} [nom] nom de l\&#39;adherent particulier
         * @param {string} [email] email de l\&#39;adherent particulier
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] champs de tri
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompteByCritere(
            nom?: string,
            email?: string,
            page?: number,
            taille?: number,
            tri?: Array<string>,
            options?: any,
        ) {
            return CompteApiFp(configuration).getCompteByCritere(nom, email, page, taille, tri, options)(axios, basePath);
        },
        /**
         * Recuperation info compte particulier
         * @summary GET /compte
         * @param {string} login correspond au numero d\&#39;adhesion avec lequel le particulier a cree son compte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompteByLogin(login: string, options?: any) {
            return CompteApiFp(configuration).getCompteByLogin(login, options)(axios, basePath);
        },
        /**
         * Ajout d\'un contrat à un CompteParticulier
         * @summary POST /compte/{login}/ajouterAdherent
         * @param {string} login login du compte
         * @param {NumeroAdhesion} numeroAdhesion Le numeroAdhesion d\&#39;une adhésion de l\&#39;adhérent que l\&#39;on souhaite ajouter au compte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAjouterAdherentByNumeroAdhesion(login: string, numeroAdhesion: NumeroAdhesion, options?: any) {
            return CompteApiFp(configuration).postAjouterAdherentByNumeroAdhesion(
                login,
                numeroAdhesion,
                options,
            )(axios, basePath);
        },
        /**
         * Creation d\'un compte
         * @summary POST /compte
         * @param {CreationCompte} creationCompte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompte(creationCompte: CreationCompte, options?: any) {
            return CompteApiFp(configuration).postCompte(creationCompte, options)(axios, basePath);
        },
        /**
         * Détacher un contrat à un CompteParticulier
         * @summary PUT /compte/{login}/detacherAdherent
         * @param {string} login login du compte
         * @param {DetacherAdherent} [detacherAdherent] ok
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDetacherAdherentByNumeroAdhesion(login: string, detacherAdherent?: DetacherAdherent, options?: any) {
            return CompteApiFp(configuration).putDetacherAdherentByNumeroAdhesion(
                login,
                detacherAdherent,
                options,
            )(axios, basePath);
        },
    };
};

/**
 * CompteApi - object-oriented interface
 * @export
 * @class CompteApi
 * @extends {BaseAPI}
 */
export class CompteApi extends BaseAPI {
    /**
     * Permet de rechercher des comptes en fonction du critere de recherche.
     * @summary GET /compte
     * @param {string} [nom] nom de l\&#39;adherent particulier
     * @param {string} [email] email de l\&#39;adherent particulier
     * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
     * @param {number} [taille] Le nombre d\&#39;éléments à retourner
     * @param {Array<string>} [tri] champs de tri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompteApi
     */
    public getCompteByCritere(
        nom?: string,
        email?: string,
        page?: number,
        taille?: number,
        tri?: Array<string>,
        options?: any,
    ) {
        return CompteApiFp(this.configuration).getCompteByCritere(
            nom,
            email,
            page,
            taille,
            tri,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Recuperation info compte particulier
     * @summary GET /compte
     * @param {string} login correspond au numero d\&#39;adhesion avec lequel le particulier a cree son compte
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompteApi
     */
    public getCompteByLogin(login: string, options?: any) {
        return CompteApiFp(this.configuration).getCompteByLogin(login, options)(this.axios, this.basePath);
    }

    /**
     * Ajout d\'un contrat à un CompteParticulier
     * @summary POST /compte/{login}/ajouterAdherent
     * @param {string} login login du compte
     * @param {NumeroAdhesion} numeroAdhesion Le numeroAdhesion d\&#39;une adhésion de l\&#39;adhérent que l\&#39;on souhaite ajouter au compte
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompteApi
     */
    public postAjouterAdherentByNumeroAdhesion(login: string, numeroAdhesion: NumeroAdhesion, options?: any) {
        return CompteApiFp(this.configuration).postAjouterAdherentByNumeroAdhesion(
            login,
            numeroAdhesion,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Creation d\'un compte
     * @summary POST /compte
     * @param {CreationCompte} creationCompte
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompteApi
     */
    public postCompte(creationCompte: CreationCompte, options?: any) {
        return CompteApiFp(this.configuration).postCompte(creationCompte, options)(this.axios, this.basePath);
    }

    /**
     * Détacher un contrat à un CompteParticulier
     * @summary PUT /compte/{login}/detacherAdherent
     * @param {string} login login du compte
     * @param {DetacherAdherent} [detacherAdherent] ok
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompteApi
     */
    public putDetacherAdherentByNumeroAdhesion(login: string, detacherAdherent?: DetacherAdherent, options?: any) {
        return CompteApiFp(this.configuration).putDetacherAdherentByNumeroAdhesion(
            login,
            detacherAdherent,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * recupere un document par type dans la ged
         * @summary GET /referentiel/document
         * @param {'DECLARATIONSINISTRE'} type type du document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(type: 'DECLARATIONSINISTRE', options: any = {}): RequestArgs {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type', 'Required parameter type was null or undefined when calling getDocument.');
            }
            const localVarPath = `/referentiel/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function (configuration?: Configuration) {
    return {
        /**
         * recupere un document par type dans la ged
         * @summary GET /referentiel/document
         * @param {'DECLARATIONSINISTRE'} type type du document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(
            type: 'DECLARATIONSINISTRE',
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).getDocument(type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * recupere un document par type dans la ged
         * @summary GET /referentiel/document
         * @param {'DECLARATIONSINISTRE'} type type du document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(type: 'DECLARATIONSINISTRE', options?: any) {
            return DocumentApiFp(configuration).getDocument(type, options)(axios, basePath);
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * recupere un document par type dans la ged
     * @summary GET /referentiel/document
     * @param {'DECLARATIONSINISTRE'} type type du document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocument(type: 'DECLARATIONSINISTRE', options?: any) {
        return DocumentApiFp(this.configuration).getDocument(type, options)(this.axios, this.basePath);
    }
}

/**
 * GenreVehiculeApi - axios parameter creator
 * @export
 */
export const GenreVehiculeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des genres de vehicules
         * @summary GET /referentiel/genreVehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielGenreVehicule(options: any = {}): RequestArgs {
            const localVarPath = `/referentiel/genreVehicule`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * GenreVehiculeApi - functional programming interface
 * @export
 */
export const GenreVehiculeApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des genres de vehicules
         * @summary GET /referentiel/genreVehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielGenreVehicule(
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GenreVehicule>> {
            const localVarAxiosArgs = GenreVehiculeApiAxiosParamCreator(configuration).getReferentielGenreVehicule(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * GenreVehiculeApi - factory interface
 * @export
 */
export const GenreVehiculeApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
) {
    return {
        /**
         * Obtenir la liste des genres de vehicules
         * @summary GET /referentiel/genreVehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielGenreVehicule(options?: any) {
            return GenreVehiculeApiFp(configuration).getReferentielGenreVehicule(options)(axios, basePath);
        },
    };
};

/**
 * GenreVehiculeApi - object-oriented interface
 * @export
 * @class GenreVehiculeApi
 * @extends {BaseAPI}
 */
export class GenreVehiculeApi extends BaseAPI {
    /**
     * Obtenir la liste des genres de vehicules
     * @summary GET /referentiel/genreVehicule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenreVehiculeApi
     */
    public getReferentielGenreVehicule(options?: any) {
        return GenreVehiculeApiFp(this.configuration).getReferentielGenreVehicule(options)(this.axios, this.basePath);
    }
}

/**
 * MandatApi - axios parameter creator
 * @export
 */
export const MandatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMandat(options: any = {}): RequestArgs {
            const localVarPath = `/mandat`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verification du mandat SEPA
         * @summary POST /referentiel/sepa/verifier
         * @param {IbanBicResource} ibanBicResource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReferentielVerifierSepa(ibanBicResource: IbanBicResource, options: any = {}): RequestArgs {
            // verify required parameter 'ibanBicResource' is not null or undefined
            if (ibanBicResource === null || ibanBicResource === undefined) {
                throw new RequiredError(
                    'ibanBicResource',
                    'Required parameter ibanBicResource was null or undefined when calling postReferentielVerifierSepa.',
                );
            }
            const localVarPath = `/referentiel/sepa/verifier`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof ibanBicResource !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(ibanBicResource !== undefined ? ibanBicResource : {})
                : ibanBicResource || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * MandatApi - functional programming interface
 * @export
 */
export const MandatApiFp = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMandat(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RumResource> {
            const localVarAxiosArgs = MandatApiAxiosParamCreator(configuration).postMandat(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Verification du mandat SEPA
         * @summary POST /referentiel/sepa/verifier
         * @param {IbanBicResource} ibanBicResource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReferentielVerifierSepa(
            ibanBicResource: IbanBicResource,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = MandatApiAxiosParamCreator(configuration).postReferentielVerifierSepa(
                ibanBicResource,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * MandatApi - factory interface
 * @export
 */
export const MandatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMandat(options?: any) {
            return MandatApiFp(configuration).postMandat(options)(axios, basePath);
        },
        /**
         * Verification du mandat SEPA
         * @summary POST /referentiel/sepa/verifier
         * @param {IbanBicResource} ibanBicResource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReferentielVerifierSepa(ibanBicResource: IbanBicResource, options?: any) {
            return MandatApiFp(configuration).postReferentielVerifierSepa(ibanBicResource, options)(axios, basePath);
        },
    };
};

/**
 * MandatApi - object-oriented interface
 * @export
 * @class MandatApi
 * @extends {BaseAPI}
 */
export class MandatApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandatApi
     */
    public postMandat(options?: any) {
        return MandatApiFp(this.configuration).postMandat(options)(this.axios, this.basePath);
    }

    /**
     * Verification du mandat SEPA
     * @summary POST /referentiel/sepa/verifier
     * @param {IbanBicResource} ibanBicResource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandatApi
     */
    public postReferentielVerifierSepa(ibanBicResource: IbanBicResource, options?: any) {
        return MandatApiFp(this.configuration).postReferentielVerifierSepa(ibanBicResource, options)(
            this.axios,
            this.basePath,
        );
    }
}

/**
 * MarqueVehiculeApi - axios parameter creator
 * @export
 */
export const MarqueVehiculeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des marques de vehicules
         * @summary GET /referentiel/marqueVehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielMarque(options: any = {}): RequestArgs {
            const localVarPath = `/referentiel/marqueVehicule`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * MarqueVehiculeApi - functional programming interface
 * @export
 */
export const MarqueVehiculeApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des marques de vehicules
         * @summary GET /referentiel/marqueVehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielMarque(
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarqueVehicule>> {
            const localVarAxiosArgs = MarqueVehiculeApiAxiosParamCreator(configuration).getReferentielMarque(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * MarqueVehiculeApi - factory interface
 * @export
 */
export const MarqueVehiculeApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
) {
    return {
        /**
         * Obtenir la liste des marques de vehicules
         * @summary GET /referentiel/marqueVehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielMarque(options?: any) {
            return MarqueVehiculeApiFp(configuration).getReferentielMarque(options)(axios, basePath);
        },
    };
};

/**
 * MarqueVehiculeApi - object-oriented interface
 * @export
 * @class MarqueVehiculeApi
 * @extends {BaseAPI}
 */
export class MarqueVehiculeApi extends BaseAPI {
    /**
     * Obtenir la liste des marques de vehicules
     * @summary GET /referentiel/marqueVehicule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarqueVehiculeApi
     */
    public getReferentielMarque(options?: any) {
        return MarqueVehiculeApiFp(this.configuration).getReferentielMarque(options)(this.axios, this.basePath);
    }
}

/**
 * ModeleCarteApi - axios parameter creator
 * @export
 */
export const ModeleCarteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retourne fond de carte en base 64
         * @summary GET /modeleCarte/{refCarte}/fondCarte
         * @param {number} refCarte reference de la carte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFondCarteByModeleCarte(refCarte: number, options: any = {}): RequestArgs {
            // verify required parameter 'refCarte' is not null or undefined
            if (refCarte === null || refCarte === undefined) {
                throw new RequiredError(
                    'refCarte',
                    'Required parameter refCarte was null or undefined when calling getFondCarteByModeleCarte.',
                );
            }
            const localVarPath = `/modeleCarte/{refCarte}/fondCarte`.replace(
                `{${'refCarte'}}`,
                encodeURIComponent(String(refCarte)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modification d\'un fond de carte
         * @summary PUT /modeleCarte/{refCarte}/fondCarte
         * @param {number} refCarte reference de la carte
         * @param {Fichier} fichier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFondCarteByModeleCarte(refCarte: number, fichier: Fichier, options: any = {}): RequestArgs {
            // verify required parameter 'refCarte' is not null or undefined
            if (refCarte === null || refCarte === undefined) {
                throw new RequiredError(
                    'refCarte',
                    'Required parameter refCarte was null or undefined when calling putFondCarteByModeleCarte.',
                );
            }
            // verify required parameter 'fichier' is not null or undefined
            if (fichier === null || fichier === undefined) {
                throw new RequiredError(
                    'fichier',
                    'Required parameter fichier was null or undefined when calling putFondCarteByModeleCarte.',
                );
            }
            const localVarPath = `/modeleCarte/{refCarte}/fondCarte`.replace(
                `{${'refCarte'}}`,
                encodeURIComponent(String(refCarte)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof fichier !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(fichier !== undefined ? fichier : {})
                : fichier || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ModeleCarteApi - functional programming interface
 * @export
 */
export const ModeleCarteApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Retourne fond de carte en base 64
         * @summary GET /modeleCarte/{refCarte}/fondCarte
         * @param {number} refCarte reference de la carte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFondCarteByModeleCarte(
            refCarte: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = ModeleCarteApiAxiosParamCreator(configuration).getFondCarteByModeleCarte(
                refCarte,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Modification d\'un fond de carte
         * @summary PUT /modeleCarte/{refCarte}/fondCarte
         * @param {number} refCarte reference de la carte
         * @param {Fichier} fichier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFondCarteByModeleCarte(
            refCarte: number,
            fichier: Fichier,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = ModeleCarteApiAxiosParamCreator(configuration).putFondCarteByModeleCarte(
                refCarte,
                fichier,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ModeleCarteApi - factory interface
 * @export
 */
export const ModeleCarteApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
) {
    return {
        /**
         * Retourne fond de carte en base 64
         * @summary GET /modeleCarte/{refCarte}/fondCarte
         * @param {number} refCarte reference de la carte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFondCarteByModeleCarte(refCarte: number, options?: any) {
            return ModeleCarteApiFp(configuration).getFondCarteByModeleCarte(refCarte, options)(axios, basePath);
        },
        /**
         * Modification d\'un fond de carte
         * @summary PUT /modeleCarte/{refCarte}/fondCarte
         * @param {number} refCarte reference de la carte
         * @param {Fichier} fichier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFondCarteByModeleCarte(refCarte: number, fichier: Fichier, options?: any) {
            return ModeleCarteApiFp(configuration).putFondCarteByModeleCarte(refCarte, fichier, options)(axios, basePath);
        },
    };
};

/**
 * ModeleCarteApi - object-oriented interface
 * @export
 * @class ModeleCarteApi
 * @extends {BaseAPI}
 */
export class ModeleCarteApi extends BaseAPI {
    /**
     * Retourne fond de carte en base 64
     * @summary GET /modeleCarte/{refCarte}/fondCarte
     * @param {number} refCarte reference de la carte
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModeleCarteApi
     */
    public getFondCarteByModeleCarte(refCarte: number, options?: any) {
        return ModeleCarteApiFp(this.configuration).getFondCarteByModeleCarte(refCarte, options)(this.axios, this.basePath);
    }

    /**
     * Modification d\'un fond de carte
     * @summary PUT /modeleCarte/{refCarte}/fondCarte
     * @param {number} refCarte reference de la carte
     * @param {Fichier} fichier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModeleCarteApi
     */
    public putFondCarteByModeleCarte(refCarte: number, fichier: Fichier, options?: any) {
        return ModeleCarteApiFp(this.configuration).putFondCarteByModeleCarte(
            refCarte,
            fichier,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * MoyenTransportApi - axios parameter creator
 * @export
 */
export const MoyenTransportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Rechercher un vehicule dans le referentiel du SIV par son immatriculation. Ne remonte pas d\'informations en cas d\'immatriculation temporaire
         * @summary GET /moyenTransport/{immatriculation}
         * @param {string} immatriculation Immatriculation du moyen de transport a rechercher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoyenTransportByImmatriculation(immatriculation: string, options: any = {}): RequestArgs {
            // verify required parameter 'immatriculation' is not null or undefined
            if (immatriculation === null || immatriculation === undefined) {
                throw new RequiredError(
                    'immatriculation',
                    'Required parameter immatriculation was null or undefined when calling getMoyenTransportByImmatriculation.',
                );
            }
            const localVarPath = `/moyenTransport/{immatriculation}`.replace(
                `{${'immatriculation'}}`,
                encodeURIComponent(String(immatriculation)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * MoyenTransportApi - functional programming interface
 * @export
 */
export const MoyenTransportApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Rechercher un vehicule dans le referentiel du SIV par son immatriculation. Ne remonte pas d\'informations en cas d\'immatriculation temporaire
         * @summary GET /moyenTransport/{immatriculation}
         * @param {string} immatriculation Immatriculation du moyen de transport a rechercher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoyenTransportByImmatriculation(
            immatriculation: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoyenTransport> {
            const localVarAxiosArgs = MoyenTransportApiAxiosParamCreator(configuration).getMoyenTransportByImmatriculation(
                immatriculation,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * MoyenTransportApi - factory interface
 * @export
 */
export const MoyenTransportApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
) {
    return {
        /**
         * Rechercher un vehicule dans le referentiel du SIV par son immatriculation. Ne remonte pas d\'informations en cas d\'immatriculation temporaire
         * @summary GET /moyenTransport/{immatriculation}
         * @param {string} immatriculation Immatriculation du moyen de transport a rechercher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoyenTransportByImmatriculation(immatriculation: string, options?: any) {
            return MoyenTransportApiFp(configuration).getMoyenTransportByImmatriculation(immatriculation, options)(
                axios,
                basePath,
            );
        },
    };
};

/**
 * MoyenTransportApi - object-oriented interface
 * @export
 * @class MoyenTransportApi
 * @extends {BaseAPI}
 */
export class MoyenTransportApi extends BaseAPI {
    /**
     * Rechercher un vehicule dans le referentiel du SIV par son immatriculation. Ne remonte pas d\'informations en cas d\'immatriculation temporaire
     * @summary GET /moyenTransport/{immatriculation}
     * @param {string} immatriculation Immatriculation du moyen de transport a rechercher
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoyenTransportApi
     */
    public getMoyenTransportByImmatriculation(immatriculation: string, options?: any) {
        return MoyenTransportApiFp(this.configuration).getMoyenTransportByImmatriculation(immatriculation, options)(
            this.axios,
            this.basePath,
        );
    }
}

/**
 * PaysApi - axios parameter creator
 * @export
 */
export const PaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des pays prent dans le referentiel
         * @summary GET /referentiel/pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielPays(options: any = {}): RequestArgs {
            const localVarPath = `/referentiel/pays`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * PaysApi - functional programming interface
 * @export
 */
export const PaysApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des pays prent dans le referentiel
         * @summary GET /referentiel/pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielPays(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pays>> {
            const localVarAxiosArgs = PaysApiAxiosParamCreator(configuration).getReferentielPays(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * PaysApi - factory interface
 * @export
 */
export const PaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Obtenir la liste des pays prent dans le referentiel
         * @summary GET /referentiel/pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielPays(options?: any) {
            return PaysApiFp(configuration).getReferentielPays(options)(axios, basePath);
        },
    };
};

/**
 * PaysApi - object-oriented interface
 * @export
 * @class PaysApi
 * @extends {BaseAPI}
 */
export class PaysApi extends BaseAPI {
    /**
     * Obtenir la liste des pays prent dans le referentiel
     * @summary GET /referentiel/pays
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaysApi
     */
    public getReferentielPays(options?: any) {
        return PaysApiFp(this.configuration).getReferentielPays(options)(this.axios, this.basePath);
    }
}

/**
 * PersonnalisationApi - axios parameter creator
 * @export
 */
export const PersonnalisationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Permet de créer une personnalisation pour un client donné
         * @summary /personnalisation
         * @param {PersonnalisationIn} personnalisationIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonnalisation(personnalisationIn: PersonnalisationIn, options: any = {}): RequestArgs {
            // verify required parameter 'personnalisationIn' is not null or undefined
            if (personnalisationIn === null || personnalisationIn === undefined) {
                throw new RequiredError(
                    'personnalisationIn',
                    'Required parameter personnalisationIn was null or undefined when calling createPersonnalisation.',
                );
            }
            const localVarPath = `/personnalisation`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof personnalisationIn !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(personnalisationIn !== undefined ? personnalisationIn : {})
                : personnalisationIn || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personnalisationId Id de la personnalisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonnalisation(personnalisationId: number, options: any = {}): RequestArgs {
            // verify required parameter 'personnalisationId' is not null or undefined
            if (personnalisationId === null || personnalisationId === undefined) {
                throw new RequiredError(
                    'personnalisationId',
                    'Required parameter personnalisationId was null or undefined when calling deletePersonnalisation.'
                );
            }
            const localVarPath = `/personnalisation/{personnalisationId}`.replace(
                `{${"personnalisationId"}}`,
                encodeURIComponent(String(personnalisationId))
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la personnalisation applicable à un client
         * @summary GET /client/{clientId}/personnalisation
         * @param {number} clientId Identifiant de la ressource client
         * @param {boolean} [loadGedMedia] permet le chargement des logos complémentaires pour la personnalisation, false par défaut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientPersonnalisation(clientId: number, loadGedMedia?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getClientPersonnalisation.',
                );
            }
            const localVarPath = `/client/{clientId}/personnalisation`.replace(
                `{${'clientId'}}`,
                encodeURIComponent(String(clientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (loadGedMedia !== undefined) {
                localVarQueryParameter['loadGedMedia'] = loadGedMedia;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de récupérer une personnalisation en fonction de son id
         * @summary /personnalisation/{personnalisationId}
         * @param {number} personnalisationId Id de la personnalisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonnalisationById(personnalisationId: number, options: any = {}): RequestArgs {
            // verify required parameter 'personnalisationId' is not null or undefined
            if (personnalisationId === null || personnalisationId === undefined) {
                throw new RequiredError(
                    'personnalisationId',
                    'Required parameter personnalisationId was null or undefined when calling getPersonnalisationById.',
                );
            }
            const localVarPath = `/personnalisation/{personnalisationId}`.replace(
                `{${'personnalisationId'}}`,
                encodeURIComponent(String(personnalisationId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GET /compte/{login}/personnalisation
         * @param {string} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonnalisationPart(login: string, options: any = {}): RequestArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError(
                    'login',
                    'Required parameter login was null or undefined when calling getPersonnalisationPart.',
                );
            }
            const localVarPath = `/compte/{login}/personnalisation`.replace(
                `{${'login'}}`,
                encodeURIComponent(String(login)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de récupérer les différents thèmes possible pour la personnalisation
         * @summary GET /referentiel/theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielTheme(options: any = {}): RequestArgs {
            const localVarPath = `/referentiel/theme`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de mettre à jour une personnalisation donnée.
         * @summary /personnalisation/{personnalisationId}
         * @param {number} personnalisationId Id de la personnalisation
         * @param {PersonnalisationIn} personnalisationIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonnalisation(
            personnalisationId: number,
            personnalisationIn: PersonnalisationIn,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'personnalisationId' is not null or undefined
            if (personnalisationId === null || personnalisationId === undefined) {
                throw new RequiredError(
                    'personnalisationId',
                    'Required parameter personnalisationId was null or undefined when calling updatePersonnalisation.',
                );
            }
            // verify required parameter 'personnalisationIn' is not null or undefined
            if (personnalisationIn === null || personnalisationIn === undefined) {
                throw new RequiredError(
                    'personnalisationIn',
                    'Required parameter personnalisationIn was null or undefined when calling updatePersonnalisation.',
                );
            }
            const localVarPath = `/personnalisation/{personnalisationId}`.replace(
                `{${'personnalisationId'}}`,
                encodeURIComponent(String(personnalisationId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof personnalisationIn !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(personnalisationIn !== undefined ? personnalisationIn : {})
                : personnalisationIn || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * PersonnalisationApi - functional programming interface
 * @export
 */
export const PersonnalisationApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Permet de créer une personnalisation pour un client donné
         * @summary /personnalisation
         * @param {PersonnalisationIn} personnalisationIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonnalisation(
            personnalisationIn: PersonnalisationIn,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Personnalisation> {
            const localVarAxiosArgs = PersonnalisationApiAxiosParamCreator(configuration).createPersonnalisation(
                personnalisationIn,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} personnalisationId Id de la personnalisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonnalisation(
            personnalisationId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = PersonnalisationApiAxiosParamCreator(configuration).deletePersonnalisation(
                personnalisationId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtenir la personnalisation applicable à un client
         * @summary GET /client/{clientId}/personnalisation
         * @param {number} clientId Identifiant de la ressource client
         * @param {boolean} [loadGedMedia] permet le chargement des logos complémentaires pour la personnalisation, false par défaut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientPersonnalisation(
            clientId: number,
            loadGedMedia?: boolean,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonnalisationClient> {
            const localVarAxiosArgs = PersonnalisationApiAxiosParamCreator(configuration).getClientPersonnalisation(
                clientId,
                loadGedMedia,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de récupérer une personnalisation en fonction de son id
         * @summary /personnalisation/{personnalisationId}
         * @param {number} personnalisationId Id de la personnalisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonnalisationById(
            personnalisationId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Personnalisation> {
            const localVarAxiosArgs = PersonnalisationApiAxiosParamCreator(configuration).getPersonnalisationById(
                personnalisationId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary GET /compte/{login}/personnalisation
         * @param {string} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonnalisationPart(
            login: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonnalisationClient> {
            const localVarAxiosArgs = PersonnalisationApiAxiosParamCreator(configuration).getPersonnalisationPart(
                login,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de récupérer les différents thèmes possible pour la personnalisation
         * @summary GET /referentiel/theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielTheme(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Theme>> {
            const localVarAxiosArgs = PersonnalisationApiAxiosParamCreator(configuration).getReferentielTheme(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de mettre à jour une personnalisation donnée.
         * @summary /personnalisation/{personnalisationId}
         * @param {number} personnalisationId Id de la personnalisation
         * @param {PersonnalisationIn} personnalisationIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonnalisation(
            personnalisationId: number,
            personnalisationIn: PersonnalisationIn,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Personnalisation> {
            const localVarAxiosArgs = PersonnalisationApiAxiosParamCreator(configuration).updatePersonnalisation(
                personnalisationId,
                personnalisationIn,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * PersonnalisationApi - factory interface
 * @export
 */
export const PersonnalisationApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
) {
    return {
        /**
         * Permet de créer une personnalisation pour un client donné
         * @summary /personnalisation
         * @param {PersonnalisationIn} personnalisationIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonnalisation(personnalisationIn: PersonnalisationIn, options?: any) {
            return PersonnalisationApiFp(configuration).createPersonnalisation(personnalisationIn, options)(axios, basePath);
        },
        /**
         *
         * @param {number} personnalisationId Id de la personnalisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonnalisation(personnalisationId: number, options?: any) {
            return PersonnalisationApiFp(configuration).deletePersonnalisation(personnalisationId, options)(axios, basePath);
        },
        /**
         * Obtenir la personnalisation applicable à un client
         * @summary GET /client/{clientId}/personnalisation
         * @param {number} clientId Identifiant de la ressource client
         * @param {boolean} [loadGedMedia] permet le chargement des logos complémentaires pour la personnalisation, false par défaut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientPersonnalisation(clientId: number, loadGedMedia?: boolean, options?: any) {
            return PersonnalisationApiFp(configuration).getClientPersonnalisation(clientId, loadGedMedia, options)(axios, basePath);
        },
        /**
         * Permet de récupérer une personnalisation en fonction de son id
         * @summary /personnalisation/{personnalisationId}
         * @param {number} personnalisationId Id de la personnalisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonnalisationById(personnalisationId: number, options?: any) {
            return PersonnalisationApiFp(configuration).getPersonnalisationById(personnalisationId, options)(axios, basePath);
        },
        /**
         *
         * @summary GET /compte/{login}/personnalisation
         * @param {string} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonnalisationPart(login: string, options?: any) {
            return PersonnalisationApiFp(configuration).getPersonnalisationPart(login, options)(axios, basePath);
        },
        /**
         * Permet de récupérer les différents thèmes possible pour la personnalisation
         * @summary GET /referentiel/theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielTheme(options?: any) {
            return PersonnalisationApiFp(configuration).getReferentielTheme(options)(axios, basePath);
        },
        /**
         * Permet de mettre à jour une personnalisation donnée.
         * @summary /personnalisation/{personnalisationId}
         * @param {number} personnalisationId Id de la personnalisation
         * @param {PersonnalisationIn} personnalisationIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonnalisation(personnalisationId: number, personnalisationIn: PersonnalisationIn, options?: any) {
            return PersonnalisationApiFp(configuration).updatePersonnalisation(
                personnalisationId,
                personnalisationIn,
                options,
            )(axios, basePath);
        },
    };
};

/**
 * PersonnalisationApi - object-oriented interface
 * @export
 * @class PersonnalisationApi
 * @extends {BaseAPI}
 */
export class PersonnalisationApi extends BaseAPI {
    /**
     * Permet de créer une personnalisation pour un client donné
     * @summary /personnalisation
     * @param {PersonnalisationIn} personnalisationIn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnalisationApi
     */
    public createPersonnalisation(personnalisationIn: PersonnalisationIn, options?: any) {
        return PersonnalisationApiFp(this.configuration).createPersonnalisation(personnalisationIn, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     *
     * @param {number} personnalisationId Id de la personnalisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnalisationApi
     */
    public deletePersonnalisation(personnalisationId: number, options?: any) {
        return PersonnalisationApiFp(this.configuration).deletePersonnalisation(personnalisationId, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Obtenir la personnalisation applicable à un client
     * @summary GET /client/{clientId}/personnalisation
     * @param {number} clientId Identifiant de la ressource client
     * @param {boolean} [loadGedMedia] permet le chargement des logos complémentaires pour la personnalisation, false par défaut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnalisationApi
     */
    public getClientPersonnalisation(clientId: number, loadGedMedia?: boolean, options?: any) {
        return PersonnalisationApiFp(this.configuration).getClientPersonnalisation(clientId, loadGedMedia, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Permet de récupérer une personnalisation en fonction de son id
     * @summary /personnalisation/{personnalisationId}
     * @param {number} personnalisationId Id de la personnalisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnalisationApi
     */
    public getPersonnalisationById(personnalisationId: number, options?: any) {
        return PersonnalisationApiFp(this.configuration).getPersonnalisationById(personnalisationId, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     *
     * @summary GET /compte/{login}/personnalisation
     * @param {string} login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnalisationApi
     */
    public getPersonnalisationPart(login: string, options?: any) {
        return PersonnalisationApiFp(this.configuration).getPersonnalisationPart(login, options)(this.axios, this.basePath);
    }

    /**
     * Permet de récupérer les différents thèmes possible pour la personnalisation
     * @summary GET /referentiel/theme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnalisationApi
     */
    public getReferentielTheme(options?: any) {
        return PersonnalisationApiFp(this.configuration).getReferentielTheme(options)(this.axios, this.basePath);
    }

    /**
     * Permet de mettre à jour une personnalisation donnée.
     * @summary /personnalisation/{personnalisationId}
     * @param {number} personnalisationId Id de la personnalisation
     * @param {PersonnalisationIn} personnalisationIn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnalisationApi
     */
    public updatePersonnalisation(personnalisationId: number, personnalisationIn: PersonnalisationIn, options?: any) {
        return PersonnalisationApiFp(this.configuration).updatePersonnalisation(
            personnalisationId,
            personnalisationIn,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * ProduitApi - axios parameter creator
 * @export
 */
export const ProduitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Suppression d\'un document dans la version courante du produit
         * @summary DELETE /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {'ADHESION' | 'CONDITIONSGENERALES'} typeDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentsProduitByDocumentsId(
            documentsId: number,
            typeDocument: 'ADHESION' | 'CONDITIONSGENERALES',
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'documentsId' is not null or undefined
            if (documentsId === null || documentsId === undefined) {
                throw new RequiredError(
                    'documentsId',
                    'Required parameter documentsId was null or undefined when calling deleteDocumentsProduitByDocumentsId.',
                );
            }
            // verify required parameter 'typeDocument' is not null or undefined
            if (typeDocument === null || typeDocument === undefined) {
                throw new RequiredError(
                    'typeDocument',
                    'Required parameter typeDocument was null or undefined when calling deleteDocumentsProduitByDocumentsId.',
                );
            }
            const localVarPath = `/produit/documents/{documentsId}`.replace(
                `{${'documentsId'}}`,
                encodeURIComponent(String(documentsId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typeDocument !== undefined) {
                localVarQueryParameter['typeDocument'] = typeDocument;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupération d\'un document de la version courante d\'un produit
         * @summary GET /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {'ADHESION' | 'CONDITIONSGENERALES'} typeDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsProduitByDocumentsId(
            documentsId: number,
            typeDocument: 'ADHESION' | 'CONDITIONSGENERALES',
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'documentsId' is not null or undefined
            if (documentsId === null || documentsId === undefined) {
                throw new RequiredError(
                    'documentsId',
                    'Required parameter documentsId was null or undefined when calling getDocumentsProduitByDocumentsId.',
                );
            }
            // verify required parameter 'typeDocument' is not null or undefined
            if (typeDocument === null || typeDocument === undefined) {
                throw new RequiredError(
                    'typeDocument',
                    'Required parameter typeDocument was null or undefined when calling getDocumentsProduitByDocumentsId.',
                );
            }
            const localVarPath = `/produit/documents/{documentsId}`.replace(
                `{${'documentsId'}}`,
                encodeURIComponent(String(documentsId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typeDocument !== undefined) {
                localVarQueryParameter['typeDocument'] = typeDocument;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les infos d\'un produit à partir de son codeProduit
         * @summary GET /produit/{codeProduit}
         * @param {string} codeProduit code du produit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfosProduit(codeProduit: string, options: any = {}): RequestArgs {
            // verify required parameter 'codeProduit' is not null or undefined
            if (codeProduit === null || codeProduit === undefined) {
                throw new RequiredError(
                    'codeProduit',
                    'Required parameter codeProduit was null or undefined when calling getInfosProduit.',
                );
            }
            const localVarPath = `/produit/{codeProduit}`.replace(
                `{${'codeProduit'}}`,
                encodeURIComponent(String(codeProduit)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * liste de tous les produits SAGA
         * @summary GET /produits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduits(options: any = {}): RequestArgs {
            const localVarPath = `/produits`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ajout d\'une nouvelle version des documents d\'un produit
         * @summary POST /produit/{code}/documents
         * @param {string} code code du produit
         * @param {ProduitDocuments} [produitDocuments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentsProduit(code: string, produitDocuments?: ProduitDocuments, options: any = {}): RequestArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError(
                    'code',
                    'Required parameter code was null or undefined when calling postDocumentsProduit.',
                );
            }
            const localVarPath = `/produit/{code}/documents`.replace(`{${'code'}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof produitDocuments !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(produitDocuments !== undefined ? produitDocuments : {})
                : produitDocuments || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modification des documents d\'un produit
         * @summary PUT /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {ProduitDocuments} [produitDocuments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDocumentsProduitByDocumentsId(
            documentsId: number,
            produitDocuments?: ProduitDocuments,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'documentsId' is not null or undefined
            if (documentsId === null || documentsId === undefined) {
                throw new RequiredError(
                    'documentsId',
                    'Required parameter documentsId was null or undefined when calling putDocumentsProduitByDocumentsId.',
                );
            }
            const localVarPath = `/produit/documents/{documentsId}`.replace(
                `{${'documentsId'}}`,
                encodeURIComponent(String(documentsId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof produitDocuments !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(produitDocuments !== undefined ? produitDocuments : {})
                : produitDocuments || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ProduitApi - functional programming interface
 * @export
 */
export const ProduitApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Suppression d\'un document dans la version courante du produit
         * @summary DELETE /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {'ADHESION' | 'CONDITIONSGENERALES'} typeDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentsProduitByDocumentsId(
            documentsId: number,
            typeDocument: 'ADHESION' | 'CONDITIONSGENERALES',
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ProduitApiAxiosParamCreator(configuration).deleteDocumentsProduitByDocumentsId(
                documentsId,
                typeDocument,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Récupération d\'un document de la version courante d\'un produit
         * @summary GET /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {'ADHESION' | 'CONDITIONSGENERALES'} typeDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsProduitByDocumentsId(
            documentsId: number,
            typeDocument: 'ADHESION' | 'CONDITIONSGENERALES',
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = ProduitApiAxiosParamCreator(configuration).getDocumentsProduitByDocumentsId(
                documentsId,
                typeDocument,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Récupérer les infos d\'un produit à partir de son codeProduit
         * @summary GET /produit/{codeProduit}
         * @param {string} codeProduit code du produit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfosProduit(
            codeProduit: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ProduitApiAxiosParamCreator(configuration).getInfosProduit(codeProduit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * liste de tous les produits SAGA
         * @summary GET /produits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduits(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListeProduits>> {
            const localVarAxiosArgs = ProduitApiAxiosParamCreator(configuration).getProduits(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Ajout d\'une nouvelle version des documents d\'un produit
         * @summary POST /produit/{code}/documents
         * @param {string} code code du produit
         * @param {ProduitDocuments} [produitDocuments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentsProduit(
            code: string,
            produitDocuments?: ProduitDocuments,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ProduitApiAxiosParamCreator(configuration).postDocumentsProduit(
                code,
                produitDocuments,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Modification des documents d\'un produit
         * @summary PUT /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {ProduitDocuments} [produitDocuments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDocumentsProduitByDocumentsId(
            documentsId: number,
            produitDocuments?: ProduitDocuments,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ProduitApiAxiosParamCreator(configuration).putDocumentsProduitByDocumentsId(
                documentsId,
                produitDocuments,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ProduitApi - factory interface
 * @export
 */
export const ProduitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Suppression d\'un document dans la version courante du produit
         * @summary DELETE /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {'ADHESION' | 'CONDITIONSGENERALES'} typeDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentsProduitByDocumentsId(
            documentsId: number,
            typeDocument: 'ADHESION' | 'CONDITIONSGENERALES',
            options?: any,
        ) {
            return ProduitApiFp(configuration).deleteDocumentsProduitByDocumentsId(
                documentsId,
                typeDocument,
                options,
            )(axios, basePath);
        },
        /**
         * Récupération d\'un document de la version courante d\'un produit
         * @summary GET /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {'ADHESION' | 'CONDITIONSGENERALES'} typeDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsProduitByDocumentsId(
            documentsId: number,
            typeDocument: 'ADHESION' | 'CONDITIONSGENERALES',
            options?: any,
        ) {
            return ProduitApiFp(configuration).getDocumentsProduitByDocumentsId(
                documentsId,
                typeDocument,
                options,
            )(axios, basePath);
        },
        /**
         * Récupérer les infos d\'un produit à partir de son codeProduit
         * @summary GET /produit/{codeProduit}
         * @param {string} codeProduit code du produit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfosProduit(codeProduit: string, options?: any) {
            return ProduitApiFp(configuration).getInfosProduit(codeProduit, options)(axios, basePath);
        },
        /**
         * liste de tous les produits SAGA
         * @summary GET /produits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduits(options?: any) {
            return ProduitApiFp(configuration).getProduits(options)(axios, basePath);
        },
        /**
         * Ajout d\'une nouvelle version des documents d\'un produit
         * @summary POST /produit/{code}/documents
         * @param {string} code code du produit
         * @param {ProduitDocuments} [produitDocuments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentsProduit(code: string, produitDocuments?: ProduitDocuments, options?: any) {
            return ProduitApiFp(configuration).postDocumentsProduit(code, produitDocuments, options)(axios, basePath);
        },
        /**
         * Modification des documents d\'un produit
         * @summary PUT /produit/documents/{documentsId}
         * @param {number} documentsId
         * @param {ProduitDocuments} [produitDocuments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDocumentsProduitByDocumentsId(documentsId: number, produitDocuments?: ProduitDocuments, options?: any) {
            return ProduitApiFp(configuration).putDocumentsProduitByDocumentsId(
                documentsId,
                produitDocuments,
                options,
            )(axios, basePath);
        },
    };
};

/**
 * ProduitApi - object-oriented interface
 * @export
 * @class ProduitApi
 * @extends {BaseAPI}
 */
export class ProduitApi extends BaseAPI {
    /**
     * Suppression d\'un document dans la version courante du produit
     * @summary DELETE /produit/documents/{documentsId}
     * @param {number} documentsId
     * @param {'ADHESION' | 'CONDITIONSGENERALES'} typeDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProduitApi
     */
    public deleteDocumentsProduitByDocumentsId(
        documentsId: number,
        typeDocument: 'ADHESION' | 'CONDITIONSGENERALES',
        options?: any,
    ) {
        return ProduitApiFp(this.configuration).deleteDocumentsProduitByDocumentsId(
            documentsId,
            typeDocument,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Récupération d\'un document de la version courante d\'un produit
     * @summary GET /produit/documents/{documentsId}
     * @param {number} documentsId
     * @param {'ADHESION' | 'CONDITIONSGENERALES'} typeDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProduitApi
     */
    public getDocumentsProduitByDocumentsId(
        documentsId: number,
        typeDocument: 'ADHESION' | 'CONDITIONSGENERALES',
        options?: any,
    ) {
        return ProduitApiFp(this.configuration).getDocumentsProduitByDocumentsId(
            documentsId,
            typeDocument,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Récupérer les infos d\'un produit à partir de son codeProduit
     * @summary GET /produit/{codeProduit}
     * @param {string} codeProduit code du produit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProduitApi
     */
    public getInfosProduit(codeProduit: string, options?: any) {
        return ProduitApiFp(this.configuration).getInfosProduit(codeProduit, options)(this.axios, this.basePath);
    }

    /**
     * liste de tous les produits SAGA
     * @summary GET /produits
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProduitApi
     */
    public getProduits(options?: any) {
        return ProduitApiFp(this.configuration).getProduits(options)(this.axios, this.basePath);
    }

    /**
     * Ajout d\'une nouvelle version des documents d\'un produit
     * @summary POST /produit/{code}/documents
     * @param {string} code code du produit
     * @param {ProduitDocuments} [produitDocuments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProduitApi
     */
    public postDocumentsProduit(code: string, produitDocuments?: ProduitDocuments, options?: any) {
        return ProduitApiFp(this.configuration).postDocumentsProduit(
            code,
            produitDocuments,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Modification des documents d\'un produit
     * @summary PUT /produit/documents/{documentsId}
     * @param {number} documentsId
     * @param {ProduitDocuments} [produitDocuments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProduitApi
     */
    public putDocumentsProduitByDocumentsId(documentsId: number, produitDocuments?: ProduitDocuments, options?: any) {
        return ProduitApiFp(this.configuration).putDocumentsProduitByDocumentsId(
            documentsId,
            produitDocuments,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * ProgrammeApi - axios parameter creator
 * @export
 */
export const ProgrammeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retourne les informations de contact de l\'assisteur en fonction du code programme
         * @summary GET /programme/{codeProgramme]/assisteur
         * @param {string} codeProgramme code commercial du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssisteurByCodeProgramme(codeProgramme: string, options: any = {}): RequestArgs {
            // verify required parameter 'codeProgramme' is not null or undefined
            if (codeProgramme === null || codeProgramme === undefined) {
                throw new RequiredError(
                    'codeProgramme',
                    'Required parameter codeProgramme was null or undefined when calling getAssisteurByCodeProgramme.',
                );
            }
            const localVarPath = `/programme/{codeProgramme}/assisteur`.replace(
                `{${'codeProgramme'}}`,
                encodeURIComponent(String(codeProgramme)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retourne les infos d\'un programme
         * @summary GET /programme/{codeProgramme}
         * @param {string} codeProgramme Le code du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeByCode(codeProgramme: string, options: any = {}): RequestArgs {
            // verify required parameter 'codeProgramme' is not null or undefined
            if (codeProgramme === null || codeProgramme === undefined) {
                throw new RequiredError(
                    'codeProgramme',
                    'Required parameter codeProgramme was null or undefined when calling getProgrammeByCode.',
                );
            }
            const localVarPath = `/programme/{codeProgramme}`.replace(
                `{${'codeProgramme'}}`,
                encodeURIComponent(String(codeProgramme)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des programmes SAGA accessible a un client
         * @summary GET /programme/client/{clientId}
         * @param {string} clientId Id de la resssource client
         * @param {string} dateEffet Date effet pour la recherche du programme en cours
         * @param {string} [gravage] Filtre sur les programmes avec gravage. \&quot;O\&quot; ou \&quot;N\&quot;, par defaut \&quot;N\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeClientByClientId(
            clientId: string,
            dateEffet: string,
            gravage?: string,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getProgrammeClientByClientId.',
                );
            }
            // verify required parameter 'dateEffet' is not null or undefined
            if (dateEffet === null || dateEffet === undefined) {
                throw new RequiredError(
                    'dateEffet',
                    'Required parameter dateEffet was null or undefined when calling getProgrammeClientByClientId.',
                );
            }
            const localVarPath = `/programme/client/{clientId}`.replace(
                `{${'clientId'}}`,
                encodeURIComponent(String(clientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateEffet !== undefined) {
                localVarQueryParameter['dateEffet'] = dateEffet;
            }

            if (gravage !== undefined) {
                localVarQueryParameter['gravage'] = gravage;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des programmes SAGA accessible a un grand client du client en parametre
         * @summary /programme/client/{clientId}/grandClient
         * @param {number} clientId id de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeGrandClientByClientId(clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getProgrammeGrandClientByClientId.',
                );
            }
            const localVarPath = `/programme/client/{clientId}/grandClient`.replace(
                `{${'clientId'}}`,
                encodeURIComponent(String(clientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ProgrammeApi - functional programming interface
 * @export
 */
export const ProgrammeApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Retourne les informations de contact de l\'assisteur en fonction du code programme
         * @summary GET /programme/{codeProgramme]/assisteur
         * @param {string} codeProgramme code commercial du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssisteurByCodeProgramme(
            codeProgramme: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assisteur> {
            const localVarAxiosArgs = ProgrammeApiAxiosParamCreator(configuration).getAssisteurByCodeProgramme(
                codeProgramme,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retourne les infos d\'un programme
         * @summary GET /programme/{codeProgramme}
         * @param {string} codeProgramme Le code du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeByCode(
            codeProgramme: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Programme> {
            const localVarAxiosArgs = ProgrammeApiAxiosParamCreator(configuration).getProgrammeByCode(codeProgramme, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtenir la liste des programmes SAGA accessible a un client
         * @summary GET /programme/client/{clientId}
         * @param {string} clientId Id de la resssource client
         * @param {string} dateEffet Date effet pour la recherche du programme en cours
         * @param {string} [gravage] Filtre sur les programmes avec gravage. \&quot;O\&quot; ou \&quot;N\&quot;, par defaut \&quot;N\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeClientByClientId(
            clientId: string,
            dateEffet: string,
            gravage?: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Programme>> {
            const localVarAxiosArgs = ProgrammeApiAxiosParamCreator(configuration).getProgrammeClientByClientId(
                clientId,
                dateEffet,
                gravage,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Obtenir la liste des programmes SAGA accessible a un grand client du client en parametre
         * @summary /programme/client/{clientId}/grandClient
         * @param {number} clientId id de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeGrandClientByClientId(
            clientId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Programme>> {
            const localVarAxiosArgs = ProgrammeApiAxiosParamCreator(configuration).getProgrammeGrandClientByClientId(
                clientId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ProgrammeApi - factory interface
 * @export
 */
export const ProgrammeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Retourne les informations de contact de l\'assisteur en fonction du code programme
         * @summary GET /programme/{codeProgramme]/assisteur
         * @param {string} codeProgramme code commercial du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssisteurByCodeProgramme(codeProgramme: string, options?: any) {
            return ProgrammeApiFp(configuration).getAssisteurByCodeProgramme(codeProgramme, options)(axios, basePath);
        },
        /**
         * Retourne les infos d\'un programme
         * @summary GET /programme/{codeProgramme}
         * @param {string} codeProgramme Le code du programme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeByCode(codeProgramme: string, options?: any) {
            return ProgrammeApiFp(configuration).getProgrammeByCode(codeProgramme, options)(axios, basePath);
        },
        /**
         * Obtenir la liste des programmes SAGA accessible a un client
         * @summary GET /programme/client/{clientId}
         * @param {string} clientId Id de la resssource client
         * @param {string} dateEffet Date effet pour la recherche du programme en cours
         * @param {string} [gravage] Filtre sur les programmes avec gravage. \&quot;O\&quot; ou \&quot;N\&quot;, par defaut \&quot;N\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeClientByClientId(clientId: string, dateEffet: string, gravage?: string, options?: any) {
            return ProgrammeApiFp(configuration).getProgrammeClientByClientId(
                clientId,
                dateEffet,
                gravage,
                options,
            )(axios, basePath);
        },
        /**
         * Obtenir la liste des programmes SAGA accessible a un grand client du client en parametre
         * @summary /programme/client/{clientId}/grandClient
         * @param {number} clientId id de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgrammeGrandClientByClientId(clientId: number, options?: any) {
            return ProgrammeApiFp(configuration).getProgrammeGrandClientByClientId(clientId, options)(axios, basePath);
        },
    };
};

/**
 * ProgrammeApi - object-oriented interface
 * @export
 * @class ProgrammeApi
 * @extends {BaseAPI}
 */
export class ProgrammeApi extends BaseAPI {
    /**
     * Retourne les informations de contact de l\'assisteur en fonction du code programme
     * @summary GET /programme/{codeProgramme]/assisteur
     * @param {string} codeProgramme code commercial du programme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgrammeApi
     */
    public getAssisteurByCodeProgramme(codeProgramme: string, options?: any) {
        return ProgrammeApiFp(this.configuration).getAssisteurByCodeProgramme(codeProgramme, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Retourne les infos d\'un programme
     * @summary GET /programme/{codeProgramme}
     * @param {string} codeProgramme Le code du programme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgrammeApi
     */
    public getProgrammeByCode(codeProgramme: string, options?: any) {
        return ProgrammeApiFp(this.configuration).getProgrammeByCode(codeProgramme, options)(this.axios, this.basePath);
    }

    /**
     * Obtenir la liste des programmes SAGA accessible a un client
     * @summary GET /programme/client/{clientId}
     * @param {string} clientId Id de la resssource client
     * @param {string} dateEffet Date effet pour la recherche du programme en cours
     * @param {string} [gravage] Filtre sur les programmes avec gravage. \&quot;O\&quot; ou \&quot;N\&quot;, par defaut \&quot;N\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgrammeApi
     */
    public getProgrammeClientByClientId(clientId: string, dateEffet: string, gravage?: string, options?: any) {
        return ProgrammeApiFp(this.configuration).getProgrammeClientByClientId(
            clientId,
            dateEffet,
            gravage,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Obtenir la liste des programmes SAGA accessible a un grand client du client en parametre
     * @summary /programme/client/{clientId}/grandClient
     * @param {number} clientId id de la ressource client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgrammeApi
     */
    public getProgrammeGrandClientByClientId(clientId: number, options?: any) {
        return ProgrammeApiFp(this.configuration).getProgrammeGrandClientByClientId(clientId, options)(
            this.axios,
            this.basePath,
        );
    }
}

/**
 * RapportApi - axios parameter creator
 * @export
 */
export const RapportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Service d\'appel du reporting de la liste des transactions fid
         * @summary GET /rapport/achat/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} startDate Date de debut
         * @param {string} endDate Date de fin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAchatByGrandClientId(
            grandClientId: number,
            format: string,
            startDate: string,
            endDate: string,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'grandClientId' is not null or undefined
            if (grandClientId === null || grandClientId === undefined) {
                throw new RequiredError(
                    'grandClientId',
                    'Required parameter grandClientId was null or undefined when calling getRapportAchatByGrandClientId.',
                );
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError(
                    'format',
                    'Required parameter format was null or undefined when calling getRapportAchatByGrandClientId.',
                );
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new RequiredError(
                    'startDate',
                    'Required parameter startDate was null or undefined when calling getRapportAchatByGrandClientId.',
                );
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new RequiredError(
                    'endDate',
                    'Required parameter endDate was null or undefined when calling getRapportAchatByGrandClientId.',
                );
            }
            const localVarPath = `/rapport/achat/grandClient/{grandClientId}`.replace(
                `{${'grandClientId'}}`,
                encodeURIComponent(String(grandClientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin. Pas disponible.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax Pas disponible.
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {Array<string>} [etatAdhesion] etatAdhesion
         * @param {'excel' | 'pdf'} [format] Format du rapport
         * @param {boolean} [infoVehicule] info pour afficher ou non les colonnes vehicule dans extraction de la liste des contrats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAdherentParticulierAdhesion(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            adherentParticulierId?: number,
            souscripteurId?: number,
            numeroSerie?: string,
            etatAdhesion?: Array<string>,
            format?: 'excel' | 'pdf',
            infoVehicule?: boolean,
            options: any = {},
        ): RequestArgs {
            const localVarPath = `/adherentParticulier/adhesion/rapport`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (grandClientId !== undefined) {
                localVarQueryParameter['grandClientId'] = grandClientId;
            }

            if (dateMin !== undefined) {
                localVarQueryParameter['dateMin'] =
                    (dateMin as any) instanceof Date ? (dateMin as any).toISOString().substr(0, 10) : dateMin;
            }

            if (dateMax !== undefined) {
                localVarQueryParameter['dateMax'] =
                    (dateMax as any) instanceof Date ? (dateMax as any).toISOString().substr(0, 10) : dateMax;
            }

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            if (immatriculation !== undefined) {
                localVarQueryParameter['immatriculation'] = immatriculation;
            }

            if (adherentParticulierId !== undefined) {
                localVarQueryParameter['adherentParticulierId'] = adherentParticulierId;
            }

            if (souscripteurId !== undefined) {
                localVarQueryParameter['souscripteurId'] = souscripteurId;
            }

            if (numeroSerie !== undefined) {
                localVarQueryParameter['numeroSerie'] = numeroSerie;
            }

            if (etatAdhesion) {
                localVarQueryParameter['etatAdhesion'] = etatAdhesion;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (infoVehicule !== undefined) {
                localVarQueryParameter['infoVehicule'] = infoVehicule;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Service d\'appel de l\'export des ventes (donnees brutes de rapport/vente/grandClient/:grandClientId)
         * @summary GET /rapport/exportVente/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportExportVenteByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'grandClientId' is not null or undefined
            if (grandClientId === null || grandClientId === undefined) {
                throw new RequiredError(
                    'grandClientId',
                    'Required parameter grandClientId was null or undefined when calling getRapportExportVenteByGrandClientId.',
                );
            }
            // verify required parameter 'annee' is not null or undefined
            if (annee === null || annee === undefined) {
                throw new RequiredError(
                    'annee',
                    'Required parameter annee was null or undefined when calling getRapportExportVenteByGrandClientId.',
                );
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError(
                    'format',
                    'Required parameter format was null or undefined when calling getRapportExportVenteByGrandClientId.',
                );
            }
            const localVarPath = `/rapport/exportVente/grandClient/{grandClientId}`.replace(
                `{${'grandClientId'}}`,
                encodeURIComponent(String(grandClientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (login !== undefined) {
                localVarQueryParameter['login'] = login;
            }

            if (annee !== undefined) {
                localVarQueryParameter['annee'] = annee;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Service d\'appel du reporting de suivi des objectifs
         * @summary GET /rapport/objectif/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, ex: \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportObjectifByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'grandClientId' is not null or undefined
            if (grandClientId === null || grandClientId === undefined) {
                throw new RequiredError(
                    'grandClientId',
                    'Required parameter grandClientId was null or undefined when calling getRapportObjectifByGrandClientId.',
                );
            }
            // verify required parameter 'annee' is not null or undefined
            if (annee === null || annee === undefined) {
                throw new RequiredError(
                    'annee',
                    'Required parameter annee was null or undefined when calling getRapportObjectifByGrandClientId.',
                );
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError(
                    'format',
                    'Required parameter format was null or undefined when calling getRapportObjectifByGrandClientId.',
                );
            }
            const localVarPath = `/rapport/objectif/grandClient/{grandClientId}`.replace(
                `{${'grandClientId'}}`,
                encodeURIComponent(String(grandClientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (login !== undefined) {
                localVarQueryParameter['login'] = login;
            }

            if (annee !== undefined) {
                localVarQueryParameter['annee'] = annee;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Service d\'appel du reporting des ventes
         * @summary GET /rapport/vente/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportVenteByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'grandClientId' is not null or undefined
            if (grandClientId === null || grandClientId === undefined) {
                throw new RequiredError(
                    'grandClientId',
                    'Required parameter grandClientId was null or undefined when calling getRapportVenteByGrandClientId.',
                );
            }
            // verify required parameter 'annee' is not null or undefined
            if (annee === null || annee === undefined) {
                throw new RequiredError(
                    'annee',
                    'Required parameter annee was null or undefined when calling getRapportVenteByGrandClientId.',
                );
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError(
                    'format',
                    'Required parameter format was null or undefined when calling getRapportVenteByGrandClientId.',
                );
            }
            const localVarPath = `/rapport/vente/grandClient/{grandClientId}`.replace(
                `{${'grandClientId'}}`,
                encodeURIComponent(String(grandClientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (login !== undefined) {
                localVarQueryParameter['login'] = login;
            }

            if (annee !== undefined) {
                localVarQueryParameter['annee'] = annee;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * RapportApi - functional programming interface
 * @export
 */
export const RapportApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Service d\'appel du reporting de la liste des transactions fid
         * @summary GET /rapport/achat/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} startDate Date de debut
         * @param {string} endDate Date de fin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAchatByGrandClientId(
            grandClientId: number,
            format: string,
            startDate: string,
            endDate: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = RapportApiAxiosParamCreator(configuration).getRapportAchatByGrandClientId(
                grandClientId,
                format,
                startDate,
                endDate,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin. Pas disponible.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax Pas disponible.
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {Array<string>} [etatAdhesion] etatAdhesion
         * @param {'excel' | 'pdf'} [format] Format du rapport
         * @param {boolean} [infoVehicule] info pour afficher ou non les colonnes vehicule dans extraction de la liste des contrats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAdherentParticulierAdhesion(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            adherentParticulierId?: number,
            souscripteurId?: number,
            numeroSerie?: string,
            etatAdhesion?: Array<string>,
            format?: 'excel' | 'pdf',
            infoVehicule?: boolean,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = RapportApiAxiosParamCreator(configuration).getRapportAdherentParticulierAdhesion(
                grandClientId,
                dateMin,
                dateMax,
                nom,
                immatriculation,
                adherentParticulierId,
                souscripteurId,
                numeroSerie,
                etatAdhesion,
                format,
                infoVehicule,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Service d\'appel de l\'export des ventes (donnees brutes de rapport/vente/grandClient/:grandClientId)
         * @summary GET /rapport/exportVente/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportExportVenteByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = RapportApiAxiosParamCreator(configuration).getRapportExportVenteByGrandClientId(
                grandClientId,
                annee,
                format,
                login,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Service d\'appel du reporting de suivi des objectifs
         * @summary GET /rapport/objectif/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, ex: \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportObjectifByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = RapportApiAxiosParamCreator(configuration).getRapportObjectifByGrandClientId(
                grandClientId,
                annee,
                format,
                login,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Service d\'appel du reporting des ventes
         * @summary GET /rapport/vente/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportVenteByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier> {
            const localVarAxiosArgs = RapportApiAxiosParamCreator(configuration).getRapportVenteByGrandClientId(
                grandClientId,
                annee,
                format,
                login,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * RapportApi - factory interface
 * @export
 */
export const RapportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Service d\'appel du reporting de la liste des transactions fid
         * @summary GET /rapport/achat/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} startDate Date de debut
         * @param {string} endDate Date de fin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAchatByGrandClientId(
            grandClientId: number,
            format: string,
            startDate: string,
            endDate: string,
            options?: any,
        ) {
            return RapportApiFp(configuration).getRapportAchatByGrandClientId(
                grandClientId,
                format,
                startDate,
                endDate,
                options,
            )(axios, basePath);
        },
        /**
         * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
         * @summary GET /adherentParticulier/adhesion
         * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin. Pas disponible.
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax Pas disponible.
         * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
         * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
         * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
         * @param {number} [souscripteurId]
         * @param {string} [numeroSerie]
         * @param {Array<string>} [etatAdhesion] etatAdhesion
         * @param {'excel' | 'pdf'} [format] Format du rapport
         * @param {boolean} [infoVehicule] info pour afficher ou non les colonnes vehicule dans extraction de la liste des contrats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAdherentParticulierAdhesion(
            grandClientId?: number,
            dateMin?: string,
            dateMax?: string,
            nom?: string,
            immatriculation?: string,
            adherentParticulierId?: number,
            souscripteurId?: number,
            numeroSerie?: string,
            etatAdhesion?: Array<string>,
            format?: 'excel' | 'pdf',
            infoVehicule?: boolean,
            options?: any,
        ) {
            return RapportApiFp(configuration).getRapportAdherentParticulierAdhesion(
                grandClientId,
                dateMin,
                dateMax,
                nom,
                immatriculation,
                adherentParticulierId,
                souscripteurId,
                numeroSerie,
                etatAdhesion,
                format,
                infoVehicule,
                options,
            )(axios, basePath);
        },
        /**
         * Service d\'appel de l\'export des ventes (donnees brutes de rapport/vente/grandClient/:grandClientId)
         * @summary GET /rapport/exportVente/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportExportVenteByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options?: any,
        ) {
            return RapportApiFp(configuration).getRapportExportVenteByGrandClientId(
                grandClientId,
                annee,
                format,
                login,
                options,
            )(axios, basePath);
        },
        /**
         * Service d\'appel du reporting de suivi des objectifs
         * @summary GET /rapport/objectif/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, ex: \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportObjectifByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options?: any,
        ) {
            return RapportApiFp(configuration).getRapportObjectifByGrandClientId(
                grandClientId,
                annee,
                format,
                login,
                options,
            )(axios, basePath);
        },
        /**
         * Service d\'appel du reporting des ventes
         * @summary GET /rapport/vente/grandClient/{grandClientId}
         * @param {number} grandClientId Identifiant du grand client
         * @param {number} annee Annee du rapport
         * @param {string} format Format du reporting, \&quot;excel\&quot;
         * @param {string} [login] Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportVenteByGrandClientId(
            grandClientId: number,
            annee: number,
            format: string,
            login?: string,
            options?: any,
        ) {
            return RapportApiFp(configuration).getRapportVenteByGrandClientId(
                grandClientId,
                annee,
                format,
                login,
                options,
            )(axios, basePath);
        },
    };
};

/**
 * RapportApi - object-oriented interface
 * @export
 * @class RapportApi
 * @extends {BaseAPI}
 */
export class RapportApi extends BaseAPI {
    /**
     * Service d\'appel du reporting de la liste des transactions fid
     * @summary GET /rapport/achat/grandClient/{grandClientId}
     * @param {number} grandClientId Identifiant du grand client
     * @param {string} format Format du reporting, \&quot;excel\&quot;
     * @param {string} startDate Date de debut
     * @param {string} endDate Date de fin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RapportApi
     */
    public getRapportAchatByGrandClientId(
        grandClientId: number,
        format: string,
        startDate: string,
        endDate: string,
        options?: any,
    ) {
        return RapportApiFp(this.configuration).getRapportAchatByGrandClientId(
            grandClientId,
            format,
            startDate,
            endDate,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Permet de rechercher les clients particulier en fonction du critere de recherche. Affiche la liste des clients particuliers du reseau auquel est rattache l\'utilisateur.
     * @summary GET /adherentParticulier/adhesion
     * @param {number} [grandClientId] Login de l\&#39;utilisateur qui veut effectuer la recherche
     * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin. Pas disponible.
     * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax Pas disponible.
     * @param {string} [nom] Permet de filtrer la recherche sur le nom du particulier (inclus en ignorant la casse). Pas disponible.
     * @param {string} [immatriculation] Permet de filtrer la recherche sur l\&#39;immatriculation du véhicule d\&#39;une des adhesion du particulier. Ignore la casse, les blancs et tirets. Pas disponible.
     * @param {number} [adherentParticulierId] Identifiant de l\&#39;adherent particulier
     * @param {number} [souscripteurId]
     * @param {string} [numeroSerie]
     * @param {Array<string>} [etatAdhesion] etatAdhesion
     * @param {'excel' | 'pdf'} [format] Format du rapport
     * @param {boolean} [infoVehicule] info pour afficher ou non les colonnes vehicule dans extraction de la liste des contrats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RapportApi
     */
    public getRapportAdherentParticulierAdhesion(
        grandClientId?: number,
        dateMin?: string,
        dateMax?: string,
        nom?: string,
        immatriculation?: string,
        adherentParticulierId?: number,
        souscripteurId?: number,
        numeroSerie?: string,
        etatAdhesion?: Array<string>,
        format?: 'excel' | 'pdf',
        infoVehicule?: boolean,
        options?: any,
    ) {
        return RapportApiFp(this.configuration).getRapportAdherentParticulierAdhesion(
            grandClientId,
            dateMin,
            dateMax,
            nom,
            immatriculation,
            adherentParticulierId,
            souscripteurId,
            numeroSerie,
            etatAdhesion,
            format,
            infoVehicule,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Service d\'appel de l\'export des ventes (donnees brutes de rapport/vente/grandClient/:grandClientId)
     * @summary GET /rapport/exportVente/grandClient/{grandClientId}
     * @param {number} grandClientId Identifiant du grand client
     * @param {number} annee Annee du rapport
     * @param {string} format Format du reporting, \&quot;excel\&quot;
     * @param {string} [login] Login de l\&#39;utilisateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RapportApi
     */
    public getRapportExportVenteByGrandClientId(
        grandClientId: number,
        annee: number,
        format: string,
        login?: string,
        options?: any,
    ) {
        return RapportApiFp(this.configuration).getRapportExportVenteByGrandClientId(
            grandClientId,
            annee,
            format,
            login,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Service d\'appel du reporting de suivi des objectifs
     * @summary GET /rapport/objectif/grandClient/{grandClientId}
     * @param {number} grandClientId Identifiant du grand client
     * @param {number} annee Annee du rapport
     * @param {string} format Format du reporting, ex: \&quot;excel\&quot;
     * @param {string} [login] Login de l\&#39;utilisateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RapportApi
     */
    public getRapportObjectifByGrandClientId(
        grandClientId: number,
        annee: number,
        format: string,
        login?: string,
        options?: any,
    ) {
        return RapportApiFp(this.configuration).getRapportObjectifByGrandClientId(
            grandClientId,
            annee,
            format,
            login,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Service d\'appel du reporting des ventes
     * @summary GET /rapport/vente/grandClient/{grandClientId}
     * @param {number} grandClientId Identifiant du grand client
     * @param {number} annee Annee du rapport
     * @param {string} format Format du reporting, \&quot;excel\&quot;
     * @param {string} [login] Login de l\&#39;utilisateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RapportApi
     */
    public getRapportVenteByGrandClientId(
        grandClientId: number,
        annee: number,
        format: string,
        login?: string,
        options?: any,
    ) {
        return RapportApiFp(this.configuration).getRapportVenteByGrandClientId(
            grandClientId,
            annee,
            format,
            login,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * ReseauApi - axios parameter creator
 * @export
 */
export const ReseauApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Permet d\'ajouter une concession a plusieurs utilisateurs
         * @summary PUT /utilisateur/reseau/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurReseauByClientId(clientId: number, requestBody: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling putUtilisateurReseauByClientId.',
                );
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError(
                    'requestBody',
                    'Required parameter requestBody was null or undefined when calling putUtilisateurReseauByClientId.',
                );
            }
            const localVarPath = `/utilisateur/reseau/client/{clientId}`.replace(
                `{${'clientId'}}`,
                encodeURIComponent(String(clientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof requestBody !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(requestBody !== undefined ? requestBody : {})
                : requestBody || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ReseauApi - functional programming interface
 * @export
 */
export const ReseauApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Permet d\'ajouter une concession a plusieurs utilisateurs
         * @summary PUT /utilisateur/reseau/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurReseauByClientId(
            clientId: number,
            requestBody: Array<string>,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ReseauApiAxiosParamCreator(configuration).putUtilisateurReseauByClientId(
                clientId,
                requestBody,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ReseauApi - factory interface
 * @export
 */
export const ReseauApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Permet d\'ajouter une concession a plusieurs utilisateurs
         * @summary PUT /utilisateur/reseau/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurReseauByClientId(clientId: number, requestBody: Array<string>, options?: any) {
            return ReseauApiFp(configuration).putUtilisateurReseauByClientId(clientId, requestBody, options)(axios, basePath);
        },
    };
};

/**
 * ReseauApi - object-oriented interface
 * @export
 * @class ReseauApi
 * @extends {BaseAPI}
 */
export class ReseauApi extends BaseAPI {
    /**
     * Permet d\'ajouter une concession a plusieurs utilisateurs
     * @summary PUT /utilisateur/reseau/client/{clientId}
     * @param {number} clientId Identifiant de la ressource client
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReseauApi
     */
    public putUtilisateurReseauByClientId(clientId: number, requestBody: Array<string>, options?: any) {
        return ReseauApiFp(this.configuration).putUtilisateurReseauByClientId(
            clientId,
            requestBody,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * StockApi - axios parameter creator
 * @export
 */
export const StockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retourner liste des volets A pour le groupe de l\'utilisateur
         * @summary GET /stock
         * @param {number} [grandClientId] Id du grand client de l\&#39;utilisateur
         * @param {number} [taille] le nombre d\&#39;elements a retourner
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc \\n Nom de l\&#39;attribut egal au nom du champ envoye
         * @param {string} [numeroSerie] filtrer la liste des stocks pour afficher que les stocks dont le n° de série court se termine par la combinaison saisie
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin.
         * @param {string} [categorie] Categorie vehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStock(
            grandClientId?: number,
            taille?: number,
            page?: number,
            tri?: Array<string>,
            numeroSerie?: string,
            dateMax?: string,
            dateMin?: string,
            categorie?: string,
            options: any = {},
        ): RequestArgs {
            const localVarPath = `/stock`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (grandClientId !== undefined) {
                localVarQueryParameter['grandClientId'] = grandClientId;
            }

            if (taille !== undefined) {
                localVarQueryParameter['taille'] = taille;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (tri) {
                localVarQueryParameter['tri'] = tri;
            }

            if (numeroSerie !== undefined) {
                localVarQueryParameter['numeroSerie'] = numeroSerie;
            }

            if (dateMax !== undefined) {
                localVarQueryParameter['dateMax'] = dateMax;
            }

            if (dateMin !== undefined) {
                localVarQueryParameter['dateMin'] = dateMin;
            }

            if (categorie !== undefined) {
                localVarQueryParameter['categorie'] = categorie;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Declarer un stock a la date du jour
         * @summary POST /stock
         * @param {Array<Stock>} stock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStock(stock: Array<Stock>, options: any = {}): RequestArgs {
            // verify required parameter 'stock' is not null or undefined
            if (stock === null || stock === undefined) {
                throw new RequiredError('stock', 'Required parameter stock was null or undefined when calling postStock.');
            }
            const localVarPath = `/stock`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof stock !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(stock !== undefined ? stock : {}) : stock || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reedition de pochoir d\'un vehicule du stock
         * @summary POST /stock/pochoir
         * @param {StockPochoir} stockPochoir
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStockPochoir(stockPochoir: StockPochoir, options: any = {}): RequestArgs {
            // verify required parameter 'stockPochoir' is not null or undefined
            if (stockPochoir === null || stockPochoir === undefined) {
                throw new RequiredError(
                    'stockPochoir',
                    'Required parameter stockPochoir was null or undefined when calling postStockPochoir.',
                );
            }
            const localVarPath = `/stock/pochoir`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof stockPochoir !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(stockPochoir !== undefined ? stockPochoir : {})
                : stockPochoir || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * StockApi - functional programming interface
 * @export
 */
export const StockApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Retourner liste des volets A pour le groupe de l\'utilisateur
         * @summary GET /stock
         * @param {number} [grandClientId] Id du grand client de l\&#39;utilisateur
         * @param {number} [taille] le nombre d\&#39;elements a retourner
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc \\n Nom de l\&#39;attribut egal au nom du champ envoye
         * @param {string} [numeroSerie] filtrer la liste des stocks pour afficher que les stocks dont le n° de série court se termine par la combinaison saisie
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin.
         * @param {string} [categorie] Categorie vehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStock(
            grandClientId?: number,
            taille?: number,
            page?: number,
            tri?: Array<string>,
            numeroSerie?: string,
            dateMax?: string,
            dateMin?: string,
            categorie?: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListePageStockRecherche> {
            const localVarAxiosArgs = StockApiAxiosParamCreator(configuration).getStock(
                grandClientId,
                taille,
                page,
                tri,
                numeroSerie,
                dateMax,
                dateMin,
                categorie,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Declarer un stock a la date du jour
         * @summary POST /stock
         * @param {Array<Stock>} stock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStock(
            stock: Array<Stock>,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Stock>> {
            const localVarAxiosArgs = StockApiAxiosParamCreator(configuration).postStock(stock, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Reedition de pochoir d\'un vehicule du stock
         * @summary POST /stock/pochoir
         * @param {StockPochoir} stockPochoir
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStockPochoir(
            stockPochoir: StockPochoir,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockPochoir> {
            const localVarAxiosArgs = StockApiAxiosParamCreator(configuration).postStockPochoir(stockPochoir, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * StockApi - factory interface
 * @export
 */
export const StockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Retourner liste des volets A pour le groupe de l\'utilisateur
         * @summary GET /stock
         * @param {number} [grandClientId] Id du grand client de l\&#39;utilisateur
         * @param {number} [taille] le nombre d\&#39;elements a retourner
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc \\n Nom de l\&#39;attribut egal au nom du champ envoye
         * @param {string} [numeroSerie] filtrer la liste des stocks pour afficher que les stocks dont le n° de série court se termine par la combinaison saisie
         * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax
         * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin.
         * @param {string} [categorie] Categorie vehicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStock(
            grandClientId?: number,
            taille?: number,
            page?: number,
            tri?: Array<string>,
            numeroSerie?: string,
            dateMax?: string,
            dateMin?: string,
            categorie?: string,
            options?: any,
        ) {
            return StockApiFp(configuration).getStock(
                grandClientId,
                taille,
                page,
                tri,
                numeroSerie,
                dateMax,
                dateMin,
                categorie,
                options,
            )(axios, basePath);
        },
        /**
         * Declarer un stock a la date du jour
         * @summary POST /stock
         * @param {Array<Stock>} stock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStock(stock: Array<Stock>, options?: any) {
            return StockApiFp(configuration).postStock(stock, options)(axios, basePath);
        },
        /**
         * Reedition de pochoir d\'un vehicule du stock
         * @summary POST /stock/pochoir
         * @param {StockPochoir} stockPochoir
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStockPochoir(stockPochoir: StockPochoir, options?: any) {
            return StockApiFp(configuration).postStockPochoir(stockPochoir, options)(axios, basePath);
        },
    };
};

/**
 * StockApi - object-oriented interface
 * @export
 * @class StockApi
 * @extends {BaseAPI}
 */
export class StockApi extends BaseAPI {

    /**
     * Retourner liste des volets A pour le groupe de l\'utilisateur
     * @summary GET /stock
     * @param {number} [grandClientId] Id du grand client de l\&#39;utilisateur
     * @param {number} [taille] le nombre d\&#39;elements a retourner
     * @param {number} [page] L\&#39;index de la page (l\&#39;index de la premiere page est 0)
     * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc \\n Nom de l\&#39;attribut egal au nom du champ envoye
     * @param {string} [numeroSerie] filtrer la liste des stocks pour afficher que les stocks dont le n° de série court se termine par la combinaison saisie
     * @param {string} [dateMax] Permet de filtrer les particuliers ayant une adhesion mofifiee avant dateMax
     * @param {string} [dateMin] Permet de filtrer les particuliers ayant une adhesion mofifiee apres dateMin.
     * @param {string} [categorie] Categorie vehicule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public getStock(
        grandClientId?: number,
        taille?: number,
        page?: number,
        tri?: Array<string>,
        numeroSerie?: string,
        dateMax?: string,
        dateMin?: string,
        categorie?: string,
        options?: any,
    ) {
        return StockApiFp(this.configuration).getStock(
            grandClientId,
            taille,
            page,
            tri,
            numeroSerie,
            dateMax,
            dateMin,
            categorie,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Declarer un stock a la date du jour
     * @summary POST /stock
     * @param {Array<Stock>} stock
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public postStock(stock: Array<Stock>, options?: any) {
        return StockApiFp(this.configuration).postStock(stock, options)(this.axios, this.basePath);
    }

    /**
     * Reedition de pochoir d\'un vehicule du stock
     * @summary POST /stock/pochoir
     * @param {StockPochoir} stockPochoir
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public postStockPochoir(stockPochoir: StockPochoir, options?: any) {
        return StockApiFp(this.configuration).postStockPochoir(stockPochoir, options)(this.axios, this.basePath);
    }
}

/**
 * TitreApi - axios parameter creator
 * @export
 */
export const TitreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des titres de personne
         * @summary GET /referentiel/titre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielTitre(options: any = {}): RequestArgs {
            const localVarPath = `/referentiel/titre`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * TitreApi - functional programming interface
 * @export
 */
export const TitreApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des titres de personne
         * @summary GET /referentiel/titre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielTitre(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>> {
            const localVarAxiosArgs = TitreApiAxiosParamCreator(configuration).getReferentielTitre(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * TitreApi - factory interface
 * @export
 */
export const TitreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Obtenir la liste des titres de personne
         * @summary GET /referentiel/titre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielTitre(options?: any) {
            return TitreApiFp(configuration).getReferentielTitre(options)(axios, basePath);
        },
    };
};

/**
 * TitreApi - object-oriented interface
 * @export
 * @class TitreApi
 * @extends {BaseAPI}
 */
export class TitreApi extends BaseAPI {
    /**
     * Obtenir la liste des titres de personne
     * @summary GET /referentiel/titre
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitreApi
     */
    public getReferentielTitre(options?: any) {
        return TitreApiFp(this.configuration).getReferentielTitre(options)(this.axios, this.basePath);
    }
}

/**
 * UtilisateurApi - axios parameter creator
 * @export
 */
export const UtilisateurApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Permet d\'obentir les informations concenant un utilisateur
         * @summary GET /utilisateur/{login}
         * @param {string} login Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateurByLogin(login: string, options: any = {}): RequestArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError(
                    'login',
                    'Required parameter login was null or undefined when calling getUtilisateurByLogin.',
                );
            }
            const localVarPath = `/utilisateur/{login}`.replace(`{${'login'}}`, encodeURIComponent(String(login)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet d\'obtenir le liste des utilisateurs d\'un client ayant le droit de le modifier. Tri par ordre alphabetique avec en premier les utilisateurs attache au client en parametre puis par ordre alphabétique NOM PRENOM
         * @summary GET /utilisateur/client/{clientId}/reseau
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateurReseauByClientId(clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getUtilisateurReseauByClientId.',
                );
            }
            const localVarPath = `/utilisateur/client/{clientId}/reseau`.replace(
                `{${'clientId'}}`,
                encodeURIComponent(String(clientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet d\'obtenir le liste des utilisateurs d\'en client. Tri par ordre alphabetique du prenom puis du nom.
         * @summary GET /utilisateur/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {string} [fonction] Fonction de l\&#39;utilisateur pour un client Valeur supporte: VENDEUR
         * @param {string} [statut] statut &#x3D; actif → Retourne uniquement les utilisateurs dont date de fin &#x3D; NULL OU date du jour &lt; date de fin statut &#x3D; tous → Retourne tous les utilisateurs Par défaut, statut &#x3D; actif
         * @param {string} [relation] rattachement → Retourne les utilisateurs dont le clientId est le clientId en paramètre reseau →  Retourne les utilisateurs dont le clientId en paramètre fait partie de leur réseau (&#x3D;liste des clients autorisés) Par défaut, reseau
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtuilisateurByClientId(
            clientId: number,
            fonction?: string,
            statut?: string,
            relation?: string,
            options: any = {},
        ): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling getUtuilisateurByClientId.',
                );
            }
            const localVarPath = `/utilisateur/client/{clientId}`.replace(
                `{${'clientId'}}`,
                encodeURIComponent(String(clientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fonction !== undefined) {
                localVarQueryParameter['fonction'] = fonction;
            }

            if (statut !== undefined) {
                localVarQueryParameter['statut'] = statut;
            }

            if (relation !== undefined) {
                localVarQueryParameter['relation'] = relation;
            }

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creation d\'un utilisateur
         * @summary POST /utilisateur
         * @param {UtilisateurIn} utilisateurIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUtilisateur(utilisateurIn: UtilisateurIn, options: any = {}): RequestArgs {
            // verify required parameter 'utilisateurIn' is not null or undefined
            if (utilisateurIn === null || utilisateurIn === undefined) {
                throw new RequiredError(
                    'utilisateurIn',
                    'Required parameter utilisateurIn was null or undefined when calling postUtilisateur.',
                );
            }
            const localVarPath = `/utilisateur`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof utilisateurIn !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(utilisateurIn !== undefined ? utilisateurIn : {})
                : utilisateurIn || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de activer une liste d\'utilisateurs
         * @summary PUT /utilisateur/activer
         * @param {Array<string>} requestBody Liste des utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurActiver(requestBody: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError(
                    'requestBody',
                    'Required parameter requestBody was null or undefined when calling putUtilisateurActiver.',
                );
            }
            const localVarPath = `/utilisateur/activer`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof requestBody !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(requestBody !== undefined ? requestBody : {})
                : requestBody || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de modifier les informations d\'un utilisateur
         * @summary PUT utilisateur/{login}
         * @param {string} login Login de l\&#39;utilisateur
         * @param {UtilisateurIn} utilisateurIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurByLogin(login: string, utilisateurIn: UtilisateurIn, options: any = {}): RequestArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError(
                    'login',
                    'Required parameter login was null or undefined when calling putUtilisateurByLogin.',
                );
            }
            // verify required parameter 'utilisateurIn' is not null or undefined
            if (utilisateurIn === null || utilisateurIn === undefined) {
                throw new RequiredError(
                    'utilisateurIn',
                    'Required parameter utilisateurIn was null or undefined when calling putUtilisateurByLogin.',
                );
            }
            const localVarPath = `/utilisateur/{login}`.replace(`{${'login'}}`, encodeURIComponent(String(login)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof utilisateurIn !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(utilisateurIn !== undefined ? utilisateurIn : {})
                : utilisateurIn || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de désactiver une liste d\'utilisateurs
         * @summary PUT /utilisateur/desactiver
         * @param {Array<string>} requestBody Liste des utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurDesactiver(requestBody: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError(
                    'requestBody',
                    'Required parameter requestBody was null or undefined when calling putUtilisateurDesactiver.',
                );
            }
            const localVarPath = `/utilisateur/desactiver`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof requestBody !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(requestBody !== undefined ? requestBody : {})
                : requestBody || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet d\'ajouter une concession a plusieurs utilisateurs
         * @summary PUT /utilisateur/reseau/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurReseauByClientId(clientId: number, requestBody: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError(
                    'clientId',
                    'Required parameter clientId was null or undefined when calling putUtilisateurReseauByClientId.',
                );
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError(
                    'requestBody',
                    'Required parameter requestBody was null or undefined when calling putUtilisateurReseauByClientId.',
                );
            }
            const localVarPath = `/utilisateur/reseau/client/{clientId}`.replace(
                `{${'clientId'}}`,
                encodeURIComponent(String(clientId)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            const needsSerialization =
                typeof requestBody !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(requestBody !== undefined ? requestBody : {})
                : requestBody || '';

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * UtilisateurApi - functional programming interface
 * @export
 */
export const UtilisateurApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Permet d\'obentir les informations concenant un utilisateur
         * @summary GET /utilisateur/{login}
         * @param {string} login Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateurByLogin(
            login: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur> {
            const localVarAxiosArgs = UtilisateurApiAxiosParamCreator(configuration).getUtilisateurByLogin(login, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet d\'obtenir le liste des utilisateurs d\'un client ayant le droit de le modifier. Tri par ordre alphabetique avec en premier les utilisateurs attache au client en parametre puis par ordre alphabétique NOM PRENOM
         * @summary GET /utilisateur/client/{clientId}/reseau
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateurReseauByClientId(
            clientId: number,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UtilisateurRecherche>> {
            const localVarAxiosArgs = UtilisateurApiAxiosParamCreator(configuration).getUtilisateurReseauByClientId(
                clientId,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet d\'obtenir le liste des utilisateurs d\'en client. Tri par ordre alphabetique du prenom puis du nom.
         * @summary GET /utilisateur/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {string} [fonction] Fonction de l\&#39;utilisateur pour un client Valeur supporte: VENDEUR
         * @param {string} [statut] statut &#x3D; actif → Retourne uniquement les utilisateurs dont date de fin &#x3D; NULL OU date du jour &lt; date de fin statut &#x3D; tous → Retourne tous les utilisateurs Par défaut, statut &#x3D; actif
         * @param {string} [relation] rattachement → Retourne les utilisateurs dont le clientId est le clientId en paramètre reseau →  Retourne les utilisateurs dont le clientId en paramètre fait partie de leur réseau (&#x3D;liste des clients autorisés) Par défaut, reseau
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtuilisateurByClientId(
            clientId: number,
            fonction?: string,
            statut?: string,
            relation?: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UtilisateurRecherche>> {
            const localVarAxiosArgs = UtilisateurApiAxiosParamCreator(configuration).getUtuilisateurByClientId(
                clientId,
                fonction,
                statut,
                relation,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Creation d\'un utilisateur
         * @summary POST /utilisateur
         * @param {UtilisateurIn} utilisateurIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUtilisateur(
            utilisateurIn: UtilisateurIn,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur> {
            const localVarAxiosArgs = UtilisateurApiAxiosParamCreator(configuration).postUtilisateur(utilisateurIn, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de activer une liste d\'utilisateurs
         * @summary PUT /utilisateur/activer
         * @param {Array<string>} requestBody Liste des utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurActiver(
            requestBody: Array<string>,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UtilisateurApiAxiosParamCreator(configuration).putUtilisateurActiver(
                requestBody,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de modifier les informations d\'un utilisateur
         * @summary PUT utilisateur/{login}
         * @param {string} login Login de l\&#39;utilisateur
         * @param {UtilisateurIn} utilisateurIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurByLogin(
            login: string,
            utilisateurIn: UtilisateurIn,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur> {
            const localVarAxiosArgs = UtilisateurApiAxiosParamCreator(configuration).putUtilisateurByLogin(
                login,
                utilisateurIn,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet de désactiver une liste d\'utilisateurs
         * @summary PUT /utilisateur/desactiver
         * @param {Array<string>} requestBody Liste des utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurDesactiver(
            requestBody: Array<string>,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UtilisateurApiAxiosParamCreator(configuration).putUtilisateurDesactiver(
                requestBody,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Permet d\'ajouter une concession a plusieurs utilisateurs
         * @summary PUT /utilisateur/reseau/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurReseauByClientId(
            clientId: number,
            requestBody: Array<string>,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UtilisateurApiAxiosParamCreator(configuration).putUtilisateurReseauByClientId(
                clientId,
                requestBody,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * UtilisateurApi - factory interface
 * @export
 */
export const UtilisateurApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
) {
    return {
        /**
         * Permet d\'obentir les informations concenant un utilisateur
         * @summary GET /utilisateur/{login}
         * @param {string} login Login de l\&#39;utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateurByLogin(login: string, options?: any) {
            return UtilisateurApiFp(configuration).getUtilisateurByLogin(login, options)(axios, basePath);
        },
        /**
         * Permet d\'obtenir le liste des utilisateurs d\'un client ayant le droit de le modifier. Tri par ordre alphabetique avec en premier les utilisateurs attache au client en parametre puis par ordre alphabétique NOM PRENOM
         * @summary GET /utilisateur/client/{clientId}/reseau
         * @param {number} clientId Identifiant de la ressource client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateurReseauByClientId(clientId: number, options?: any) {
            return UtilisateurApiFp(configuration).getUtilisateurReseauByClientId(clientId, options)(axios, basePath);
        },
        /**
         * Permet d\'obtenir le liste des utilisateurs d\'en client. Tri par ordre alphabetique du prenom puis du nom.
         * @summary GET /utilisateur/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {string} [fonction] Fonction de l\&#39;utilisateur pour un client Valeur supporte: VENDEUR
         * @param {string} [statut] statut &#x3D; actif → Retourne uniquement les utilisateurs dont date de fin &#x3D; NULL OU date du jour &lt; date de fin statut &#x3D; tous → Retourne tous les utilisateurs Par défaut, statut &#x3D; actif
         * @param {string} [relation] rattachement → Retourne les utilisateurs dont le clientId est le clientId en paramètre reseau →  Retourne les utilisateurs dont le clientId en paramètre fait partie de leur réseau (&#x3D;liste des clients autorisés) Par défaut, reseau
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtuilisateurByClientId(clientId: number, fonction?: string, statut?: string, relation?: string, options?: any) {
            return UtilisateurApiFp(configuration).getUtuilisateurByClientId(
                clientId,
                fonction,
                statut,
                relation,
                options,
            )(axios, basePath);
        },
        /**
         * Creation d\'un utilisateur
         * @summary POST /utilisateur
         * @param {UtilisateurIn} utilisateurIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUtilisateur(utilisateurIn: UtilisateurIn, options?: any) {
            return UtilisateurApiFp(configuration).postUtilisateur(utilisateurIn, options)(axios, basePath);
        },
        /**
         * Permet de activer une liste d\'utilisateurs
         * @summary PUT /utilisateur/activer
         * @param {Array<string>} requestBody Liste des utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurActiver(requestBody: Array<string>, options?: any) {
            return UtilisateurApiFp(configuration).putUtilisateurActiver(requestBody, options)(axios, basePath);
        },
        /**
         * Permet de modifier les informations d\'un utilisateur
         * @summary PUT utilisateur/{login}
         * @param {string} login Login de l\&#39;utilisateur
         * @param {UtilisateurIn} utilisateurIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurByLogin(login: string, utilisateurIn: UtilisateurIn, options?: any) {
            return UtilisateurApiFp(configuration).putUtilisateurByLogin(login, utilisateurIn, options)(axios, basePath);
        },
        /**
         * Permet de désactiver une liste d\'utilisateurs
         * @summary PUT /utilisateur/desactiver
         * @param {Array<string>} requestBody Liste des utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurDesactiver(requestBody: Array<string>, options?: any) {
            return UtilisateurApiFp(configuration).putUtilisateurDesactiver(requestBody, options)(axios, basePath);
        },
        /**
         * Permet d\'ajouter une concession a plusieurs utilisateurs
         * @summary PUT /utilisateur/reseau/client/{clientId}
         * @param {number} clientId Identifiant de la ressource client
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUtilisateurReseauByClientId(clientId: number, requestBody: Array<string>, options?: any) {
            return UtilisateurApiFp(configuration).putUtilisateurReseauByClientId(
                clientId,
                requestBody,
                options,
            )(axios, basePath);
        },
    };
};

/**
 * UtilisateurApi - object-oriented interface
 * @export
 * @class UtilisateurApi
 * @extends {BaseAPI}
 */
export class UtilisateurApi extends BaseAPI {
    /**
     * Permet d\'obentir les informations concenant un utilisateur
     * @summary GET /utilisateur/{login}
     * @param {string} login Login de l\&#39;utilisateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateurApi
     */
    public getUtilisateurByLogin(login: string, options?: any) {
        return UtilisateurApiFp(this.configuration).getUtilisateurByLogin(login, options)(this.axios, this.basePath);
    }

    /**
     * Permet d\'obtenir le liste des utilisateurs d\'un client ayant le droit de le modifier. Tri par ordre alphabetique avec en premier les utilisateurs attache au client en parametre puis par ordre alphabétique NOM PRENOM
     * @summary GET /utilisateur/client/{clientId}/reseau
     * @param {number} clientId Identifiant de la ressource client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateurApi
     */
    public getUtilisateurReseauByClientId(clientId: number, options?: any) {
        return UtilisateurApiFp(this.configuration).getUtilisateurReseauByClientId(clientId, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Permet d\'obtenir le liste des utilisateurs d\'en client. Tri par ordre alphabetique du prenom puis du nom.
     * @summary GET /utilisateur/client/{clientId}
     * @param {number} clientId Identifiant de la ressource client
     * @param {string} [fonction] Fonction de l\&#39;utilisateur pour un client Valeur supporte: VENDEUR
     * @param {string} [statut] statut &#x3D; actif → Retourne uniquement les utilisateurs dont date de fin &#x3D; NULL OU date du jour &lt; date de fin statut &#x3D; tous → Retourne tous les utilisateurs Par défaut, statut &#x3D; actif
     * @param {string} [relation] rattachement → Retourne les utilisateurs dont le clientId est le clientId en paramètre reseau →  Retourne les utilisateurs dont le clientId en paramètre fait partie de leur réseau (&#x3D;liste des clients autorisés) Par défaut, reseau
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateurApi
     */
    public getUtuilisateurByClientId(
        clientId: number,
        fonction?: string,
        statut?: string,
        relation?: string,
        options?: any,
    ) {
        return UtilisateurApiFp(this.configuration).getUtuilisateurByClientId(
            clientId,
            fonction,
            statut,
            relation,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Creation d\'un utilisateur
     * @summary POST /utilisateur
     * @param {UtilisateurIn} utilisateurIn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateurApi
     */
    public postUtilisateur(utilisateurIn: UtilisateurIn, options?: any) {
        return UtilisateurApiFp(this.configuration).postUtilisateur(utilisateurIn, options)(this.axios, this.basePath);
    }

    /**
     * Permet de activer une liste d\'utilisateurs
     * @summary PUT /utilisateur/activer
     * @param {Array<string>} requestBody Liste des utilisateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateurApi
     */
    public putUtilisateurActiver(requestBody: Array<string>, options?: any) {
        return UtilisateurApiFp(this.configuration).putUtilisateurActiver(requestBody, options)(this.axios, this.basePath);
    }

    /**
     * Permet de modifier les informations d\'un utilisateur
     * @summary PUT utilisateur/{login}
     * @param {string} login Login de l\&#39;utilisateur
     * @param {UtilisateurIn} utilisateurIn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateurApi
     */
    public putUtilisateurByLogin(login: string, utilisateurIn: UtilisateurIn, options?: any) {
        return UtilisateurApiFp(this.configuration).putUtilisateurByLogin(
            login,
            utilisateurIn,
            options,
        )(this.axios, this.basePath);
    }

    /**
     * Permet de désactiver une liste d\'utilisateurs
     * @summary PUT /utilisateur/desactiver
     * @param {Array<string>} requestBody Liste des utilisateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateurApi
     */
    public putUtilisateurDesactiver(requestBody: Array<string>, options?: any) {
        return UtilisateurApiFp(this.configuration).putUtilisateurDesactiver(requestBody, options)(
            this.axios,
            this.basePath,
        );
    }

    /**
     * Permet d\'ajouter une concession a plusieurs utilisateurs
     * @summary PUT /utilisateur/reseau/client/{clientId}
     * @param {number} clientId Identifiant de la ressource client
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateurApi
     */
    public putUtilisateurReseauByClientId(clientId: number, requestBody: Array<string>, options?: any) {
        return UtilisateurApiFp(this.configuration).putUtilisateurReseauByClientId(
            clientId,
            requestBody,
            options,
        )(this.axios, this.basePath);
    }
}

/**
 * VilleApi - axios parameter creator
 * @export
 */
export const VilleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Rechercher les villes correspondant a un code postal
         * @summary GET /referentiel/ville/codePostal/{codePostal}
         * @param {string} codePostal code postal de la ville a rechercher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielVilleCodePostalByCodePostal(codePostal: string, options: any = {}): RequestArgs {
            // verify required parameter 'codePostal' is not null or undefined
            if (codePostal === null || codePostal === undefined) {
                throw new RequiredError(
                    'codePostal',
                    'Required parameter codePostal was null or undefined when calling getReferentielVilleCodePostalByCodePostal.',
                );
            }
            const localVarPath = `/referentiel/ville/codePostal/{codePostal}`.replace(
                `{${'codePostal'}}`,
                encodeURIComponent(String(codePostal)),
            );
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * VilleApi - functional programming interface
 * @export
 */
export const VilleApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Rechercher les villes correspondant a un code postal
         * @summary GET /referentiel/ville/codePostal/{codePostal}
         * @param {string} codePostal code postal de la ville a rechercher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielVilleCodePostalByCodePostal(
            codePostal: string,
            options?: any,
        ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ville>> {
            const localVarAxiosArgs = VilleApiAxiosParamCreator(configuration).getReferentielVilleCodePostalByCodePostal(
                codePostal,
                options,
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * VilleApi - factory interface
 * @export
 */
export const VilleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Rechercher les villes correspondant a un code postal
         * @summary GET /referentiel/ville/codePostal/{codePostal}
         * @param {string} codePostal code postal de la ville a rechercher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferentielVilleCodePostalByCodePostal(codePostal: string, options?: any) {
            return VilleApiFp(configuration).getReferentielVilleCodePostalByCodePostal(codePostal, options)(axios, basePath);
        },
    };
};

/**
 * VilleApi - object-oriented interface
 * @export
 * @class VilleApi
 * @extends {BaseAPI}
 */
export class VilleApi extends BaseAPI {
    /**
     * Rechercher les villes correspondant a un code postal
     * @summary GET /referentiel/ville/codePostal/{codePostal}
     * @param {string} codePostal code postal de la ville a rechercher
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VilleApi
     */
    public getReferentielVilleCodePostalByCodePostal(codePostal: string, options?: any) {
        return VilleApiFp(this.configuration).getReferentielVilleCodePostalByCodePostal(codePostal, options)(
            this.axios,
            this.basePath,
        );
    }
}
